var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoDigitalLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 413.33334 100",
    height: 75,
    width: 310,
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath30",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "M 0,75 H 310 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath270",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path268",
    d: "m 7.326,52.006 c 0,-0.191 0.157,-0.345 0.35,-0.345 v 0 c 0.194,0 0.35,0.154 0.35,0.345 v 0 c 0,0.19 -0.156,0.345 -0.35,0.345 v 0 c -0.193,0 -0.35,-0.155 -0.35,-0.345"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath286",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path284",
    d: "M 0,75 H 310 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath414",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path412",
    d: "m 5.279,47.085 c 0.636,-0.171 1.47,-0.254 2.394,-0.255 v 0 c 0.923,0.001 1.761,0.084 2.396,0.255 v 0 c -0.635,0.171 -1.473,0.277 -2.396,0.278 v 0 C 6.749,47.362 5.915,47.256 5.279,47.085"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath466",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path464",
    d: "M 0,75 H 310 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath748",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path746",
    d: "m 4.594,10.463 h 6.165 V 41.887 H 4.594 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath764",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path762",
    d: "M 0,75 H 310 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1050",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1048",
    d: "m 61.851,47.085 c 0.634,-0.171 1.469,-0.254 2.392,-0.255 v 0 c 0.922,0.001 1.762,0.084 2.397,0.255 v 0 c -0.635,0.171 -1.475,0.277 -2.397,0.278 v 0 C 63.32,47.362 62.485,47.256 61.851,47.085"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1102",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1100",
    d: "M 0,75 H 310 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1270",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1268",
    d: "m 63.896,51.646 c 0,-0.19 0.157,-0.344 0.351,-0.344 v 0 c 0.194,0 0.351,0.154 0.351,0.344 v 0 c 0,0.191 -0.157,0.345 -0.351,0.345 v 0 c -0.194,0 -0.351,-0.154 -0.351,-0.345"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1286",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1284",
    d: "M 0,75 H 310 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1424",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1422",
    d: "m 61.188,10.463 h 6.164 v 31.424 h -6.164 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1440",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1438",
    d: "M 0,75 H 310 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1542",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1540",
    d: "m 25.032,48.744 c 2.887,-0.778 6.681,-1.281 10.878,-1.288 v 0 c 4.198,0.007 8.012,0.51 10.898,1.288 v 0 c -2.886,0.778 -6.7,1.253 -10.898,1.26 v 0 c -4.197,-0.007 -7.991,-0.482 -10.878,-1.26"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1650",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1648",
    d: "M 0,75 H 310 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath2034",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2032",
    d: "m 34.204,70.057 c 0,-0.914 0.752,-1.655 1.679,-1.655 v 0 c 0.928,0 1.68,0.741 1.68,1.655 v 0 c 0,0.914 -0.752,1.655 -1.68,1.655 v 0 c -0.927,0 -1.679,-0.741 -1.679,-1.655"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath2050",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2048",
    d: "M 0,75 H 310 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath2066",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2064",
    d: "m 34.187,69.997 c 0,-0.914 0.753,-1.655 1.68,-1.655 v 0 c 0.928,0 1.68,0.741 1.68,1.655 v 0 c 0,0.914 -0.752,1.656 -1.68,1.656 v 0 c -0.927,0 -1.68,-0.742 -1.68,-1.656"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath2082",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2080",
    d: "M 0,75 H 310 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath2110",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2108",
    d: "M 16.943,25.105 V 11.944 c 0,-5.192 4.274,-9.402 9.542,-9.402 v 0 c 5.27,0 9.499,4.21 9.499,9.402 v 0 13.161 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath2128",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2126",
    d: "M 0,75 H 310 V 0 H 0 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,100)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(94.6275,47.593)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 H 1.207 V -8.885 H -0.09 v 6.913 l -2.772,-3.434 h -0.239 l -2.805,3.434 v -6.913 h -1.29 V 0 h 1.222 l 2.996,-3.649 z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 97.79,47.593 h 1.291 V 38.708 H 97.79 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108.2461,47.593)",
    id: "g18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path20",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 1.226 v -8.885 h -1.11 l -6.028,6.843 V -8.885 H -7.125 V 0 H -6.08 L 0,-6.901 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 111.415,47.593 h 1.291 v -8.885 h -1.291 z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g24"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath30)",
    id: "g26"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(116.94,42.4304)",
    id: "g32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path34",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -0.981,0.587 c -0.615,0.371 -1.053,0.735 -1.313,1.093 -0.261,0.359 -0.391,0.771 -0.391,1.237 0,0.7 0.247,1.268 0.739,1.705 0.493,0.437 1.133,0.655 1.92,0.655 0.753,0 1.444,-0.208 2.072,-0.625 V 3.208 C 1.396,3.824 0.697,4.132 -0.052,4.132 -0.473,4.132 -0.82,4.036 -1.091,3.844 -1.362,3.652 -1.497,3.406 -1.497,3.106 c 0,-0.266 0.1,-0.516 0.299,-0.748 0.2,-0.232 0.521,-0.476 0.964,-0.732 L 0.751,1.052 c 1.1,-0.648 1.65,-1.471 1.65,-2.472 0,-0.713 -0.242,-1.291 -0.726,-1.737 -0.484,-0.445 -1.113,-0.667 -1.888,-0.667 -0.891,0 -1.702,0.269 -2.433,0.809 v 1.616 c 0.697,-0.871 1.504,-1.306 2.42,-1.306 0.405,0 0.741,0.111 1.01,0.332 0.269,0.223 0.403,0.5 0.403,0.834 C 1.187,-0.998 0.792,-0.485 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(119.9932,47.6057)",
    id: "g36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path38",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 H 7.532 V -1.132 H 4.389 V -8.898 H 3.091 v 7.766 l -3.091,0 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128.7451,47.593)",
    id: "g40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path42",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 H 5.112 V -1.132 H 1.291 v -2.71 H 4.982 V -4.98 H 1.291 V -7.74 H 5.234 V -8.873 H 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(137.0713,46.5114)",
    id: "g44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path46",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -0.387 v -2.805 h 0.49 c 0.654,0 1.103,0.055 1.346,0.166 0.243,0.11 0.432,0.276 0.568,0.499 0.135,0.223 0.203,0.476 0.203,0.76 0,0.28 -0.075,0.533 -0.226,0.76 -0.15,0.227 -0.362,0.387 -0.636,0.48 C 1.085,-0.046 0.632,0 0,0 m -1.678,-7.804 v 8.886 h 2.259 c 0.912,0 1.636,-0.223 2.171,-0.668 0.536,-0.446 0.804,-1.048 0.804,-1.807 0,-0.517 -0.131,-0.964 -0.393,-1.342 C 2.9,-3.112 2.523,-3.394 2.033,-3.581 2.321,-3.767 2.603,-4.021 2.878,-4.344 3.154,-4.666 3.541,-5.228 4.04,-6.029 4.354,-6.534 4.606,-6.913 4.795,-7.167 L 5.273,-7.804 H 3.737 L 3.344,-7.218 C 3.331,-7.197 3.305,-7.161 3.266,-7.11 l -0.251,0.35 -0.4,0.649 -0.431,0.694 C 1.917,-5.053 1.673,-4.762 1.451,-4.546 1.229,-4.331 1.029,-4.175 0.85,-4.08 0.671,-3.984 0.371,-3.937 -0.051,-3.937 h -0.336 v -3.867 z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 143.351,47.593 h 1.291 v -8.885 h -1.291 z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(151.1192,46.5114)",
    id: "g50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path52",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -1.032,0 -1.88,-0.318 -2.544,-0.954 -0.664,-0.636 -0.997,-1.448 -0.997,-2.436 0,-0.958 0.333,-1.755 1,-2.391 0.666,-0.636 1.5,-0.954 2.502,-0.954 1.006,0 1.845,0.324 2.518,0.973 0.673,0.649 1.009,1.456 1.009,2.423 0,0.942 -0.336,1.733 -1.009,2.376 C 1.806,-0.321 0.98,0 0,0 m -0.052,1.208 c 1.393,0 2.553,-0.434 3.48,-1.303 0.926,-0.869 1.39,-1.959 1.39,-3.269 0,-1.31 -0.468,-2.395 -1.403,-3.254 -0.936,-0.858 -2.115,-1.287 -3.538,-1.287 -1.358,0 -2.491,0.429 -3.396,1.287 -0.905,0.859 -1.357,1.935 -1.357,3.228 0,1.327 0.455,2.426 1.367,3.295 0.911,0.869 2.064,1.303 3.457,1.303"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90.0191,32.4772)",
    id: "g54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path56",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -1.336 v -2.779 h 1.414 c 0.525,0 0.929,0.122 1.213,0.365 0.284,0.244 0.426,0.593 0.426,1.047 C 1.717,-0.456 1.145,0 0,0 m -2.633,-7.766 v 8.898 h 2.859 c 0.86,0 1.547,-0.229 2.059,-0.687 0.512,-0.458 0.768,-1.072 0.768,-1.844 0,-0.518 -0.131,-0.976 -0.394,-1.374 C 2.397,-3.171 2.038,-3.461 1.582,-3.641 1.125,-3.821 0.471,-3.912 -0.381,-3.912 h -0.955 v -3.854 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(98.0718,28.4767)",
    id: "g58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path60",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 -1.455,3.218 -2.804,0 Z m -1.896,5.171 h 0.907 L 3.053,-3.765 H 1.732 L 0.531,-1.132 H -3.316 L -4.443,-3.765 H -5.77 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(103.8296,32.5153)",
    id: "g62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path64",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -0.387 v -2.805 h 0.49 c 0.654,0 1.103,0.055 1.346,0.166 0.243,0.11 0.432,0.276 0.568,0.499 0.135,0.223 0.203,0.476 0.203,0.76 0,0.28 -0.075,0.533 -0.226,0.76 -0.15,0.227 -0.362,0.387 -0.636,0.48 C 1.085,-0.046 0.632,0 0,0 m -1.678,-7.804 v 8.886 h 2.259 c 0.912,0 1.636,-0.223 2.171,-0.668 0.536,-0.446 0.804,-1.048 0.804,-1.807 0,-0.517 -0.131,-0.964 -0.393,-1.342 C 2.9,-3.112 2.523,-3.394 2.033,-3.581 2.321,-3.767 2.603,-4.021 2.878,-4.344 3.154,-4.666 3.541,-5.228 4.04,-6.029 4.354,-6.534 4.606,-6.913 4.795,-7.167 L 5.273,-7.804 H 3.737 L 3.344,-7.218 C 3.331,-7.197 3.305,-7.161 3.266,-7.11 l -0.251,0.35 -0.4,0.649 -0.431,0.694 C 1.917,-5.053 1.673,-4.762 1.451,-4.546 1.229,-4.331 1.029,-4.175 0.85,-4.08 0.671,-3.984 0.371,-3.937 -0.051,-3.937 h -0.336 v -3.867 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(114.8721,28.4767)",
    id: "g66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path68",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 -1.455,3.218 -2.804,0 Z m -1.896,5.171 h 0.907 L 3.053,-3.765 H 1.732 L 0.531,-1.132 H -3.316 L -4.443,-3.765 H -5.77 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(122.5855,33.5969)",
    id: "g70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path72",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 1.291 v -7.728 h 4.06 V -8.885 H 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(133.8409,28.4767)",
    id: "g74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path76",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 -1.455,3.218 -2.804,0 Z m -1.896,5.171 h 0.907 L 3.053,-3.765 H 1.732 L 0.531,-1.132 H -3.316 L -4.443,-3.765 H -5.77 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(139.3721,33.6096)",
    id: "g78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path80",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 H 7.532 V -1.132 H 4.389 V -8.898 H 3.091 v 7.766 l -3.091,0 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(149.8409,32.5153)",
    id: "g82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path84",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -0.387 v -2.805 h 0.49 c 0.654,0 1.103,0.055 1.346,0.166 0.243,0.11 0.432,0.276 0.568,0.499 0.135,0.223 0.203,0.476 0.203,0.76 0,0.28 -0.075,0.533 -0.226,0.76 -0.15,0.227 -0.362,0.387 -0.636,0.48 C 1.085,-0.046 0.632,0 0,0 m -1.678,-7.804 v 8.886 h 2.259 c 0.912,0 1.636,-0.223 2.171,-0.668 0.536,-0.446 0.804,-1.048 0.804,-1.807 0,-0.517 -0.131,-0.964 -0.393,-1.342 C 2.9,-3.112 2.523,-3.394 2.033,-3.581 2.321,-3.767 2.603,-4.021 2.878,-4.344 3.154,-4.666 3.541,-5.228 4.04,-6.029 4.354,-6.534 4.606,-6.913 4.795,-7.167 L 5.273,-7.804 H 3.737 L 3.344,-7.218 C 3.331,-7.197 3.305,-7.161 3.266,-7.11 l -0.251,0.35 -0.4,0.649 -0.431,0.694 C 1.917,-5.053 1.673,-4.762 1.451,-4.546 1.229,-4.331 1.029,-4.175 0.85,-4.08 0.671,-3.984 0.371,-3.937 -0.051,-3.937 h -0.336 v -3.867 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160.8833,28.4767)",
    id: "g86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path88",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 -1.455,3.218 -2.804,0 Z m -1.896,5.171 h 0.907 L 3.053,-3.765 H 1.732 L 0.531,-1.132 H -3.316 L -4.443,-3.765 H -5.77 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(172.0884,33.5969)",
    id: "g90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path92",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 1.226 v -8.885 h -1.11 l -6.028,6.843 V -8.885 H -7.125 V 0 H -6.08 L 0,-6.901 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(177.4776,28.4343)",
    id: "g94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path96",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -0.981,0.587 c -0.615,0.371 -1.053,0.735 -1.313,1.093 -0.261,0.359 -0.391,0.771 -0.391,1.237 0,0.7 0.247,1.268 0.739,1.705 0.493,0.437 1.133,0.655 1.92,0.655 0.753,0 1.444,-0.208 2.072,-0.625 V 3.208 C 1.396,3.824 0.697,4.132 -0.052,4.132 -0.473,4.132 -0.82,4.036 -1.091,3.844 -1.362,3.652 -1.497,3.406 -1.497,3.106 c 0,-0.266 0.1,-0.516 0.299,-0.748 0.2,-0.232 0.521,-0.476 0.964,-0.732 L 0.751,1.052 c 1.1,-0.648 1.65,-1.471 1.65,-2.472 0,-0.713 -0.242,-1.291 -0.726,-1.737 -0.484,-0.445 -1.113,-0.667 -1.888,-0.667 -0.891,0 -1.702,0.269 -2.433,0.809 v 1.616 c 0.697,-0.871 1.504,-1.306 2.42,-1.306 0.405,0 0.741,0.111 1.01,0.332 0.269,0.223 0.403,0.5 0.403,0.834 C 1.187,-0.998 0.792,-0.485 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(181.3116,33.5969)",
    id: "g98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path100",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 H 4.809 V -1.132 H 1.291 V -3.613 H 4.809 V -4.745 H 1.291 v -4.14 l -1.291,0 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(191.9776,32.5153)",
    id: "g102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path104",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -1.032,0 -1.88,-0.318 -2.544,-0.954 -0.664,-0.636 -0.997,-1.448 -0.997,-2.436 0,-0.958 0.333,-1.755 1,-2.391 0.666,-0.636 1.5,-0.954 2.502,-0.954 1.006,0 1.845,0.324 2.518,0.973 0.673,0.649 1.009,1.456 1.009,2.423 0,0.942 -0.336,1.733 -1.009,2.376 C 1.806,-0.321 0.98,0 0,0 m -0.052,1.208 c 1.393,0 2.553,-0.434 3.48,-1.303 0.926,-0.869 1.39,-1.959 1.39,-3.269 0,-1.31 -0.468,-2.395 -1.403,-3.254 -0.936,-0.858 -2.115,-1.287 -3.538,-1.287 -1.358,0 -2.491,0.429 -3.396,1.287 -0.905,0.859 -1.357,1.935 -1.357,3.228 0,1.327 0.455,2.426 1.367,3.295 0.911,0.869 2.064,1.303 3.457,1.303"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200.1001,32.5153)",
    id: "g106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path108",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -0.387 v -2.805 h 0.49 c 0.654,0 1.103,0.055 1.346,0.166 0.243,0.11 0.432,0.276 0.568,0.499 0.135,0.223 0.203,0.476 0.203,0.76 0,0.28 -0.075,0.533 -0.226,0.76 -0.15,0.227 -0.362,0.387 -0.636,0.48 C 1.085,-0.046 0.632,0 0,0 m -1.678,-7.804 v 8.886 h 2.259 c 0.912,0 1.636,-0.223 2.171,-0.668 0.536,-0.446 0.804,-1.048 0.804,-1.807 0,-0.517 -0.131,-0.964 -0.393,-1.342 C 2.9,-3.112 2.523,-3.394 2.033,-3.581 2.321,-3.767 2.603,-4.021 2.878,-4.344 3.154,-4.666 3.541,-5.228 4.04,-6.029 4.354,-6.534 4.606,-6.913 4.795,-7.167 L 5.273,-7.804 H 3.737 L 3.344,-7.218 C 3.331,-7.197 3.305,-7.161 3.266,-7.11 l -0.251,0.35 -0.4,0.649 -0.431,0.694 C 1.917,-5.053 1.673,-4.762 1.451,-4.546 1.229,-4.331 1.029,-4.175 0.85,-4.08 0.671,-3.984 0.371,-3.937 -0.051,-3.937 h -0.336 v -3.867 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(213.5376,33.5969)",
    id: "g110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path112",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 H 1.207 V -8.885 H -0.09 v 6.913 l -2.772,-3.434 h -0.239 l -2.805,3.434 v -6.913 h -1.29 V 0 h 1.222 l 2.996,-3.649 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.4629,28.4767)",
    id: "g114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path116",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 -1.455,3.218 -2.804,0 Z m -1.896,5.171 h 0.907 L 3.053,-3.765 H 1.732 L 0.531,-1.132 H -3.316 L -4.443,-3.765 H -5.77 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(232.812,26.7722)",
    id: "g118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path120",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 v -1.399 c -0.947,-0.509 -2.04,-0.763 -3.279,-0.763 -1.007,0 -1.861,0.199 -2.562,0.598 -0.702,0.398 -1.257,0.947 -1.665,1.647 -0.41,0.699 -0.614,1.456 -0.614,2.271 0,1.292 0.468,2.38 1.404,3.262 0.936,0.882 2.09,1.323 3.463,1.323 0.946,0 1.999,-0.244 3.156,-0.731 V 4.84 C -1.151,5.434 -2.182,5.73 -3.188,5.73 -4.221,5.73 -5.079,5.41 -5.761,4.767 -6.443,4.125 -6.784,3.32 -6.784,2.354 c 0,-0.976 0.336,-1.777 1.007,-2.405 0.672,-0.627 1.53,-0.941 2.575,-0.941 1.093,0 2.16,0.331 3.202,0.992"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path122",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 234.413,33.597 h 1.291 v -8.885 h -1.291 z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(243.4488,36.1599)",
    id: "g124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path126",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 -1.458,-1.908 H -2.182 L -1.31,0 Z m -1.268,-3.645 c -1.032,0 -1.88,-0.317 -2.544,-0.953 -0.665,-0.636 -0.997,-1.448 -0.997,-2.436 0,-0.959 0.333,-1.756 1,-2.392 0.666,-0.636 1.5,-0.954 2.502,-0.954 1.006,0 1.845,0.325 2.518,0.973 0.673,0.649 1.009,1.457 1.009,2.424 0,0.941 -0.336,1.733 -1.009,2.375 -0.673,0.643 -1.499,0.963 -2.479,0.963 m -0.052,1.209 c 1.393,0 2.553,-0.435 3.48,-1.304 0.926,-0.869 1.39,-1.959 1.39,-3.269 0,-1.31 -0.468,-2.394 -1.403,-3.253 -0.936,-0.859 -2.115,-1.288 -3.538,-1.288 -1.359,0 -2.491,0.429 -3.396,1.288 -0.905,0.859 -1.358,1.934 -1.358,3.228 0,1.327 0.456,2.425 1.368,3.294 0.911,0.869 2.064,1.304 3.457,1.304"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(255.7505,33.5969)",
    id: "g128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path130",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 1.226 v -8.885 h -1.11 l -6.028,6.843 V -8.885 H -7.125 V 0 H -6.08 L 0,-6.901 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(265.4961,32.4645)",
    id: "g132"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path134",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -1.613 v -6.608 h 1.652 c 0.645,0 1.147,0.044 1.504,0.13 0.357,0.087 0.655,0.197 0.894,0.331 0.238,0.133 0.457,0.298 0.655,0.493 0.637,0.636 0.955,1.439 0.955,2.41 0,0.954 -0.327,1.732 -0.981,2.335 C 2.825,-0.685 2.548,-0.5 2.236,-0.356 1.924,-0.212 1.629,-0.117 1.349,-0.07 1.069,-0.023 0.62,0 0,0 m -2.904,-7.74 v 8.872 h 3.04 c 1.226,0 2.196,-0.181 2.91,-0.544 C 3.761,0.226 4.329,-0.308 4.75,-1.011 5.172,-1.715 5.383,-2.482 5.383,-3.313 5.383,-3.907 5.267,-4.476 5.035,-5.018 4.802,-5.561 4.471,-6.038 4.041,-6.449 3.602,-6.873 3.092,-7.193 2.511,-7.41 2.171,-7.541 1.859,-7.629 1.575,-7.673 1.291,-7.718 0.749,-7.74 -0.051,-7.74 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path136",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 272.505,33.597 h 1.291 v -8.885 h -1.291 z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280.67,29.0876)",
    id: "g138"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path140",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 3.027 v -3.766 c -1.11,-0.474 -2.212,-0.712 -3.304,-0.712 -1.494,0 -2.686,0.43 -3.579,1.288 -0.893,0.859 -1.339,1.918 -1.339,3.177 0,1.327 0.462,2.432 1.387,3.314 0.925,0.882 2.085,1.323 3.479,1.323 0.508,0 0.99,-0.055 1.446,-0.163 C 1.573,4.354 2.149,4.155 2.847,3.867 V 2.569 C 1.771,3.184 0.704,3.492 -0.355,3.492 -1.34,3.492 -2.17,3.161 -2.846,2.5 -3.521,1.838 -3.859,1.026 -3.859,0.063 c 0,-1.009 0.338,-1.834 1.013,-2.474 0.676,-0.64 1.545,-0.96 2.607,-0.96 0.517,0 1.134,0.117 1.853,0.35 l 0.122,0.038 v 1.851 l -1.736,0 z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path142",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 285.595,33.597 h 1.291 v -8.885 h -1.291 z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288.1187,33.6096)",
    id: "g144"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path146",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 H 7.532 V -1.132 H 4.389 V -8.898 H 3.091 v 7.766 l -3.091,0 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(300.5093,28.4767)",
    id: "g148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path150",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 -1.455,3.218 -2.804,0 Z m -1.896,5.171 h 0.907 L 3.053,-3.765 H 1.732 L 0.531,-1.132 H -3.316 L -4.443,-3.765 H -5.77 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(304.5503,33.5969)",
    id: "g152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path154",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 1.291 v -7.728 h 4.06 V -8.885 H 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(92.8799,19.6008)",
    id: "g156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path158",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 1.567 l -3.331,-4.185 v -4.7 h -1.322 v 4.7 L -6.417,0 h 1.558 l 2.413,-3.063 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.0303,18.4684)",
    id: "g160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path162",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -1.613 v -6.608 h 1.652 c 0.645,0 1.147,0.044 1.504,0.13 0.357,0.087 0.655,0.197 0.894,0.331 0.238,0.133 0.457,0.298 0.655,0.493 0.637,0.636 0.955,1.439 0.955,2.41 0,0.954 -0.327,1.732 -0.981,2.335 C 2.825,-0.685 2.548,-0.5 2.236,-0.356 1.924,-0.212 1.629,-0.117 1.349,-0.07 1.069,-0.023 0.62,0 0,0 m -2.904,-7.74 v 8.872 h 3.04 c 1.226,0 2.196,-0.181 2.91,-0.544 C 3.761,0.226 4.329,-0.308 4.75,-1.011 5.172,-1.715 5.383,-2.482 5.383,-3.313 5.383,-3.907 5.267,-4.476 5.035,-5.018 4.802,-5.561 4.471,-6.038 4.041,-6.449 3.602,-6.873 3.092,-7.193 2.511,-7.41 2.171,-7.541 1.859,-7.629 1.575,-7.673 1.291,-7.718 0.749,-7.74 -0.051,-7.74 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(109.0269,19.6008)",
    id: "g164"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path166",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 H 5.112 V -1.132 H 1.291 v -2.71 H 4.982 V -4.98 H 1.291 V -7.74 H 5.234 V -8.873 H 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(119.3086,19.6008)",
    id: "g168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path170",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 1.291 v -7.728 h 4.06 V -8.885 H 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(130.564,14.4807)",
    id: "g172"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path174",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 -1.455,3.218 -2.804,0 Z m -1.896,5.171 h 0.907 L 3.053,-3.765 H 1.732 L 0.531,-1.132 H -3.316 L -4.443,-3.765 H -5.77 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(138.2901,19.6008)",
    id: "g176"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path178",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 H 4.809 V -1.132 H 1.291 V -3.613 H 4.809 V -4.745 H 1.291 v -4.14 l -1.291,0 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(150.7534,19.6008)",
    id: "g180"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path182",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 1.297 v -5.044 c 0,-0.683 -0.05,-1.198 -0.151,-1.545 -0.102,-0.348 -0.227,-0.638 -0.375,-0.869 -0.148,-0.23 -0.33,-0.437 -0.545,-0.62 -0.714,-0.606 -1.648,-0.909 -2.801,-0.909 -1.175,0 -2.117,0.301 -2.827,0.903 -0.216,0.187 -0.397,0.396 -0.546,0.626 -0.148,0.231 -0.271,0.515 -0.367,0.85 -0.098,0.335 -0.146,0.86 -0.146,1.577 V 0 h 1.297 v -5.044 c 0,-0.835 0.097,-1.416 0.291,-1.743 0.194,-0.326 0.488,-0.588 0.884,-0.785 0.396,-0.197 0.863,-0.296 1.401,-0.296 0.766,0 1.39,0.198 1.872,0.592 0.253,0.212 0.436,0.462 0.548,0.75 C -0.056,-6.237 0,-5.743 0,-5.044 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(161.003,19.6008)",
    id: "g184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path186",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 1.226 v -8.885 h -1.11 l -6.028,6.843 V -8.885 H -7.125 V 0 H -6.08 L 0,-6.901 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(171.9302,12.7761)",
    id: "g188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path190",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 v -1.399 c -0.947,-0.509 -2.04,-0.763 -3.279,-0.763 -1.007,0 -1.861,0.199 -2.562,0.598 -0.702,0.398 -1.257,0.947 -1.665,1.647 -0.41,0.699 -0.614,1.456 -0.614,2.271 0,1.292 0.468,2.38 1.404,3.262 0.936,0.882 2.09,1.323 3.463,1.323 0.946,0 1.999,-0.244 3.156,-0.731 V 4.84 C -1.151,5.434 -2.182,5.73 -3.188,5.73 -4.221,5.73 -5.079,5.41 -5.761,4.767 -6.443,4.125 -6.784,3.32 -6.784,2.354 c 0,-0.976 0.336,-1.777 1.007,-2.405 0.672,-0.627 1.53,-0.941 2.575,-0.941 1.093,0 2.16,0.331 3.202,0.992"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path192",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 173.531,19.601 h 1.291 v -8.885 h -1.291 z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(182.5669,22.1638)",
    id: "g194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path196",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 -1.458,-1.908 H -2.182 L -1.31,0 Z m -1.268,-3.645 c -1.032,0 -1.88,-0.317 -2.544,-0.953 -0.665,-0.636 -0.997,-1.448 -0.997,-2.436 0,-0.959 0.333,-1.756 1,-2.392 0.666,-0.636 1.5,-0.954 2.502,-0.954 1.006,0 1.845,0.325 2.518,0.973 0.673,0.649 1.009,1.457 1.009,2.424 0,0.941 -0.336,1.733 -1.009,2.375 -0.673,0.643 -1.499,0.963 -2.479,0.963 m -0.052,1.209 c 1.393,0 2.553,-0.435 3.48,-1.304 0.926,-0.869 1.39,-1.959 1.39,-3.269 0,-1.31 -0.468,-2.394 -1.403,-3.253 -0.936,-0.859 -2.115,-1.288 -3.538,-1.288 -1.359,0 -2.491,0.429 -3.396,1.288 -0.905,0.859 -1.358,1.934 -1.358,3.228 0,1.327 0.456,2.425 1.368,3.294 0.911,0.869 2.064,1.304 3.457,1.304"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.8687,19.6008)",
    id: "g198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path200",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 1.226 v -8.885 h -1.11 l -6.028,6.843 V -8.885 H -7.125 V 0 H -6.08 L 0,-6.901 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(204.2593,18.4811)",
    id: "g202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path204",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -1.336 v -2.779 h 1.414 c 0.525,0 0.929,0.122 1.213,0.365 0.284,0.244 0.426,0.593 0.426,1.047 C 1.717,-0.456 1.145,0 0,0 m -2.633,-7.766 v 8.898 h 2.859 c 0.86,0 1.547,-0.229 2.059,-0.687 0.512,-0.458 0.768,-1.072 0.768,-1.844 0,-0.518 -0.131,-0.976 -0.394,-1.374 C 2.397,-3.171 2.038,-3.461 1.582,-3.641 1.125,-3.821 0.471,-3.912 -0.381,-3.912 h -0.955 v -3.854 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(213.6568,22.1638)",
    id: "g206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path208",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 -1.458,-1.908 H -2.182 L -1.31,0 Z M 1.052,-2.563 H 2.35 V -7.607 C 2.35,-8.29 2.299,-8.805 2.198,-9.152 2.097,-9.5 1.972,-9.79 1.823,-10.021 c -0.148,-0.23 -0.33,-0.437 -0.545,-0.62 -0.714,-0.606 -1.648,-0.909 -2.801,-0.909 -1.175,0 -2.117,0.301 -2.827,0.903 -0.215,0.187 -0.397,0.396 -0.546,0.626 -0.148,0.231 -0.271,0.515 -0.367,0.85 -0.097,0.335 -0.146,0.86 -0.146,1.577 v 5.031 h 1.298 v -5.044 c 0,-0.835 0.096,-1.416 0.29,-1.743 0.194,-0.326 0.488,-0.588 0.884,-0.785 0.396,-0.197 0.863,-0.296 1.401,-0.296 0.766,0 1.39,0.198 1.872,0.592 0.253,0.212 0.436,0.462 0.548,0.75 0.112,0.289 0.168,0.783 0.168,1.482 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(220.292,14.6652)",
    id: "g210"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path212",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -1.207 v -2.817 h 1.271 c 0.706,0 1.185,0.053 1.436,0.162 0.252,0.108 0.455,0.276 0.607,0.505 0.153,0.229 0.229,0.475 0.229,0.738 0,0.271 -0.08,0.519 -0.242,0.744 -0.161,0.225 -0.39,0.392 -0.687,0.502 C 1.11,-0.055 0.641,0 0,0 m -0.097,3.803 h -1.11 V 1.132 h 0.858 c 0.689,0 1.179,0.129 1.469,0.388 0.29,0.259 0.436,0.594 0.436,1.005 0,0.852 -0.551,1.278 -1.653,1.278 M 0.555,-3.95 h -3.053 v 8.886 h 2.363 C 0.609,4.936 1.19,4.837 1.607,4.64 2.024,4.442 2.343,4.171 2.563,3.826 2.782,3.48 2.892,3.081 2.892,2.626 2.892,1.753 2.433,1.128 1.517,0.75 2.175,0.627 2.699,0.36 3.088,-0.051 3.478,-0.462 3.672,-0.954 3.672,-1.526 3.672,-1.98 3.554,-2.385 3.317,-2.741 3.081,-3.098 2.733,-3.388 2.275,-3.613 1.817,-3.837 1.244,-3.95 0.555,-3.95"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(225.2364,19.6008)",
    id: "g214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path216",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 1.291 v -7.728 h 4.06 V -8.885 H 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path218",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 231.729,19.601 h 1.291 v -8.885 h -1.291 z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(242.792,12.7761)",
    id: "g220"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path222",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 v -1.399 c -0.947,-0.509 -2.04,-0.763 -3.279,-0.763 -1.007,0 -1.861,0.199 -2.562,0.598 -0.702,0.398 -1.257,0.947 -1.665,1.647 -0.41,0.699 -0.614,1.456 -0.614,2.271 0,1.292 0.468,2.38 1.404,3.262 0.936,0.882 2.09,1.323 3.463,1.323 0.946,0 1.999,-0.244 3.156,-0.731 V 4.84 C -1.151,5.434 -2.182,5.73 -3.188,5.73 -4.221,5.73 -5.079,5.41 -5.761,4.767 -6.443,4.125 -6.784,3.32 -6.784,2.354 c 0,-0.976 0.336,-1.777 1.007,-2.405 0.672,-0.627 1.53,-0.941 2.575,-0.941 1.093,0 2.16,0.331 3.202,0.992"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(249.4331,14.4807)",
    id: "g224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path226",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 -1.455,3.218 -2.804,0 Z m -1.896,5.171 h 0.907 L 3.053,-3.765 H 1.732 L 0.531,-1.132 H -3.316 L -4.443,-3.765 H -5.77 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.7608,48.3762)",
    id: "g228"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path230",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -0.193,0 -0.299,0.063 -0.108,0.064 -0.429,0.38 -0.429,0.38 l -0.258,0.191 -0.236,0.338 c 0,0 -0.278,0.465 -0.15,0.823 0.129,0.36 0.343,0.487 0.536,0.592 0.193,0.106 0.6,0.233 0.6,0.233 0,0 0.323,0.148 0.429,0.169 0.108,0.021 0.494,0.127 0.494,0.127 0,0 0.106,0.063 0.214,0.105 0.107,0.042 0.257,0.042 0.343,0.064 0.086,0.021 0.299,0.094 0.428,0.1 0.2,0.009 0.516,-0.037 0.622,-0.037 0.108,0 0.473,-0.022 0.622,-0.022 0.15,0 0.687,0.043 0.837,0.043 0.15,0 0.257,0.021 0.429,0 C 4.354,3.148 4.653,3.042 4.739,3 4.825,2.958 5.339,2.768 5.532,2.705 5.725,2.641 6.197,2.557 6.412,2.451 6.626,2.345 6.756,2.167 6.863,2.019 6.97,1.871 6.991,1.711 7.033,1.606 7.076,1.5 7.078,1.271 7.035,1.166 6.993,1.06 6.84,0.845 6.84,0.845 L 6.604,0.443 6.304,0.19 C 6.304,0.19 6.089,-0.021 5.918,0 5.747,0.021 4.01,0.338 2.895,0.338 1.78,0.338 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.7608,48.3762)",
    id: "g232"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path234",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -0.193,0 -0.299,0.063 -0.108,0.064 -0.429,0.38 -0.429,0.38 l -0.258,0.191 -0.236,0.338 c 0,0 -0.278,0.465 -0.15,0.823 0.129,0.36 0.343,0.487 0.536,0.592 0.193,0.106 0.6,0.233 0.6,0.233 0,0 0.323,0.148 0.429,0.169 0.108,0.021 0.494,0.127 0.494,0.127 0,0 0.106,0.063 0.214,0.105 0.107,0.042 0.257,0.042 0.343,0.064 0.086,0.021 0.299,0.094 0.428,0.1 0.2,0.009 0.516,-0.037 0.622,-0.037 0.108,0 0.473,-0.022 0.622,-0.022 0.15,0 0.687,0.043 0.837,0.043 0.15,0 0.257,0.021 0.429,0 C 4.354,3.148 4.653,3.042 4.739,3 4.825,2.958 5.339,2.768 5.532,2.705 5.725,2.641 6.197,2.557 6.412,2.451 6.626,2.345 6.756,2.167 6.863,2.019 6.97,1.871 6.991,1.711 7.033,1.606 7.076,1.5 7.078,1.271 7.035,1.166 6.993,1.06 6.84,0.845 6.84,0.845 L 6.604,0.443 6.304,0.19 C 6.304,0.19 6.089,-0.021 5.918,0 5.747,0.021 4.01,0.338 2.895,0.338 1.78,0.338 0,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.146,50.9655)",
    id: "g236"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path238",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.543 0.234,0.984 0.523,0.984 0.812,0.984 1.045,0.543 1.045,0 1.045,-0.544 0.812,-0.985 0.523,-0.985 0.234,-0.985 0,-0.544 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.146,50.9655)",
    id: "g240"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path242",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.543 0.234,0.984 0.523,0.984 0.812,0.984 1.045,0.543 1.045,0 1.045,-0.544 0.812,-0.985 0.523,-0.985 0.234,-0.985 0,-0.544 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.439,50.9655)",
    id: "g244"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path246",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.5 0.107,0.905 0.241,0.905 0.373,0.905 0.481,0.5 0.481,0 0.481,-0.5 0.373,-0.906 0.241,-0.906 0.107,-0.906 0,-0.5 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.439,50.9655)",
    id: "g248"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path250",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.5 0.107,0.905 0.241,0.905 0.373,0.905 0.481,0.5 0.481,0 0.481,-0.5 0.373,-0.906 0.241,-0.906 0.107,-0.906 0,-0.5 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.3262,52.006)",
    id: "g252"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path254",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.19 0.157,0.345 0.35,0.345 0.543,0.345 0.7,0.19 0.7,0 0.7,-0.191 0.543,-0.345 0.35,-0.345 0.157,-0.345 0,-0.191 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.9234,52.1262)",
    id: "g256"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path258",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 V -0.228 H -0.541 V 0 h 0.176 v 0.518 h -0.233 v 0.228 h 0.233 v 0.227 h 0.232 V 0.746 H 0.1 V 0.518 h -0.233 l 0,-0.518 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.9234,52.1262)",
    id: "g260"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path262",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.111,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -0.228 H -0.541 V 0 h 0.176 v 0.518 h -0.233 v 0.228 h 0.233 v 0.227 h 0.232 V 0.746 H 0.1 V 0.518 h -0.233 l 0,-0.518 z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g264"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath270)",
    id: "g266"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.1646,52.1262)",
    id: "g272"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path274",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 V -0.228 H -0.961 V 0 h 0.355 v 0.518 h -0.233 v 0.228 h 0.233 v 0.227 h 0.232 V 0.746 h 0.232 V 0.518 H -0.374 V 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.1646,52.1262)",
    id: "g276"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path278",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.111,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -0.228 H -0.961 V 0 h 0.355 v 0.518 h -0.233 v 0.228 h 0.233 v 0.227 h 0.232 V 0.746 h 0.232 V 0.518 H -0.374 V 0 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g280"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath286)",
    id: "g282"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.7759,52.3366)",
    id: "g288"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path290",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0.146,-0.042 0.25,-0.174 0.25,-0.331 0,-0.19 -0.157,-0.345 -0.35,-0.345 -0.193,0 -0.35,0.155 -0.35,0.345 0,0.16 0.11,0.294 0.259,0.333"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.6768,48.4391)",
    id: "g292"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path294",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 h -1.821 l -0.044,0.465 -0.086,0.486 -0.09,0.604 c -0.503,0.69 -0.965,1.143 -1.121,1.047 0.038,0.127 0.082,0.224 0.179,0.282 0.445,0.275 1.368,-0.386 2.06,-1.478 0.062,-0.099 0.121,-0.198 0.175,-0.297 H 0 0.759 C 0.812,1.208 0.872,1.307 0.935,1.406 1.625,2.498 2.548,3.159 2.995,2.884 3.09,2.826 3.134,2.729 3.172,2.602 3.016,2.698 2.555,2.245 2.051,1.555 L 1.961,0.951 1.876,0.465 1.833,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.6768,48.4391)",
    id: "g296"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path298",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 h -1.821 l -0.044,0.465 -0.086,0.486 -0.09,0.604 c -0.503,0.69 -0.965,1.143 -1.121,1.047 0.038,0.127 0.082,0.224 0.179,0.282 0.445,0.275 1.368,-0.386 2.06,-1.478 0.062,-0.099 0.121,-0.198 0.175,-0.297 H 0 0.759 C 0.812,1.208 0.872,1.307 0.935,1.406 1.625,2.498 2.548,3.159 2.995,2.884 3.09,2.826 3.134,2.729 3.172,2.602 3.016,2.698 2.555,2.245 2.051,1.555 L 1.961,0.951 1.876,0.465 1.833,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.5962,51.0578)",
    id: "g300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path302",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0.343,0.211 1.143,-0.45 1.793,-1.476"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.7686,51.0578)",
    id: "g304"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path306",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C -0.343,0.211 -1.143,-0.45 -1.793,-1.476"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.9849,47.5837)",
    id: "g308"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path310",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -0.077,0.226 -0.219,0.426 -0.219,0.426 0.738,0.227 1.765,0.368 2.908,0.37 1.143,-0.002 2.178,-0.143 2.916,-0.37 0,0 -0.082,-0.151 -0.197,-0.361 C 5.344,-0.051 5.26,-0.256 5.267,-0.256 4.599,-0.042 3.74,0.068 2.685,0.07 1.628,0.068 0.614,-0.067 0.085,-0.268 0.091,-0.268 0.047,-0.141 -0.006,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.9849,47.5837)",
    id: "g312"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path314",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -0.077,0.226 -0.219,0.426 -0.219,0.426 0.738,0.227 1.765,0.368 2.908,0.37 1.143,-0.002 2.178,-0.143 2.916,-0.37 0,0 -0.082,-0.151 -0.197,-0.361 C 5.344,-0.051 5.26,-0.256 5.267,-0.256 4.599,-0.042 3.74,0.068 2.685,0.07 1.628,0.068 0.614,-0.067 0.085,-0.268 0.091,-0.268 0.047,-0.141 -0.006,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.6743,46.6071)",
    id: "g316"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path318",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0.922,0.001 1.938,0.147 2.313,0.247 2.564,0.323 2.71,0.439 2.683,0.579 2.67,0.643 2.616,0.698 2.544,0.73 1.993,0.915 1,1.045 0,1.047 -1,1.045 -1.998,0.915 -2.547,0.73 -2.62,0.698 -2.675,0.643 -2.686,0.579 -2.714,0.439 -2.568,0.323 -2.316,0.247 -1.942,0.147 -0.921,0.001 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.6743,46.6071)",
    id: "g320"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path322",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0.922,0.001 1.938,0.147 2.313,0.247 2.564,0.323 2.71,0.439 2.683,0.579 2.67,0.643 2.616,0.698 2.544,0.73 1.993,0.915 1,1.045 0,1.047 -1,1.045 -1.998,0.915 -2.547,0.73 -2.62,0.698 -2.675,0.643 -2.686,0.579 -2.714,0.439 -2.568,0.323 -2.316,0.247 -1.942,0.147 -0.921,0.001 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.6358,48.4391)",
    id: "g324"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path326",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 -0.225,0.211 c 0,0 -0.214,-0.137 -0.482,-0.095 -0.268,0.043 -0.354,0.381 -0.354,0.381 0,0 -0.3,-0.265 -0.547,-0.243 -0.246,0.021 -0.408,0.243 -0.408,0.243 0,0 -0.267,-0.201 -0.504,-0.18 -0.235,0.021 -0.46,0.328 -0.46,0.328 0,0 -0.236,-0.317 -0.472,-0.338 -0.236,-0.021 -0.429,0.211 -0.429,0.211 0,0 -0.107,-0.232 -0.407,-0.286 -0.3,-0.052 -0.558,0.244 -0.558,0.244 0,0 -0.171,-0.285 -0.375,-0.36 -0.203,-0.074 -0.471,0.106 -0.471,0.106 0,0 -0.043,-0.106 -0.075,-0.169 -0.033,-0.064 -0.118,-0.074 -0.118,-0.074 l 0.067,-0.188 c 0.735,0.221 1.731,0.358 2.856,0.36 1.128,-0.002 2.151,-0.14 2.888,-0.362 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.6358,48.4391)",
    id: "g328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path330",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 -0.225,0.211 c 0,0 -0.214,-0.137 -0.482,-0.095 -0.268,0.043 -0.354,0.381 -0.354,0.381 0,0 -0.3,-0.265 -0.547,-0.243 -0.246,0.021 -0.408,0.243 -0.408,0.243 0,0 -0.267,-0.201 -0.504,-0.18 -0.235,0.021 -0.46,0.328 -0.46,0.328 0,0 -0.236,-0.317 -0.472,-0.338 -0.236,-0.021 -0.429,0.211 -0.429,0.211 0,0 -0.107,-0.232 -0.407,-0.286 -0.3,-0.052 -0.558,0.244 -0.558,0.244 0,0 -0.171,-0.285 -0.375,-0.36 -0.203,-0.074 -0.471,0.106 -0.471,0.106 0,0 -0.043,-0.106 -0.075,-0.169 -0.033,-0.064 -0.118,-0.074 -0.118,-0.074 l 0.067,-0.188 c 0.735,0.221 1.731,0.358 2.856,0.36 1.128,-0.002 2.151,-0.14 2.888,-0.362 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.6802,49.4601)",
    id: "g332"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path334",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 0.106,-0.021 c -0.017,-0.044 -0.02,-0.094 -0.02,-0.144 0,-0.231 0.189,-0.417 0.422,-0.417 0.188,0 0.347,0.121 0.403,0.288 0.006,-0.005 0.04,0.15 0.057,0.148 0.015,-0.001 0.014,-0.161 0.019,-0.158 0.028,-0.21 0.212,-0.352 0.419,-0.352 0.233,0 0.422,0.186 0.422,0.415 0,0.018 -0.001,0.035 -0.003,0.051 l 0.133,0.137 0.07,-0.174 C 2,-0.281 1.989,-0.343 1.989,-0.409 c 0,-0.219 0.18,-0.397 0.403,-0.397 0.14,0 0.263,0.071 0.336,0.177 l 0.085,0.112 -0.001,-0.137 c 0,-0.138 0.055,-0.263 0.186,-0.284 0,0 0.148,-0.01 0.345,0.151 0.197,0.161 0.306,0.294 0.306,0.294 l 0.014,-0.162 c 0,0 -0.195,-0.332 -0.372,-0.438 -0.097,-0.059 -0.243,-0.12 -0.36,-0.1 -0.122,0.021 -0.21,0.123 -0.255,0.242 -0.089,-0.054 -0.192,-0.086 -0.303,-0.086 -0.239,0 -0.453,0.136 -0.538,0.342 -0.11,-0.123 -0.263,-0.199 -0.442,-0.199 -0.191,0 -0.365,0.089 -0.474,0.227 -0.108,-0.103 -0.254,-0.166 -0.416,-0.166 -0.211,0 -0.399,0.108 -0.505,0.27 -0.107,-0.162 -0.295,-0.27 -0.506,-0.27 -0.16,0 -0.307,0.063 -0.415,0.166 -0.109,-0.138 -0.284,-0.227 -0.475,-0.227 -0.178,0 -0.332,0.076 -0.442,0.199 -0.085,-0.206 -0.299,-0.342 -0.537,-0.342 -0.111,0 -0.215,0.032 -0.303,0.086 -0.045,-0.119 -0.133,-0.221 -0.256,-0.242 -0.116,-0.02 -0.263,0.041 -0.36,0.1 -0.177,0.106 -0.384,0.438 -0.384,0.438 l 0.028,0.162 c 0,0 0.108,-0.133 0.305,-0.294 0.197,-0.161 0.346,-0.151 0.346,-0.151 0.129,0.021 0.185,0.146 0.185,0.284 v 0.137 l 0.085,-0.112 c 0.072,-0.106 0.194,-0.177 0.335,-0.177 0.223,0 0.402,0.178 0.402,0.397 0,0.066 -0.01,0.128 -0.039,0.182 l 0.072,0.174 0.132,-0.137 c -0.003,-0.016 -0.003,-0.033 -0.003,-0.051 0,-0.229 0.188,-0.415 0.422,-0.415 0.208,0 0.391,0.142 0.419,0.352 0.005,-0.003 0.004,0.157 0.018,0.158 0.018,0.002 0.053,-0.153 0.058,-0.148 0.056,-0.167 0.215,-0.288 0.402,-0.288 0.234,0 0.423,0.186 0.423,0.417 0,0.05 -0.003,0.1 -0.02,0.144 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.6802,49.4601)",
    id: "g336"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path338",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 0.106,-0.021 c -0.017,-0.044 -0.02,-0.094 -0.02,-0.144 0,-0.231 0.189,-0.417 0.422,-0.417 0.188,0 0.347,0.121 0.403,0.288 0.006,-0.005 0.04,0.15 0.057,0.148 0.015,-0.001 0.014,-0.161 0.019,-0.158 0.028,-0.21 0.212,-0.352 0.419,-0.352 0.233,0 0.422,0.186 0.422,0.415 0,0.018 -0.001,0.035 -0.003,0.051 l 0.133,0.137 0.07,-0.174 C 2,-0.281 1.989,-0.343 1.989,-0.409 c 0,-0.219 0.18,-0.397 0.403,-0.397 0.14,0 0.263,0.071 0.336,0.177 l 0.085,0.112 -0.001,-0.137 c 0,-0.138 0.055,-0.263 0.186,-0.284 0,0 0.148,-0.01 0.345,0.151 0.197,0.161 0.306,0.294 0.306,0.294 l 0.014,-0.162 c 0,0 -0.195,-0.332 -0.372,-0.438 -0.097,-0.059 -0.243,-0.12 -0.36,-0.1 -0.122,0.021 -0.21,0.123 -0.255,0.242 -0.089,-0.054 -0.192,-0.086 -0.303,-0.086 -0.239,0 -0.453,0.136 -0.538,0.342 -0.11,-0.123 -0.263,-0.199 -0.442,-0.199 -0.191,0 -0.365,0.089 -0.474,0.227 -0.108,-0.103 -0.254,-0.166 -0.416,-0.166 -0.211,0 -0.399,0.108 -0.505,0.27 -0.107,-0.162 -0.295,-0.27 -0.506,-0.27 -0.16,0 -0.307,0.063 -0.415,0.166 -0.109,-0.138 -0.284,-0.227 -0.475,-0.227 -0.178,0 -0.332,0.076 -0.442,0.199 -0.085,-0.206 -0.299,-0.342 -0.537,-0.342 -0.111,0 -0.215,0.032 -0.303,0.086 -0.045,-0.119 -0.133,-0.221 -0.256,-0.242 -0.116,-0.02 -0.263,0.041 -0.36,0.1 -0.177,0.106 -0.384,0.438 -0.384,0.438 l 0.028,0.162 c 0,0 0.108,-0.133 0.305,-0.294 0.197,-0.161 0.346,-0.151 0.346,-0.151 0.129,0.021 0.185,0.146 0.185,0.284 v 0.137 l 0.085,-0.112 c 0.072,-0.106 0.194,-0.177 0.335,-0.177 0.223,0 0.402,0.178 0.402,0.397 0,0.066 -0.01,0.128 -0.039,0.182 l 0.072,0.174 0.132,-0.137 c -0.003,-0.016 -0.003,-0.033 -0.003,-0.051 0,-0.229 0.188,-0.415 0.422,-0.415 0.208,0 0.391,0.142 0.419,0.352 0.005,-0.003 0.004,0.157 0.018,0.158 0.018,0.002 0.053,-0.153 0.058,-0.148 0.056,-0.167 0.215,-0.288 0.402,-0.288 0.234,0 0.423,0.186 0.423,0.417 0,0.05 -0.003,0.1 -0.02,0.144 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.6739,48.3796)",
    id: "g340"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path342",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -1.143,-0.002 -2.17,-0.144 -2.908,-0.371 -0.05,-0.015 -0.11,0.022 -0.125,0.07 -0.016,0.048 0.018,0.109 0.068,0.124 C -2.224,0.06 -1.171,0.208 0,0.21 1.171,0.208 2.229,0.06 2.97,-0.177 3.019,-0.192 3.055,-0.253 3.039,-0.301 3.023,-0.349 2.962,-0.386 2.912,-0.371 2.175,-0.144 1.143,-0.002 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.6739,48.3796)",
    id: "g344"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path346",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -1.143,-0.002 -2.17,-0.144 -2.908,-0.371 -0.05,-0.015 -0.11,0.022 -0.125,0.07 -0.016,0.048 0.018,0.109 0.068,0.124 C -2.224,0.06 -1.171,0.208 0,0.21 1.171,0.208 2.229,0.06 2.97,-0.177 3.019,-0.192 3.055,-0.253 3.039,-0.301 3.023,-0.349 2.962,-0.386 2.912,-0.371 2.175,-0.144 1.143,-0.002 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.5684,47.9567)",
    id: "g348"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path350",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.091 0.074,0.164 0.166,0.164 0.257,0.164 0.332,0.091 0.332,0 0.332,-0.09 0.257,-0.163 0.166,-0.163 0.074,-0.163 0,-0.09 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.5684,47.9567)",
    id: "g352"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path354",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.091 0.074,0.164 0.166,0.164 0.257,0.164 0.332,0.091 0.332,0 0.332,-0.09 0.257,-0.163 0.166,-0.163 0.074,-0.163 0,-0.09 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.6875,47.8884)",
    id: "g356"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path358",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 h -0.368 c -0.067,0 -0.124,0.054 -0.124,0.121 0,0.066 0.055,0.121 0.122,0.121 H 0 0.375 C 0.443,0.242 0.498,0.187 0.498,0.121 0.498,0.054 0.442,0 0.373,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.6875,47.8884)",
    id: "g360"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path362",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 h -0.368 c -0.067,0 -0.124,0.054 -0.124,0.121 0,0.066 0.055,0.121 0.122,0.121 H 0 0.375 C 0.443,0.242 0.498,0.187 0.498,0.121 0.498,0.054 0.442,0 0.373,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.8462,47.757)",
    id: "g364"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path366",
    style: {
      fill: "#006f46",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 -0.263,-0.041 c -0.068,-0.011 -0.132,0.035 -0.143,0.101 -0.011,0.065 0.035,0.127 0.103,0.138 l 0.264,0.041 0.27,0.042 C 0.299,0.292 0.361,0.247 0.372,0.181 0.382,0.114 0.335,0.052 0.269,0.042 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.8462,47.757)",
    id: "g368"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path370",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 -0.263,-0.041 c -0.068,-0.011 -0.132,0.035 -0.143,0.101 -0.011,0.065 0.035,0.127 0.103,0.138 l 0.264,0.041 0.27,0.042 C 0.299,0.292 0.361,0.247 0.372,0.181 0.382,0.114 0.335,0.052 0.269,0.042 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.7837,47.5617)",
    id: "g372"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path374",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 0.116,0.199 0.367,0.149 0.221,-0.071 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.7837,47.5617)",
    id: "g376"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path378",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 0.116,0.199 0.367,0.149 0.221,-0.071 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.4517,47.9567)",
    id: "g380"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path382",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.091 0.074,0.164 0.165,0.164 0.257,0.164 0.331,0.091 0.331,0 0.331,-0.09 0.257,-0.163 0.165,-0.163 0.074,-0.163 0,-0.09 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.4517,47.9567)",
    id: "g384"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path386",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.091 0.074,0.164 0.165,0.164 0.257,0.164 0.331,0.091 0.331,0 0.331,-0.09 0.257,-0.163 0.165,-0.163 0.074,-0.163 0,-0.09 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.5054,47.757)",
    id: "g388"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path390",
    style: {
      fill: "#006f46",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 0.263,-0.041 C 0.331,-0.052 0.394,-0.006 0.406,0.06 0.416,0.125 0.37,0.187 0.303,0.198 l -0.265,0.041 -0.27,0.042 c -0.067,0.011 -0.13,-0.034 -0.14,-0.1 -0.011,-0.067 0.037,-0.129 0.103,-0.139 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.5054,47.757)",
    id: "g392"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path394",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 0.263,-0.041 C 0.331,-0.052 0.394,-0.006 0.406,0.06 0.416,0.125 0.37,0.187 0.303,0.198 l -0.265,0.041 -0.27,0.042 c -0.067,0.011 -0.13,-0.034 -0.14,-0.1 -0.011,-0.067 0.037,-0.129 0.103,-0.139 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.5459,47.5524)",
    id: "g396"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path398",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 -0.095,0.209 -0.35,0.186 -0.228,-0.047 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.5459,47.5524)",
    id: "g400"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path402",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 -0.095,0.209 -0.35,0.186 -0.228,-0.047 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.6729,46.8293)",
    id: "g404"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path406",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C -0.923,0.001 -1.758,0.085 -2.394,0.256 -1.758,0.427 -0.923,0.532 0,0.534 0.923,0.532 1.761,0.427 2.396,0.256 1.761,0.085 0.923,0.001 0,0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g408"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath414)",
    id: "g410"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.4214,47.8723)",
    id: "g416"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path418",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -1.491"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.0435,47.8723)",
    id: "g420"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path422",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.121,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -1.491"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.7173,47.8723)",
    id: "g424"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path426",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -1.491"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.4126,47.8723)",
    id: "g428"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path430",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -1.491"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.1299,47.8723)",
    id: "g432"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path434",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -1.491"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.8877,47.8723)",
    id: "g436"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path438",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -1.491"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.6358,47.8723)",
    id: "g440"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path442",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.17,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -1.491"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.3936,47.8723)",
    id: "g444"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path446",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.19,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -1.491"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.1524,47.8723)",
    id: "g448"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path450",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.19,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -1.491"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.8994,47.8723)",
    id: "g452"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path454",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.214,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -1.491"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.627,47.8723)",
    id: "g456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path458",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.23800001,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -1.491"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g460"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath466)",
    id: "g462"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.6729,46.8293)",
    id: "g468"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path470",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C -0.923,0.001 -1.758,0.085 -2.394,0.256 -1.758,0.427 -0.923,0.532 0,0.534 0.923,0.532 1.761,0.427 2.396,0.256 1.761,0.085 0.923,0.001 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.5821,48.9113)",
    id: "g472"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path474",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0.024,0.074 0.002,0.148 -0.049,0.165 -0.101,0.181 -0.162,0.134 -0.187,0.06 -0.211,-0.014 -0.19,-0.088 -0.138,-0.105 -0.086,-0.121 -0.025,-0.074 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.5821,48.9113)",
    id: "g476"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path478",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0.024,0.074 0.002,0.148 -0.049,0.165 -0.101,0.181 -0.162,0.134 -0.187,0.06 -0.211,-0.014 -0.19,-0.088 -0.138,-0.105 -0.086,-0.121 -0.025,-0.074 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.7447,49.2814)",
    id: "g480"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path482",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0.01,0.078 -0.026,0.146 -0.08,0.152 -0.134,0.159 -0.185,0.101 -0.195,0.024 -0.205,-0.054 -0.168,-0.123 -0.115,-0.128 -0.061,-0.135 -0.01,-0.077 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.7447,49.2814)",
    id: "g484"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path486",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0.01,0.078 -0.026,0.146 -0.08,0.152 -0.134,0.159 -0.185,0.101 -0.195,0.024 -0.205,-0.054 -0.168,-0.123 -0.115,-0.128 -0.061,-0.135 -0.01,-0.077 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.6114,49.2814)",
    id: "g488"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path490",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C -0.009,0.078 0.026,0.146 0.08,0.152 0.134,0.159 0.186,0.101 0.195,0.024 0.205,-0.054 0.169,-0.123 0.115,-0.128 0.062,-0.135 0.01,-0.077 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.6114,49.2814)",
    id: "g492"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path494",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C -0.009,0.078 0.026,0.146 0.08,0.152 0.134,0.159 0.186,0.101 0.195,0.024 0.205,-0.054 0.169,-0.123 0.115,-0.128 0.062,-0.135 0.01,-0.077 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.774,48.9113)",
    id: "g496"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path498",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C -0.024,0.074 -0.001,0.148 0.049,0.165 0.102,0.181 0.163,0.134 0.187,0.06 0.212,-0.014 0.19,-0.088 0.138,-0.105 0.086,-0.121 0.024,-0.074 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.774,48.9113)",
    id: "g500"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path502",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C -0.024,0.074 -0.001,0.148 0.049,0.165 0.102,0.181 0.163,0.134 0.187,0.06 0.212,-0.014 0.19,-0.088 0.138,-0.105 0.086,-0.121 0.024,-0.074 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.6724,50.3859)",
    id: "g504"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path506",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 -0.326,-0.205 -0.083,-0.75 0,-0.807 l 0.083,0.058 0.242,0.544 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.6724,50.3859)",
    id: "g508"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path510",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 -0.326,-0.205 -0.083,-0.75 0,-0.807 l 0.083,0.058 0.242,0.544 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.959,49.5622)",
    id: "g512"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path514",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 0.148,-0.224 0.657,-0.063 0.71,0.012 0.657,0.087 0.148,0.243 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.959,49.5622)",
    id: "g516"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path518",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 0.148,-0.224 0.657,-0.063 0.71,0.012 0.657,0.087 0.148,0.243 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.3887,49.5622)",
    id: "g520"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path522",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 -0.148,-0.224 -0.509,0.161 -0.054,0.075 0.055,0.075 0.508,0.156 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.3887,49.5622)",
    id: "g524"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path526",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 -0.148,-0.224 -0.509,0.161 -0.054,0.075 0.055,0.075 0.508,0.156 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.5557,50.1418)",
    id: "g528"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path530",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 -0.256,-0.249 0.327,-0.449 0.088,-0.037 0.063,0.069 0.114,0.541 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.5557,50.1418)",
    id: "g532"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path534",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 -0.256,-0.249 0.327,-0.449 0.088,-0.037 0.063,0.069 0.114,0.541 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.0201,49.2433)",
    id: "g536"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path538",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 0.192,-0.187 0.655,0.073 0.693,0.158 0.624,0.22 0.094,0.268 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.0201,49.2433)",
    id: "g540"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path542",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 0.192,-0.187 0.655,0.073 0.693,0.158 0.624,0.22 0.094,0.268 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.418,49.5368)",
    id: "g544"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path546",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 -0.097,-0.249 -0.531,0.052 -0.069,0.063 0.038,0.084 0.463,0.257 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.418,49.5368)",
    id: "g548"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path550",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 -0.097,-0.249 -0.531,0.052 -0.069,0.063 0.038,0.084 0.463,0.257 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.5088,49.1745)",
    id: "g552"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path554",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 -0.044,-0.264 -0.53,-0.057 -0.08,0.047 0.018,0.09 0.4,0.347 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.5088,49.1745)",
    id: "g556"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path558",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 -0.044,-0.264 -0.53,-0.057 -0.08,0.047 0.018,0.09 0.4,0.347 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.5313,49.4006)",
    id: "g560"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path562",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.101 0.083,0.183 0.187,0.183 0.29,0.183 0.373,0.101 0.373,0 0.373,-0.102 0.29,-0.184 0.187,-0.184 0.083,-0.184 0,-0.102 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.5313,49.4006)",
    id: "g564"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path566",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.101 0.083,0.183 0.187,0.183 0.29,0.183 0.373,0.101 0.373,0 0.373,-0.102 0.29,-0.184 0.187,-0.184 0.083,-0.184 0,-0.102 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.7974,50.1418)",
    id: "g568"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path570",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 0.256,-0.249 -0.327,-0.449 -0.088,-0.037 -0.063,0.069 -0.114,0.541 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.7974,50.1418)",
    id: "g572"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path574",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 0.256,-0.249 -0.327,-0.449 -0.088,-0.037 -0.063,0.069 -0.114,0.541 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.333,49.2433)",
    id: "g576"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path578",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 -0.192,-0.187 -0.464,0.26 -0.037,0.085 0.07,0.062 0.529,0.048 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.333,49.2433)",
    id: "g580"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path582",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 -0.192,-0.187 -0.464,0.26 -0.037,0.085 0.07,0.062 0.529,0.048 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.9341,49.5368)",
    id: "g584"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path586",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 0.099,-0.249 0.53,0.052 0.069,0.063 -0.037,0.084 -0.464,0.257 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.9341,49.5368)",
    id: "g588"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path590",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 0.099,-0.249 0.53,0.052 0.069,0.063 -0.037,0.084 -0.464,0.257 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.7715,49.1745)",
    id: "g592"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path594",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 0.044,-0.264 0.53,-0.057 0.08,0.047 -0.017,0.09 -0.401,0.347 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.7715,49.1745)",
    id: "g596"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path598",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 0.044,-0.264 0.53,-0.057 0.08,0.047 -0.017,0.09 -0.401,0.347 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.4888,49.5739)",
    id: "g600"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path602",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.102 0.083,0.184 0.187,0.184 0.289,0.184 0.373,0.102 0.373,0 0.373,-0.102 0.289,-0.184 0.187,-0.184 0.083,-0.184 0,-0.102 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.4888,49.5739)",
    id: "g604"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path606",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.102 0.083,0.184 0.187,0.184 0.289,0.184 0.373,0.102 0.373,0 0.373,-0.102 0.289,-0.184 0.187,-0.184 0.083,-0.184 0,-0.102 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.4522,49.4006)",
    id: "g608"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path610",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.101 0.083,0.183 0.187,0.183 0.289,0.183 0.372,0.101 0.372,0 0.372,-0.102 0.289,-0.184 0.187,-0.184 0.083,-0.184 0,-0.102 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.4522,49.4006)",
    id: "g612"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path614",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.101 0.083,0.183 0.187,0.183 0.289,0.183 0.372,0.101 0.372,0 0.372,-0.102 0.289,-0.184 0.187,-0.184 0.083,-0.184 0,-0.102 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.7906,48.8679)",
    id: "g616"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path618",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -0.005,-0.005 -0.144,0.19 -0.249,0.288 -0.074,0.068 -0.255,0.129 -0.255,0.129 0,0.034 0.106,0.113 0.221,0.113 0.067,0 0.131,-0.03 0.169,-0.079 l 0.016,0.076 c 0,0 0.092,-0.019 0.134,-0.13 C 0.079,0.288 0.051,0.118 0.051,0.118 0.051,0.118 0.034,0.038 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.7906,48.8679)",
    id: "g620"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path622",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -0.005,-0.005 -0.144,0.19 -0.249,0.288 -0.074,0.068 -0.255,0.129 -0.255,0.129 0,0.034 0.106,0.113 0.221,0.113 0.067,0 0.131,-0.03 0.169,-0.079 l 0.016,0.076 c 0,0 0.092,-0.019 0.134,-0.13 C 0.079,0.288 0.051,0.118 0.051,0.118 0.051,0.118 0.034,0.038 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.7979,48.9626)",
    id: "g624"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path626",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0.043,0.048 0.135,0.038 0.203,-0.022 0.271,-0.083 0.291,-0.171 0.246,-0.219 0.202,-0.267 0.112,-0.257 0.043,-0.196 -0.024,-0.136 -0.043,-0.048 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.7979,48.9626)",
    id: "g628"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path630",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0.043,0.048 0.135,0.038 0.203,-0.022 0.271,-0.083 0.291,-0.171 0.246,-0.219 0.202,-0.267 0.112,-0.257 0.043,-0.196 -0.024,-0.136 -0.043,-0.048 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.4898,48.8679)",
    id: "g632"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path634",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C 0.005,-0.005 0.144,0.19 0.249,0.288 0.323,0.356 0.504,0.417 0.504,0.417 0.504,0.451 0.398,0.53 0.283,0.53 0.216,0.53 0.152,0.5 0.114,0.451 L 0.098,0.527 c 0,0 -0.091,-0.019 -0.134,-0.13 -0.043,-0.109 -0.015,-0.279 -0.015,-0.279 0,0 0.017,-0.08 0.051,-0.118"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.4898,48.8679)",
    id: "g636"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path638",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0.005,-0.005 0.144,0.19 0.249,0.288 0.323,0.356 0.504,0.417 0.504,0.417 0.504,0.451 0.398,0.53 0.283,0.53 0.216,0.53 0.152,0.5 0.114,0.451 L 0.098,0.527 c 0,0 -0.091,-0.019 -0.134,-0.13 -0.043,-0.109 -0.015,-0.279 -0.015,-0.279 0,0 0.017,-0.08 0.051,-0.118 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.4932,48.9626)",
    id: "g640"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path642",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C -0.044,0.048 -0.134,0.038 -0.203,-0.022 -0.27,-0.083 -0.29,-0.171 -0.247,-0.219 -0.202,-0.267 -0.111,-0.257 -0.043,-0.196 0.024,-0.136 0.044,-0.048 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.4932,48.9626)",
    id: "g644"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path646",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C -0.044,0.048 -0.134,0.038 -0.203,-0.022 -0.27,-0.083 -0.29,-0.171 -0.247,-0.219 -0.202,-0.267 -0.111,-0.257 -0.043,-0.196 0.024,-0.136 0.044,-0.048 0,0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path648",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 3.468,46.684 H 11.92 V 44.379 H 3.468 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.355,42.8449)",
    id: "g650"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path652",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0.053,0.022 0.092,0.026 0.157,0.026 h 6.329 c 0.063,0 0.122,-0.011 0.174,-0.032 -0.217,0.077 -0.372,0.279 -0.372,0.52 0,0.242 0.169,0.453 0.388,0.529 C 6.625,1.025 6.552,1.012 6.49,1.012 H 0.157 c -0.064,0 -0.124,0.002 -0.178,0.021 L 0.014,1.026 C 0.241,0.954 0.37,0.744 0.37,0.514 0.37,0.293 0.226,0.073 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.355,42.8449)",
    id: "g654"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path656",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0.053,0.022 0.092,0.026 0.157,0.026 h 6.329 c 0.063,0 0.122,-0.011 0.174,-0.032 -0.217,0.077 -0.372,0.279 -0.372,0.52 0,0.242 0.169,0.453 0.388,0.529 C 6.625,1.025 6.552,1.012 6.49,1.012 H 0.157 c -0.064,0 -0.124,0.002 -0.178,0.021 L 0.014,1.026 C 0.241,0.954 0.37,0.744 0.37,0.514 0.37,0.293 0.226,0.073 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.5122,42.8713)",
    id: "g658"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path660",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 h 6.329 c 0.214,0 0.388,-0.138 0.388,-0.309 0,-0.17 -0.174,-0.309 -0.388,-0.309 H 0 c -0.214,0 -0.388,0.139 -0.388,0.309 C -0.388,-0.138 -0.214,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.5122,42.8713)",
    id: "g662"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path664",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 h 6.329 c 0.214,0 0.388,-0.138 0.388,-0.309 0,-0.17 -0.174,-0.309 -0.388,-0.309 H 0 c -0.214,0 -0.388,0.139 -0.388,0.309 C -0.388,-0.138 -0.214,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.5122,44.3796)",
    id: "g666"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path668",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 h 6.333 c 0.214,0 0.388,-0.117 0.388,-0.261 0,-0.145 -0.174,-0.262 -0.388,-0.262 H 0 c -0.214,0 -0.388,0.117 -0.388,0.262 C -0.388,-0.117 -0.214,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.5122,44.3796)",
    id: "g670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path672",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 h 6.333 c 0.214,0 0.388,-0.117 0.388,-0.261 0,-0.145 -0.174,-0.262 -0.388,-0.262 H 0 c -0.214,0 -0.388,0.117 -0.388,0.262 C -0.388,-0.117 -0.214,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.5948,5.5861)",
    id: "g674"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path676",
    style: {
      fill: "#0044ae",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -0.585,0 -1.105,0.128 -1.49,0.341 -0.381,0.203 -0.897,0.327 -1.466,0.327 -0.571,0 -1.1,-0.125 -1.482,-0.329 C -4.82,0.131 -5.349,0 -5.927,0 -6.51,0 -7.033,0.143 -7.416,0.355 -7.794,0.55 -8.301,0.668 -8.855,0.668 -9.429,0.668 -9.937,0.553 -10.319,0.348 -10.702,0.137 -11.235,0 -11.816,0 v -0.951 c 0.581,0 1.114,0.137 1.497,0.348 0.382,0.205 0.89,0.32 1.464,0.32 0.554,0 1.061,-0.118 1.439,-0.313 0.383,-0.211 0.906,-0.355 1.489,-0.355 0.578,0 1.107,0.132 1.489,0.339 0.382,0.205 0.911,0.329 1.482,0.329 0.569,0 1.085,-0.124 1.466,-0.326 0.385,-0.213 0.897,-0.342 1.483,-0.342 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.5948,5.5861)",
    id: "g678"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path680",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -0.585,0 -1.105,0.128 -1.49,0.341 -0.381,0.203 -0.897,0.327 -1.466,0.327 -0.571,0 -1.1,-0.125 -1.482,-0.329 C -4.82,0.131 -5.349,0 -5.927,0 -6.51,0 -7.033,0.143 -7.416,0.355 -7.794,0.55 -8.301,0.668 -8.855,0.668 -9.429,0.668 -9.937,0.553 -10.319,0.348 -10.702,0.137 -11.235,0 -11.816,0 v -0.951 c 0.581,0 1.114,0.137 1.497,0.348 0.382,0.205 0.89,0.32 1.464,0.32 0.554,0 1.061,-0.118 1.439,-0.313 0.383,-0.211 0.906,-0.355 1.489,-0.355 0.578,0 1.107,0.132 1.489,0.339 0.382,0.205 0.911,0.329 1.482,0.329 0.569,0 1.085,-0.124 1.466,-0.326 0.385,-0.213 0.897,-0.342 1.483,-0.342 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.5948,4.6354)",
    id: "g682"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path684",
    style: {
      fill: "#bcbab9",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -0.585,0 -1.105,0.128 -1.49,0.341 -0.381,0.203 -0.897,0.327 -1.466,0.327 -0.571,0 -1.1,-0.125 -1.482,-0.329 C -4.82,0.131 -5.349,0 -5.927,0 -6.51,0 -7.033,0.144 -7.416,0.355 -7.794,0.549 -8.301,0.668 -8.855,0.668 -9.429,0.668 -9.937,0.552 -10.319,0.348 -10.702,0.136 -11.235,0 -11.816,0 v -0.951 c 0.581,0 1.114,0.137 1.497,0.347 0.382,0.206 0.89,0.321 1.464,0.321 0.554,0 1.061,-0.118 1.439,-0.313 0.383,-0.212 0.906,-0.355 1.489,-0.355 0.578,0 1.107,0.132 1.489,0.339 0.382,0.204 0.911,0.329 1.482,0.329 0.569,0 1.085,-0.124 1.466,-0.326 0.385,-0.214 0.897,-0.342 1.483,-0.342 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.5948,4.6354)",
    id: "g686"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path688",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -0.585,0 -1.105,0.128 -1.49,0.341 -0.381,0.203 -0.897,0.327 -1.466,0.327 -0.571,0 -1.1,-0.125 -1.482,-0.329 C -4.82,0.131 -5.349,0 -5.927,0 -6.51,0 -7.033,0.144 -7.416,0.355 -7.794,0.549 -8.301,0.668 -8.855,0.668 -9.429,0.668 -9.937,0.552 -10.319,0.348 -10.702,0.136 -11.235,0 -11.816,0 v -0.951 c 0.581,0 1.114,0.137 1.497,0.347 0.382,0.206 0.89,0.321 1.464,0.321 0.554,0 1.061,-0.118 1.439,-0.313 0.383,-0.212 0.906,-0.355 1.489,-0.355 0.578,0 1.107,0.132 1.489,0.339 0.382,0.204 0.911,0.329 1.482,0.329 0.569,0 1.085,-0.124 1.466,-0.326 0.385,-0.214 0.897,-0.342 1.483,-0.342 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.5948,3.6843)",
    id: "g690"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path692",
    style: {
      fill: "#0044ae",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -0.585,0 -1.105,0.128 -1.49,0.342 -0.381,0.202 -0.897,0.326 -1.466,0.326 -0.571,0 -1.1,-0.125 -1.482,-0.329 C -4.82,0.132 -5.349,0 -5.927,0 -6.51,0 -7.033,0.144 -7.416,0.355 -7.794,0.55 -8.301,0.668 -8.855,0.668 -9.429,0.668 -9.937,0.553 -10.319,0.348 -10.702,0.137 -11.235,0 -11.816,0 v -0.951 c 0.581,0 1.114,0.137 1.497,0.348 0.382,0.206 0.89,0.321 1.464,0.321 0.554,0 1.061,-0.119 1.439,-0.313 0.383,-0.212 0.906,-0.356 1.489,-0.356 0.578,0 1.107,0.131 1.489,0.34 0.382,0.204 0.911,0.329 1.482,0.329 0.569,0 1.085,-0.125 1.466,-0.327 0.385,-0.213 0.897,-0.342 1.483,-0.342 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.5948,3.6843)",
    id: "g694"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path696",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -0.585,0 -1.105,0.128 -1.49,0.342 -0.381,0.202 -0.897,0.326 -1.466,0.326 -0.571,0 -1.1,-0.125 -1.482,-0.329 C -4.82,0.132 -5.349,0 -5.927,0 -6.51,0 -7.033,0.144 -7.416,0.355 -7.794,0.55 -8.301,0.668 -8.855,0.668 -9.429,0.668 -9.937,0.553 -10.319,0.348 -10.702,0.137 -11.235,0 -11.816,0 v -0.951 c 0.581,0 1.114,0.137 1.497,0.348 0.382,0.206 0.89,0.321 1.464,0.321 0.554,0 1.061,-0.119 1.439,-0.313 0.383,-0.212 0.906,-0.356 1.489,-0.356 0.578,0 1.107,0.131 1.489,0.34 0.382,0.204 0.911,0.329 1.482,0.329 0.569,0 1.085,-0.125 1.466,-0.327 0.385,-0.213 0.897,-0.342 1.483,-0.342 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.5874,1.7834)",
    id: "g698"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path700",
    style: {
      fill: "#bcbab9",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -0.586,0 -1.098,0.128 -1.482,0.341 -0.382,0.203 -0.898,0.327 -1.466,0.327 -0.572,0 -1.1,-0.125 -1.483,-0.33 C -4.812,0.131 -5.342,0 -5.919,0 -6.502,0 -7.025,0.143 -7.408,0.355 -7.787,0.549 -8.293,0.668 -8.848,0.668 -9.421,0.668 -9.929,0.552 -10.312,0.347 -10.695,0.136 -11.228,0 -11.809,0 v 0.946 c 0.581,0 1.114,0.141 1.497,0.352 0.383,0.205 0.891,0.321 1.464,0.321 0.555,0 1.061,-0.119 1.44,-0.313 0.383,-0.212 0.906,-0.356 1.489,-0.356 0.577,0 1.107,0.131 1.488,0.34 0.383,0.204 0.911,0.329 1.483,0.329 0.568,0 1.084,-0.125 1.466,-0.327 C -1.098,1.079 -0.578,0.95 0.007,0.95 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.5874,1.7834)",
    id: "g702"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path704",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -0.586,0 -1.098,0.128 -1.482,0.341 -0.382,0.203 -0.898,0.327 -1.466,0.327 -0.572,0 -1.1,-0.125 -1.483,-0.33 C -4.812,0.131 -5.342,0 -5.919,0 -6.502,0 -7.025,0.143 -7.408,0.355 -7.787,0.549 -8.293,0.668 -8.848,0.668 -9.421,0.668 -9.929,0.552 -10.312,0.347 -10.695,0.136 -11.228,0 -11.809,0 v 0.946 c 0.581,0 1.114,0.141 1.497,0.352 0.383,0.205 0.891,0.321 1.464,0.321 0.555,0 1.061,-0.119 1.44,-0.313 0.383,-0.212 0.906,-0.356 1.489,-0.356 0.577,0 1.107,0.131 1.488,0.34 0.383,0.204 0.911,0.329 1.483,0.329 0.568,0 1.084,-0.125 1.466,-0.327 C -1.098,1.079 -0.578,0.95 0.007,0.95 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.5874,0.8322)",
    id: "g706"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path708",
    style: {
      fill: "#0044ae",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C -0.586,0 -1.098,0.128 -1.482,0.342 -1.864,0.544 -2.38,0.668 -2.948,0.668 -3.52,0.668 -4.048,0.543 -4.431,0.339 -4.812,0.131 -5.342,0 -5.919,0 -6.502,0 -7.025,0.143 -7.408,0.355 -7.787,0.549 -8.293,0.668 -8.848,0.668 -9.421,0.668 -9.929,0.553 -10.312,0.347 -10.695,0.136 -11.228,0 -11.809,0 v 0.942 c 0.581,0 1.114,0.145 1.497,0.356 0.383,0.205 0.891,0.321 1.464,0.321 0.555,0 1.061,-0.119 1.44,-0.313 0.383,-0.212 0.906,-0.355 1.489,-0.355 0.577,0 1.107,0.131 1.488,0.339 0.383,0.204 0.911,0.329 1.483,0.329 0.568,0 1.084,-0.124 1.466,-0.327 C -1.098,1.08 -0.58,0.951 0.005,0.951 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.5874,0.8322)",
    id: "g710"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path712",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C -0.586,0 -1.098,0.128 -1.482,0.342 -1.864,0.544 -2.38,0.668 -2.948,0.668 -3.52,0.668 -4.048,0.543 -4.431,0.339 -4.812,0.131 -5.342,0 -5.919,0 -6.502,0 -7.025,0.143 -7.408,0.355 -7.787,0.549 -8.293,0.668 -8.848,0.668 -9.421,0.668 -9.929,0.553 -10.312,0.347 -10.695,0.136 -11.228,0 -11.809,0 v 0.942 c 0.581,0 1.114,0.145 1.497,0.356 0.383,0.205 0.891,0.321 1.464,0.321 0.555,0 1.061,-0.119 1.44,-0.313 0.383,-0.212 0.906,-0.355 1.489,-0.355 0.577,0 1.107,0.131 1.488,0.339 0.383,0.204 0.911,0.329 1.483,0.329 0.568,0 1.084,-0.124 1.466,-0.327 C -1.098,1.08 -0.58,0.951 0.005,0.951 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.356,9.4904)",
    id: "g714"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path716",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0.021,-0.079 0.048,-0.158 0.048,-0.244 0,-0.576 -0.48,-1.038 -1.065,-1.038 H 7.68 c -0.584,0 -1.063,0.462 -1.063,1.038 0,0.085 0.015,0.166 0.034,0.244 C 6.602,-0.017 6.542,-0.02 6.485,-0.02 H 0.156 C 0.104,-0.02 0.045,-0.014 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.356,9.4904)",
    id: "g718"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path720",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0.021,-0.079 0.048,-0.158 0.048,-0.244 0,-0.576 -0.48,-1.038 -1.065,-1.038 H 7.68 c -0.584,0 -1.063,0.462 -1.063,1.038 0,0.085 0.015,0.166 0.034,0.244 C 6.602,-0.017 6.542,-0.02 6.485,-0.02 H 0.156 C 0.104,-0.02 0.045,-0.014 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.5122,10.0881)",
    id: "g722"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path724",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 h 6.329 c 0.214,0 0.388,-0.138 0.388,-0.309 0,-0.17 -0.174,-0.309 -0.388,-0.309 H 0 c -0.214,0 -0.388,0.139 -0.388,0.309 C -0.388,-0.138 -0.214,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.5122,10.0881)",
    id: "g726"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path728",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 h 6.329 c 0.214,0 0.388,-0.138 0.388,-0.309 0,-0.17 -0.174,-0.309 -0.388,-0.309 H 0 c -0.214,0 -0.388,0.139 -0.388,0.309 C -0.388,-0.138 -0.214,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path730",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 3.351,8.209 h 8.676 V 5.91 H 3.351 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.6724,18.238)",
    id: "g732"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path734",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -0.859,-0.517 -1.441,-1.045 -1.347,-1.308 0.046,-0.243 0.32,-0.424 0.71,-0.691 0.613,-0.445 0.985,-1.238 0.694,-1.605 0.506,0.427 0.829,1.062 0.829,1.771 C 0.886,-1.093 0.547,-0.427 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.6724,18.238)",
    id: "g736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path738",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -0.859,-0.517 -1.441,-1.045 -1.347,-1.308 0.046,-0.243 0.32,-0.424 0.71,-0.691 0.613,-0.445 0.985,-1.238 0.694,-1.605 0.506,0.427 0.829,1.062 0.829,1.771 C 0.886,-1.093 0.547,-0.427 0,0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path740",
    style: {
      fill: "#bcbab9",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 4.594,41.887 h 6.165 V 10.463 H 4.594 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g742"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath748)",
    id: "g744"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.043,42.6638)",
    id: "g750"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path752",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -33.109"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.7344,42.6638)",
    id: "g754"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path756",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -33.109"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g758"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath764)",
    id: "g760"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path766",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 4.594,41.887 h 6.165 V 10.463 H 4.594 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.0542,30.1325)",
    id: "g768"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path770",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C -1.347,0.579 -3.632,1.008 -6.255,1.098 -7.16,1.089 -8.168,1.002 -9.209,0.821 c -3.687,-0.64 -6.496,-2.172 -6.271,-3.42 0.003,-0.024 0.011,-0.08 0.018,-0.105 0,0 -1.383,3.243 -1.405,3.365 -0.248,1.386 2.869,3.085 6.961,3.797 1.284,0.223 2.537,0.308 3.625,0.296 2.618,0 4.893,-0.348 6.264,-0.877 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.0542,30.1325)",
    id: "g772"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path774",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C -1.347,0.579 -3.632,1.008 -6.255,1.098 -7.16,1.089 -8.168,1.002 -9.209,0.821 c -3.687,-0.64 -6.496,-2.172 -6.271,-3.42 0.003,-0.024 0.011,-0.08 0.018,-0.105 0,0 -1.383,3.243 -1.405,3.365 -0.248,1.386 2.869,3.085 6.961,3.797 1.284,0.223 2.537,0.308 3.625,0.296 2.618,0 4.893,-0.348 6.264,-0.877 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.5835,26.1877)",
    id: "g776"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path778",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -1.71,0.127 -2.877,0.603 -3.01,1.346 -0.106,0.593 0.471,1.25 1.504,1.845 0.461,-0.052 0.98,-0.117 1.516,-0.118 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.5835,26.1877)",
    id: "g780"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path782",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -1.71,0.127 -2.877,0.603 -3.01,1.346 -0.106,0.593 0.471,1.25 1.504,1.845 0.461,-0.052 0.98,-0.117 1.516,-0.118 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.7686,28.5891)",
    id: "g784"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path786",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 1.068,-0.167 1.87,-0.442 2.271,-0.783 L 2.305,-0.851 C 2.498,-1.257 1.557,-2.122 -0.009,-3.087 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.7686,28.5891)",
    id: "g788"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path790",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 1.068,-0.167 1.87,-0.442 2.271,-0.783 L 2.305,-0.851 C 2.498,-1.257 1.557,-2.122 -0.009,-3.087 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.7539,20.1257)",
    id: "g792"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path794",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -0.162,0.509 1.505,1.523 3.861,2.423 1.076,0.401 1.965,0.82 3.068,1.326 3.272,1.503 5.688,3.233 5.391,3.863 L 12.288,7.677 C 12.462,7.53 12.732,4.426 12.732,4.426 13.031,3.847 10.818,2.146 7.806,0.643 6.841,0.162 4.804,-0.62 3.843,-0.97 2.124,-1.592 0.416,-2.762 0.571,-3.195 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.7539,20.1257)",
    id: "g796"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path798",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -0.162,0.509 1.505,1.523 3.861,2.423 1.076,0.401 1.965,0.82 3.068,1.326 3.272,1.503 5.688,3.233 5.391,3.863 L 12.288,7.677 C 12.462,7.53 12.732,4.426 12.732,4.426 13.031,3.847 10.818,2.146 7.806,0.643 6.841,0.162 4.804,-0.62 3.843,-0.97 2.124,-1.592 0.416,-2.762 0.571,-3.195 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.6709,32.7824)",
    id: "g800"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path802",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 0.26,0.098 C 0.477,0.18 0.721,0.061 0.829,-0.216 0.911,-0.428 0.888,-0.664 0.64,-0.829 0.559,-0.88 0.464,-0.919 0.373,-0.958 Z m 0.447,-1.149 c 0.754,0.285 1.247,0.623 1.006,1.24 C 1.3,0.484 0.911,0.56 0.329,0.339 l -1.03,-0.389 0.927,-2.381 c 0.102,0.046 0.203,0.097 0.308,0.136 0.104,0.04 0.213,0.068 0.32,0.101 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.5264,33.778)",
    id: "g804"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path806",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -0.108,-0.03 -0.215,-0.064 -0.325,-0.087 -0.11,-0.023 -0.222,-0.035 -0.333,-0.051 l 0.534,-2.476 1.663,0.348 c -0.02,0.05 -0.045,0.101 -0.056,0.152 -0.011,0.051 -0.01,0.109 -0.012,0.161 C 1.178,-2.041 0.859,-2.134 0.478,-2.214 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.8555,31.6432)",
    id: "g808"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path810",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0.314,0.897 0.693,1.758 1.067,2.629 1.001,2.618 0.93,2.609 0.862,2.604 0.795,2.6 0.724,2.599 0.656,2.601 0.458,1.969 0.211,1.337 -0.05,0.708 -0.362,1.305 -0.709,1.889 -0.972,2.489 -1.101,2.473 -1.235,2.452 -1.365,2.443 -1.494,2.434 -1.629,2.437 -1.759,2.435 c 0.48,-0.813 0.942,-1.623 1.379,-2.461 0.062,0.011 0.124,0.027 0.191,0.031 C -0.126,0.01 -0.063,0.003 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.3306,33.548)",
    id: "g812"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path814",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0.058,0.121 0.116,0.238 0.182,0.351 -0.09,0.088 -0.365,0.217 -0.686,0.251 -0.678,0.07 -1.068,-0.245 -1.113,-0.67 -0.095,-0.891 1.257,-0.814 1.194,-1.406 -0.027,-0.255 -0.286,-0.359 -0.562,-0.33 -0.308,0.032 -0.533,0.208 -0.573,0.47 l -0.085,0.009 c -0.043,-0.156 -0.109,-0.306 -0.179,-0.456 0.197,-0.133 0.456,-0.208 0.701,-0.234 0.691,-0.071 1.218,0.218 1.268,0.691 0.091,0.847 -1.274,0.895 -1.221,1.394 0.022,0.211 0.177,0.348 0.529,0.311 0.254,-0.026 0.41,-0.169 0.478,-0.375 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.2476,49.0944)",
    id: "g816"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path818",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -0.278,-0.306 -0.483,-0.349 -0.203,-0.042 -0.46,0.19 -0.46,0.19 0,0 -0.182,-0.2 -0.408,-0.253 -0.225,-0.052 -0.535,0.264 -0.535,0.264 0,0 -0.215,-0.316 -0.408,-0.391 -0.193,-0.074 -0.429,0.095 -0.429,0.095 0,0 -0.086,-0.158 -0.246,-0.243 -0.069,-0.036 -0.182,0.021 -0.182,0.021 l -0.226,0.148 -0.257,0.286 -0.236,0.095 c 0,0 -0.107,0.359 -0.118,0.422 -0.011,0.064 -0.032,0.222 -0.032,0.222 -0.049,0.257 0.332,0.555 0.873,0.682 0.312,0.074 0.584,0.071 0.783,0.005 0.216,0.193 0.674,0.327 1.212,0.327 0.487,0 0.916,-0.11 1.152,-0.275 0.235,0.165 0.662,0.275 1.15,0.275 0.538,0 0.996,-0.134 1.212,-0.327 0.2,0.066 0.471,0.069 0.783,-0.005 0.541,-0.127 0.922,-0.425 0.873,-0.682 0,0 -0.021,-0.158 -0.033,-0.222 C 3.976,0.222 3.868,-0.137 3.868,-0.137 L 3.632,-0.232 3.375,-0.518 3.149,-0.666 c 0,0 -0.113,-0.057 -0.181,-0.021 -0.161,0.085 -0.247,0.243 -0.247,0.243 0,0 -0.236,-0.169 -0.429,-0.095 -0.193,0.075 -0.407,0.391 -0.407,0.391 0,0 -0.311,-0.316 -0.537,-0.264 -0.224,0.053 -0.407,0.253 -0.407,0.253 0,0 -0.257,-0.232 -0.461,-0.19 C 0.276,-0.306 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.2476,49.0944)",
    id: "g820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path822",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.101,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -0.278,-0.306 -0.483,-0.349 -0.203,-0.042 -0.46,0.19 -0.46,0.19 0,0 -0.182,-0.2 -0.408,-0.253 -0.225,-0.052 -0.535,0.264 -0.535,0.264 0,0 -0.215,-0.316 -0.408,-0.391 -0.193,-0.074 -0.429,0.095 -0.429,0.095 0,0 -0.086,-0.158 -0.246,-0.243 -0.069,-0.036 -0.182,0.021 -0.182,0.021 l -0.226,0.148 -0.257,0.286 -0.236,0.095 c 0,0 -0.107,0.359 -0.118,0.422 -0.011,0.064 -0.032,0.222 -0.032,0.222 -0.049,0.257 0.332,0.555 0.873,0.682 0.312,0.074 0.584,0.071 0.783,0.005 0.216,0.193 0.674,0.327 1.212,0.327 0.487,0 0.916,-0.11 1.152,-0.275 0.235,0.165 0.662,0.275 1.15,0.275 0.538,0 0.996,-0.134 1.212,-0.327 0.2,0.066 0.471,0.069 0.783,-0.005 0.541,-0.127 0.922,-0.425 0.873,-0.682 0,0 -0.021,-0.158 -0.033,-0.222 C 3.976,0.222 3.868,-0.137 3.868,-0.137 L 3.632,-0.232 3.375,-0.518 3.149,-0.666 c 0,0 -0.113,-0.057 -0.181,-0.021 -0.161,0.085 -0.247,0.243 -0.247,0.243 0,0 -0.236,-0.169 -0.429,-0.095 -0.193,0.075 -0.407,0.391 -0.407,0.391 0,0 -0.311,-0.316 -0.537,-0.264 -0.224,0.053 -0.407,0.253 -0.407,0.253 0,0 -0.257,-0.232 -0.461,-0.19 C 0.276,-0.306 0,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.7168,50.7599)",
    id: "g824"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path826",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.428 0.234,0.775 0.522,0.775 0.812,0.775 1.045,0.428 1.045,0 1.045,-0.428 0.812,-0.774 0.522,-0.774 0.234,-0.774 0,-0.428 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.7168,50.7599)",
    id: "g828"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path830",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.428 0.234,0.775 0.522,0.775 0.812,0.775 1.045,0.428 1.045,0 1.045,-0.428 0.812,-0.774 0.522,-0.774 0.234,-0.774 0,-0.428 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.0088,50.7604)",
    id: "g832"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path834",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.394 0.108,0.712 0.24,0.712 0.374,0.712 0.481,0.394 0.481,0 0.481,-0.394 0.374,-0.712 0.24,-0.712 0.108,-0.712 0,-0.394 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.0088,50.7604)",
    id: "g836"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path838",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.394 0.108,0.712 0.24,0.712 0.374,0.712 0.481,0.394 0.481,0 0.481,-0.394 0.374,-0.712 0.24,-0.712 0.108,-0.712 0,-0.394 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.5547,47.5837)",
    id: "g840"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path842",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -0.075,0.226 -0.219,0.426 -0.219,0.426 0.738,0.227 1.766,0.368 2.908,0.37 1.144,-0.002 2.179,-0.143 2.917,-0.37 0,0 -0.083,-0.151 -0.197,-0.361 C 5.345,-0.051 5.261,-0.256 5.267,-0.256 4.601,-0.042 3.742,0.068 2.686,0.07 1.629,0.068 0.613,-0.067 0.086,-0.268 0.091,-0.268 0.049,-0.141 -0.005,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.5547,47.5837)",
    id: "g844"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path846",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -0.075,0.226 -0.219,0.426 -0.219,0.426 0.738,0.227 1.766,0.368 2.908,0.37 1.144,-0.002 2.179,-0.143 2.917,-0.37 0,0 -0.083,-0.151 -0.197,-0.361 C 5.345,-0.051 5.261,-0.256 5.267,-0.256 4.601,-0.042 3.742,0.068 2.686,0.07 1.629,0.068 0.613,-0.067 0.086,-0.268 0.091,-0.268 0.049,-0.141 -0.005,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.2461,46.6071)",
    id: "g848"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path850",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0.921,0.001 1.937,0.147 2.312,0.247 2.563,0.323 2.709,0.439 2.681,0.579 2.669,0.643 2.615,0.698 2.542,0.73 1.992,0.915 1,1.045 0,1.047 -1.001,1.045 -1.998,0.915 -2.549,0.73 -2.621,0.698 -2.675,0.643 -2.688,0.579 -2.715,0.439 -2.569,0.323 -2.318,0.247 -1.944,0.147 -0.922,0.001 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.2461,46.6071)",
    id: "g852"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path854",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0.921,0.001 1.937,0.147 2.312,0.247 2.563,0.323 2.709,0.439 2.681,0.579 2.669,0.643 2.615,0.698 2.542,0.73 1.992,0.915 1,1.045 0,1.047 -1.001,1.045 -1.998,0.915 -2.549,0.73 -2.621,0.698 -2.675,0.643 -2.688,0.579 -2.715,0.439 -2.569,0.323 -2.318,0.247 -1.944,0.147 -0.922,0.001 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.4805,50.4147)",
    id: "g856"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path858",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.093 0.077,0.169 0.172,0.169 0.267,0.169 0.344,0.093 0.344,0 0.344,-0.093 0.267,-0.169 0.172,-0.169 0.077,-0.169 0,-0.093 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.4805,50.4147)",
    id: "g860"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path862",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.086,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.093 0.077,0.169 0.172,0.169 0.267,0.169 0.344,0.093 0.344,0 0.344,-0.093 0.267,-0.169 0.172,-0.169 0.077,-0.169 0,-0.093 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.3843,51.006)",
    id: "g864"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path866",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.086,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.094 0.077,0.169 0.172,0.169 0.267,0.169 0.343,0.094 0.343,0 0.343,-0.093 0.267,-0.168 0.172,-0.168 0.077,-0.168 0,-0.093 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.9556,51.3762)",
    id: "g868"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path870",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.086,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.093 0.077,0.169 0.172,0.169 0.267,0.169 0.344,0.093 0.344,0 0.344,-0.093 0.267,-0.168 0.172,-0.168 0.077,-0.168 0,-0.093 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.42,51.5558)",
    id: "g872"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path874",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.086,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.093 0.077,0.169 0.171,0.169 0.266,0.169 0.343,0.093 0.343,0 0.343,-0.093 0.266,-0.169 0.171,-0.169 0.077,-0.169 0,-0.093 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.8726,51.5349)",
    id: "g876"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path878",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.086,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.093 0.077,0.169 0.172,0.169 0.267,0.169 0.344,0.093 0.344,0 0.344,-0.093 0.267,-0.169 0.172,-0.169 0.077,-0.169 0,-0.093 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.1773,49.2648)",
    id: "g880"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path882",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0.051,0.131 0.083,0.275 0.083,0.426 0,0.627 -0.479,1.136 -1.071,1.136 -0.19,0 -0.368,-0.052 -0.522,-0.143"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.2691,50.0646)",
    id: "g884"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path886",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0.055,0.102 0.094,0.227 0.094,0.345 0,0.452 -0.448,0.819 -1.002,0.819 -0.235,0 -0.452,-0.066 -0.623,-0.178"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.3247,49.7809)",
    id: "g888"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path890",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.086,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.093 0.077,0.169 0.172,0.169 0.267,0.169 0.343,0.093 0.343,0 0.343,-0.093 0.267,-0.168 0.172,-0.168 0.077,-0.168 0,-0.093 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.2608,50.404)",
    id: "g892"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path894",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.086,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.093 0.077,0.169 0.172,0.169 0.267,0.169 0.344,0.093 0.344,0 0.344,-0.093 0.267,-0.169 0.172,-0.169 0.077,-0.169 0,-0.093 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.8745,50.8796)",
    id: "g896"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path898",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.086,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.094 0.077,0.169 0.172,0.169 0.267,0.169 0.344,0.094 0.344,0 0.344,-0.093 0.267,-0.168 0.172,-0.168 0.077,-0.168 0,-0.093 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.3599,51.133)",
    id: "g900"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path902",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.086,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.094 0.077,0.169 0.172,0.169 0.266,0.169 0.343,0.094 0.343,0 0.343,-0.093 0.266,-0.168 0.172,-0.168 0.077,-0.168 0,-0.093 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.8135,51.112)",
    id: "g904"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path906",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.086,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.093 0.076,0.169 0.171,0.169 0.266,0.169 0.343,0.093 0.343,0 0.343,-0.093 0.266,-0.169 0.171,-0.169 0.076,-0.169 0,-0.093 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.2071,48.4391)",
    id: "g908"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path910",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 -0.226,0.211 c 0,0 -0.214,-0.137 -0.482,-0.095 -0.268,0.043 -0.354,0.381 -0.354,0.381 0,0 -0.3,-0.265 -0.546,-0.243 -0.247,0.021 -0.408,0.243 -0.408,0.243 0,0 -0.268,-0.201 -0.504,-0.18 -0.235,0.021 -0.461,0.328 -0.461,0.328 0,0 -0.235,-0.317 -0.471,-0.338 -0.236,-0.021 -0.428,0.211 -0.428,0.211 0,0 -0.109,-0.232 -0.408,-0.286 -0.301,-0.052 -0.558,0.244 -0.558,0.244 0,0 -0.172,-0.285 -0.375,-0.36 -0.204,-0.074 -0.472,0.106 -0.472,0.106 0,0 -0.043,-0.106 -0.076,-0.169 -0.031,-0.064 -0.117,-0.074 -0.117,-0.074 l 0.067,-0.188 c 0.736,0.221 1.731,0.358 2.856,0.36 1.129,-0.002 2.151,-0.14 2.888,-0.362 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.2071,48.4391)",
    id: "g912"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path914",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 -0.226,0.211 c 0,0 -0.214,-0.137 -0.482,-0.095 -0.268,0.043 -0.354,0.381 -0.354,0.381 0,0 -0.3,-0.265 -0.546,-0.243 -0.247,0.021 -0.408,0.243 -0.408,0.243 0,0 -0.268,-0.201 -0.504,-0.18 -0.235,0.021 -0.461,0.328 -0.461,0.328 0,0 -0.235,-0.317 -0.471,-0.338 -0.236,-0.021 -0.428,0.211 -0.428,0.211 0,0 -0.109,-0.232 -0.408,-0.286 -0.301,-0.052 -0.558,0.244 -0.558,0.244 0,0 -0.172,-0.285 -0.375,-0.36 -0.204,-0.074 -0.472,0.106 -0.472,0.106 0,0 -0.043,-0.106 -0.076,-0.169 -0.031,-0.064 -0.117,-0.074 -0.117,-0.074 l 0.067,-0.188 c 0.736,0.221 1.731,0.358 2.856,0.36 1.129,-0.002 2.151,-0.14 2.888,-0.362 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.6431,50.4147)",
    id: "g916"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path918",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.093 0.077,0.169 0.172,0.169 0.266,0.169 0.343,0.093 0.343,0 0.343,-0.093 0.266,-0.169 0.172,-0.169 0.077,-0.169 0,-0.093 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.6431,50.4147)",
    id: "g920"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path922",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.086,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.093 0.077,0.169 0.172,0.169 0.266,0.169 0.343,0.093 0.343,0 0.343,-0.093 0.266,-0.169 0.172,-0.169 0.077,-0.169 0,-0.093 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.7393,51.006)",
    id: "g924"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path926",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.086,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.094 0.077,0.169 0.172,0.169 0.266,0.169 0.343,0.094 0.343,0 0.343,-0.093 0.266,-0.168 0.172,-0.168 0.077,-0.168 0,-0.093 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.168,51.3762)",
    id: "g928"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path930",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.086,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.093 0.077,0.169 0.172,0.169 0.267,0.169 0.343,0.093 0.343,0 0.343,-0.093 0.267,-0.168 0.172,-0.168 0.077,-0.168 0,-0.093 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.7041,51.5558)",
    id: "g932"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path934",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.086,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.093 0.077,0.169 0.171,0.169 0.266,0.169 0.343,0.093 0.343,0 0.343,-0.093 0.266,-0.169 0.171,-0.169 0.077,-0.169 0,-0.093 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.251,51.5349)",
    id: "g936"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path938",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.086,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.093 0.077,0.169 0.171,0.169 0.266,0.169 0.343,0.093 0.343,0 0.343,-0.093 0.266,-0.169 0.171,-0.169 0.077,-0.169 0,-0.093 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.2901,49.2648)",
    id: "g940"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path942",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -0.051,0.131 -0.083,0.275 -0.083,0.426 0,0.627 0.479,1.136 1.071,1.136 0.19,0 0.367,-0.052 0.522,-0.143"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.2105,50.0778)",
    id: "g944"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path946",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -0.055,0.102 -0.107,0.213 -0.107,0.332 0,0.452 0.449,0.818 1.002,0.818 0.236,0 0.452,-0.066 0.624,-0.177"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.7993,49.7809)",
    id: "g948"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path950",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.086,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.093 0.077,0.169 0.171,0.169 0.266,0.169 0.342,0.093 0.342,0 0.342,-0.093 0.266,-0.168 0.171,-0.168 0.077,-0.168 0,-0.093 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.8628,50.404)",
    id: "g952"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path954",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.086,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.093 0.077,0.169 0.172,0.169 0.267,0.169 0.344,0.093 0.344,0 0.344,-0.093 0.267,-0.169 0.172,-0.169 0.077,-0.169 0,-0.093 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.2491,50.8796)",
    id: "g956"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path958",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.086,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.094 0.077,0.169 0.172,0.169 0.267,0.169 0.344,0.094 0.344,0 0.344,-0.093 0.267,-0.168 0.172,-0.168 0.077,-0.168 0,-0.093 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.7637,51.133)",
    id: "g960"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path962",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.086,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.094 0.077,0.169 0.171,0.169 0.266,0.169 0.343,0.094 0.343,0 0.343,-0.093 0.266,-0.168 0.171,-0.168 0.077,-0.168 0,-0.093 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.3106,51.112)",
    id: "g964"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path966",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.086,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.093 0.077,0.169 0.171,0.169 0.266,0.169 0.343,0.093 0.343,0 0.343,-0.093 0.266,-0.169 0.171,-0.169 0.077,-0.169 0,-0.093 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.251,49.4601)",
    id: "g968"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path970",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 0.106,-0.021 C 0.089,-0.065 0.085,-0.115 0.085,-0.165 c 0,-0.231 0.189,-0.417 0.424,-0.417 0.187,0 0.346,0.121 0.401,0.288 0.006,-0.005 0.04,0.15 0.058,0.148 0.015,-0.001 0.013,-0.161 0.019,-0.158 0.027,-0.21 0.211,-0.352 0.419,-0.352 0.233,0 0.421,0.186 0.421,0.415 0,0.018 0,0.035 -0.002,0.051 l 0.133,0.137 0.07,-0.174 C 2,-0.281 1.989,-0.343 1.989,-0.409 c 0,-0.219 0.18,-0.397 0.403,-0.397 0.14,0 0.263,0.071 0.335,0.177 l 0.085,0.112 v -0.137 c 0,-0.138 0.056,-0.263 0.185,-0.284 0,0 0.149,-0.01 0.346,0.151 0.197,0.161 0.305,0.294 0.305,0.294 l 0.013,-0.162 c 0,0 -0.194,-0.332 -0.369,-0.438 -0.097,-0.059 -0.244,-0.12 -0.36,-0.1 -0.123,0.021 -0.211,0.123 -0.257,0.242 -0.087,-0.054 -0.192,-0.086 -0.302,-0.086 -0.239,0 -0.453,0.136 -0.538,0.342 -0.11,-0.123 -0.263,-0.199 -0.442,-0.199 -0.191,0 -0.366,0.089 -0.476,0.227 -0.106,-0.103 -0.253,-0.166 -0.413,-0.166 -0.212,0 -0.4,0.108 -0.506,0.27 -0.108,-0.162 -0.295,-0.27 -0.505,-0.27 -0.162,0 -0.308,0.063 -0.416,0.166 -0.11,-0.138 -0.284,-0.227 -0.474,-0.227 -0.18,0 -0.332,0.076 -0.442,0.199 -0.085,-0.206 -0.3,-0.342 -0.538,-0.342 -0.112,0 -0.215,0.032 -0.303,0.086 -0.045,-0.119 -0.133,-0.221 -0.256,-0.242 -0.117,-0.02 -0.263,0.041 -0.359,0.1 -0.177,0.106 -0.386,0.438 -0.386,0.438 l 0.028,0.162 c 0,0 0.109,-0.133 0.305,-0.294 0.198,-0.161 0.347,-0.151 0.347,-0.151 0.129,0.021 0.185,0.146 0.185,0.284 l -0.001,0.137 0.085,-0.112 c 0.072,-0.106 0.196,-0.177 0.336,-0.177 0.222,0 0.403,0.178 0.403,0.397 0,0.066 -0.011,0.128 -0.04,0.182 l 0.071,0.174 0.133,-0.137 c -0.002,-0.016 -0.004,-0.033 -0.004,-0.051 0,-0.229 0.189,-0.415 0.422,-0.415 0.208,0 0.392,0.142 0.419,0.352 0.006,-0.003 0.005,0.157 0.02,0.158 0.017,0.002 0.051,-0.153 0.057,-0.148 0.056,-0.167 0.215,-0.288 0.403,-0.288 0.233,0 0.422,0.186 0.422,0.417 0,0.05 -0.003,0.1 -0.021,0.144 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.251,49.4601)",
    id: "g972"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path974",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 0.106,-0.021 C 0.089,-0.065 0.085,-0.115 0.085,-0.165 c 0,-0.231 0.189,-0.417 0.424,-0.417 0.187,0 0.346,0.121 0.401,0.288 0.006,-0.005 0.04,0.15 0.058,0.148 0.015,-0.001 0.013,-0.161 0.019,-0.158 0.027,-0.21 0.211,-0.352 0.419,-0.352 0.233,0 0.421,0.186 0.421,0.415 0,0.018 0,0.035 -0.002,0.051 l 0.133,0.137 0.07,-0.174 C 2,-0.281 1.989,-0.343 1.989,-0.409 c 0,-0.219 0.18,-0.397 0.403,-0.397 0.14,0 0.263,0.071 0.335,0.177 l 0.085,0.112 v -0.137 c 0,-0.138 0.056,-0.263 0.185,-0.284 0,0 0.149,-0.01 0.346,0.151 0.197,0.161 0.305,0.294 0.305,0.294 l 0.013,-0.162 c 0,0 -0.194,-0.332 -0.369,-0.438 -0.097,-0.059 -0.244,-0.12 -0.36,-0.1 -0.123,0.021 -0.211,0.123 -0.257,0.242 -0.087,-0.054 -0.192,-0.086 -0.302,-0.086 -0.239,0 -0.453,0.136 -0.538,0.342 -0.11,-0.123 -0.263,-0.199 -0.442,-0.199 -0.191,0 -0.366,0.089 -0.476,0.227 -0.106,-0.103 -0.253,-0.166 -0.413,-0.166 -0.212,0 -0.4,0.108 -0.506,0.27 -0.108,-0.162 -0.295,-0.27 -0.505,-0.27 -0.162,0 -0.308,0.063 -0.416,0.166 -0.11,-0.138 -0.284,-0.227 -0.474,-0.227 -0.18,0 -0.332,0.076 -0.442,0.199 -0.085,-0.206 -0.3,-0.342 -0.538,-0.342 -0.112,0 -0.215,0.032 -0.303,0.086 -0.045,-0.119 -0.133,-0.221 -0.256,-0.242 -0.117,-0.02 -0.263,0.041 -0.359,0.1 -0.177,0.106 -0.386,0.438 -0.386,0.438 l 0.028,0.162 c 0,0 0.109,-0.133 0.305,-0.294 0.198,-0.161 0.347,-0.151 0.347,-0.151 0.129,0.021 0.185,0.146 0.185,0.284 l -0.001,0.137 0.085,-0.112 c 0.072,-0.106 0.196,-0.177 0.336,-0.177 0.222,0 0.403,0.178 0.403,0.397 0,0.066 -0.011,0.128 -0.04,0.182 l 0.071,0.174 0.133,-0.137 c -0.002,-0.016 -0.004,-0.033 -0.004,-0.051 0,-0.229 0.189,-0.415 0.422,-0.415 0.208,0 0.392,0.142 0.419,0.352 0.006,-0.003 0.005,0.157 0.02,0.158 0.017,0.002 0.051,-0.153 0.057,-0.148 0.056,-0.167 0.215,-0.288 0.403,-0.288 0.233,0 0.422,0.186 0.422,0.417 0,0.05 -0.003,0.1 -0.021,0.144 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.2442,48.3796)",
    id: "g976"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path978",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -1.143,-0.002 -2.169,-0.144 -2.907,-0.371 -0.049,-0.015 -0.11,0.022 -0.126,0.07 -0.016,0.048 0.019,0.109 0.069,0.124 C -2.223,0.06 -1.17,0.208 0,0.21 1.171,0.208 2.229,0.06 2.97,-0.177 3.019,-0.192 3.056,-0.253 3.04,-0.301 3.023,-0.349 2.961,-0.386 2.912,-0.371 2.174,-0.144 1.144,-0.002 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.2442,48.3796)",
    id: "g980"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path982",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -1.143,-0.002 -2.169,-0.144 -2.907,-0.371 -0.049,-0.015 -0.11,0.022 -0.126,0.07 -0.016,0.048 0.019,0.109 0.069,0.124 C -2.223,0.06 -1.17,0.208 0,0.21 1.171,0.208 2.229,0.06 2.97,-0.177 3.019,-0.192 3.056,-0.253 3.04,-0.301 3.023,-0.349 2.961,-0.386 2.912,-0.371 2.174,-0.144 1.144,-0.002 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.1382,47.9567)",
    id: "g984"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path986",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.091 0.075,0.164 0.167,0.164 0.259,0.164 0.332,0.091 0.332,0 0.332,-0.09 0.259,-0.163 0.167,-0.163 0.075,-0.163 0,-0.09 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.1382,47.9567)",
    id: "g988"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path990",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.091 0.075,0.164 0.167,0.164 0.259,0.164 0.332,0.091 0.332,0 0.332,-0.09 0.259,-0.163 0.167,-0.163 0.075,-0.163 0,-0.09 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.2588,47.8884)",
    id: "g992"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path994",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 h -0.368 c -0.069,0 -0.124,0.054 -0.124,0.121 0,0.066 0.054,0.121 0.122,0.121 H 0 0.375 C 0.442,0.242 0.498,0.187 0.498,0.121 0.498,0.054 0.44,0 0.373,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.2588,47.8884)",
    id: "g996"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path998",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 h -0.368 c -0.069,0 -0.124,0.054 -0.124,0.121 0,0.066 0.054,0.121 0.122,0.121 H 0 0.375 C 0.442,0.242 0.498,0.187 0.498,0.121 0.498,0.054 0.44,0 0.373,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.417,47.757)",
    id: "g1000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1002",
    style: {
      fill: "#006f46",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 -0.264,-0.041 c -0.067,-0.011 -0.132,0.035 -0.142,0.101 -0.01,0.065 0.035,0.127 0.102,0.138 l 0.265,0.041 0.27,0.042 C 0.298,0.292 0.361,0.247 0.372,0.181 0.383,0.114 0.335,0.052 0.268,0.042 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.417,47.757)",
    id: "g1004"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1006",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 -0.264,-0.041 c -0.067,-0.011 -0.132,0.035 -0.142,0.101 -0.01,0.065 0.035,0.127 0.102,0.138 l 0.265,0.041 0.27,0.042 C 0.298,0.292 0.361,0.247 0.372,0.181 0.383,0.114 0.335,0.052 0.268,0.042 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.355,47.5617)",
    id: "g1008"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1010",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 0.115,0.199 0.367,0.149 0.221,-0.071 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.355,47.5617)",
    id: "g1012"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1014",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 0.115,0.199 0.367,0.149 0.221,-0.071 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.0215,47.9567)",
    id: "g1016"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1018",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.091 0.075,0.164 0.167,0.164 0.258,0.164 0.332,0.091 0.332,0 0.332,-0.09 0.258,-0.163 0.167,-0.163 0.075,-0.163 0,-0.09 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.0215,47.9567)",
    id: "g1020"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1022",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.091 0.075,0.164 0.167,0.164 0.258,0.164 0.332,0.091 0.332,0 0.332,-0.09 0.258,-0.163 0.167,-0.163 0.075,-0.163 0,-0.09 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.0747,47.757)",
    id: "g1024"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1026",
    style: {
      fill: "#006f46",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 0.265,-0.041 C 0.331,-0.052 0.396,-0.006 0.406,0.06 0.417,0.125 0.372,0.187 0.305,0.198 L 0.04,0.239 -0.23,0.281 C -0.297,0.292 -0.36,0.247 -0.371,0.181 -0.382,0.114 -0.334,0.052 -0.268,0.042 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.0747,47.757)",
    id: "g1028"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1030",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 0.265,-0.041 C 0.331,-0.052 0.396,-0.006 0.406,0.06 0.417,0.125 0.372,0.187 0.305,0.198 L 0.04,0.239 -0.23,0.281 C -0.297,0.292 -0.36,0.247 -0.371,0.181 -0.382,0.114 -0.334,0.052 -0.268,0.042 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.1158,47.5524)",
    id: "g1032"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1034",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 -0.094,0.209 -0.349,0.186 -0.228,-0.047 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.1158,47.5524)",
    id: "g1036"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1038",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 -0.094,0.209 -0.349,0.186 -0.228,-0.047 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.2427,46.8293)",
    id: "g1040"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1042",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C -0.923,0.001 -1.757,0.085 -2.392,0.256 -1.757,0.427 -0.923,0.532 0,0.534 0.923,0.532 1.762,0.427 2.397,0.256 1.762,0.085 0.923,0.001 0,0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1044"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath1050)",
    id: "g1046"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.9917,47.8723)",
    id: "g1052"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1054",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -1.491"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.6138,47.8723)",
    id: "g1056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1058",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.121,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -1.491"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.2886,47.8723)",
    id: "g1060"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1062",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -1.491"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.9844,47.8723)",
    id: "g1064"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1066",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -1.491"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.6992,47.8723)",
    id: "g1068"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1070",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -1.491"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.458,47.8723)",
    id: "g1072"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1074",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -1.491"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.2061,47.8723)",
    id: "g1076"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1078",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.17,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -1.491"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.9649,47.8723)",
    id: "g1080"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1082",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.19,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -1.491"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.7227,47.8723)",
    id: "g1084"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1086",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.19,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -1.491"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.4707,47.8723)",
    id: "g1088"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1090",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.214,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -1.491"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.1978,47.8723)",
    id: "g1092"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1094",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.23800001,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -1.491"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1096"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath1102)",
    id: "g1098"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.2427,46.8293)",
    id: "g1104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1106",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C -0.923,0.001 -1.757,0.085 -2.392,0.256 -1.757,0.427 -0.923,0.532 0,0.534 0.923,0.532 1.762,0.427 2.397,0.256 1.762,0.085 0.923,0.001 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.1534,48.9113)",
    id: "g1108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1110",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0.023,0.074 0.001,0.148 -0.049,0.165 -0.102,0.181 -0.163,0.134 -0.187,0.06 -0.212,-0.014 -0.19,-0.088 -0.139,-0.105 -0.087,-0.121 -0.025,-0.074 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.1534,48.9113)",
    id: "g1112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1114",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0.023,0.074 0.001,0.148 -0.049,0.165 -0.102,0.181 -0.163,0.134 -0.187,0.06 -0.212,-0.014 -0.19,-0.088 -0.139,-0.105 -0.087,-0.121 -0.025,-0.074 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.3159,49.2814)",
    id: "g1116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1118",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0.009,0.078 -0.026,0.146 -0.08,0.152 -0.134,0.159 -0.186,0.101 -0.196,0.024 -0.206,-0.054 -0.169,-0.123 -0.115,-0.128 -0.062,-0.135 -0.01,-0.077 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.3159,49.2814)",
    id: "g1120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1122",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0.009,0.078 -0.026,0.146 -0.08,0.152 -0.134,0.159 -0.186,0.101 -0.196,0.024 -0.206,-0.054 -0.169,-0.123 -0.115,-0.128 -0.062,-0.135 -0.01,-0.077 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.1826,49.2814)",
    id: "g1124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1126",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C -0.01,0.078 0.026,0.146 0.08,0.152 0.134,0.159 0.185,0.101 0.194,0.024 0.205,-0.054 0.168,-0.123 0.114,-0.128 0.061,-0.135 0.01,-0.077 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.1826,49.2814)",
    id: "g1128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1130",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C -0.01,0.078 0.026,0.146 0.08,0.152 0.134,0.159 0.185,0.101 0.194,0.024 0.205,-0.054 0.168,-0.123 0.114,-0.128 0.061,-0.135 0.01,-0.077 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.3452,48.9113)",
    id: "g1132"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1134",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C -0.024,0.074 -0.003,0.148 0.049,0.165 0.101,0.181 0.162,0.134 0.187,0.06 0.211,-0.014 0.19,-0.088 0.137,-0.105 0.086,-0.121 0.024,-0.074 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.3452,48.9113)",
    id: "g1136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1138",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C -0.024,0.074 -0.003,0.148 0.049,0.165 0.101,0.181 0.162,0.134 0.187,0.06 0.211,-0.014 0.19,-0.088 0.137,-0.105 0.086,-0.121 0.024,-0.074 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.2427,50.3859)",
    id: "g1140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1142",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 -0.326,-0.205 -0.083,-0.75 0,-0.807 l 0.083,0.058 0.243,0.544 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.2427,50.3859)",
    id: "g1144"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1146",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 -0.326,-0.205 -0.083,-0.75 0,-0.807 l 0.083,0.058 0.243,0.544 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.5293,49.5622)",
    id: "g1148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1150",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 0.149,-0.224 0.658,-0.063 0.711,0.012 0.656,0.087 0.149,0.243 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.5293,49.5622)",
    id: "g1152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1154",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 0.149,-0.224 0.658,-0.063 0.711,0.012 0.656,0.087 0.149,0.243 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.959,49.5622)",
    id: "g1156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1158",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 -0.148,-0.224 -0.508,0.161 -0.054,0.075 0.054,0.075 0.508,0.156 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.959,49.5622)",
    id: "g1160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1162",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 -0.148,-0.224 -0.508,0.161 -0.054,0.075 0.054,0.075 0.508,0.156 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.1265,50.1418)",
    id: "g1164"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1166",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 -0.256,-0.249 0.327,-0.449 0.087,-0.037 0.064,0.069 0.114,0.541 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.1265,50.1418)",
    id: "g1168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1170",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 -0.256,-0.249 0.327,-0.449 0.087,-0.037 0.064,0.069 0.114,0.541 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.5904,49.2433)",
    id: "g1172"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1174",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 0.192,-0.187 0.656,0.073 0.692,0.158 0.624,0.22 0.094,0.268 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.5904,49.2433)",
    id: "g1176"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1178",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 0.192,-0.187 0.656,0.073 0.692,0.158 0.624,0.22 0.094,0.268 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.9893,49.5368)",
    id: "g1180"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1182",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 -0.098,-0.249 -0.532,0.052 -0.068,0.063 0.037,0.084 0.465,0.257 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.9893,49.5368)",
    id: "g1184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1186",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 -0.098,-0.249 -0.532,0.052 -0.068,0.063 0.037,0.084 0.465,0.257 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.0786,49.1745)",
    id: "g1188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1190",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 -0.042,-0.264 -0.532,-0.057 -0.08,0.047 0.019,0.09 0.399,0.347 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.0786,49.1745)",
    id: "g1192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1194",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 -0.042,-0.264 -0.532,-0.057 -0.08,0.047 0.019,0.09 0.399,0.347 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.1021,49.4006)",
    id: "g1196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1198",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.101 0.083,0.183 0.186,0.183 0.29,0.183 0.373,0.101 0.373,0 0.373,-0.102 0.29,-0.184 0.186,-0.184 0.083,-0.184 0,-0.102 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.1021,49.4006)",
    id: "g1200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1202",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.101 0.083,0.183 0.186,0.183 0.29,0.183 0.373,0.101 0.373,0 0.373,-0.102 0.29,-0.184 0.186,-0.184 0.083,-0.184 0,-0.102 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.3677,50.1418)",
    id: "g1204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1206",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 0.256,-0.249 -0.327,-0.449 -0.088,-0.037 -0.063,0.069 -0.115,0.541 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.3677,50.1418)",
    id: "g1208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1210",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 0.256,-0.249 -0.327,-0.449 -0.088,-0.037 -0.063,0.069 -0.115,0.541 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.9038,49.2433)",
    id: "g1212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1214",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 -0.192,-0.187 -0.464,0.26 -0.037,0.085 0.068,0.062 0.531,0.048 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.9038,49.2433)",
    id: "g1216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1218",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 -0.192,-0.187 -0.464,0.26 -0.037,0.085 0.068,0.062 0.531,0.048 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.5049,49.5368)",
    id: "g1220"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1222",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 0.098,-0.249 0.629,-0.197 0.698,-0.134 0.66,-0.05 0.196,0.207 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.5049,49.5368)",
    id: "g1224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1226",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 0.098,-0.249 0.629,-0.197 0.698,-0.134 0.66,-0.05 0.196,0.207 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.3428,49.1745)",
    id: "g1228"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1230",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 0.042,-0.264 0.532,-0.057 0.081,0.047 -0.019,0.09 -0.4,0.347 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.3428,49.1745)",
    id: "g1232"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1234",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 0.042,-0.264 0.532,-0.057 0.081,0.047 -0.019,0.09 -0.4,0.347 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.0596,49.5739)",
    id: "g1236"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1238",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.102 0.083,0.184 0.187,0.184 0.29,0.184 0.373,0.102 0.373,0 0.373,-0.102 0.29,-0.184 0.187,-0.184 0.083,-0.184 0,-0.102 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.0596,49.5739)",
    id: "g1240"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1242",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.102 0.083,0.184 0.187,0.184 0.29,0.184 0.373,0.102 0.373,0 0.373,-0.102 0.29,-0.184 0.187,-0.184 0.083,-0.184 0,-0.102 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.0225,49.4006)",
    id: "g1244"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1246",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.101 0.083,0.183 0.187,0.183 0.29,0.183 0.373,0.101 0.373,0 0.373,-0.102 0.29,-0.184 0.187,-0.184 0.083,-0.184 0,-0.102 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.0225,49.4006)",
    id: "g1248"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1250",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.101 0.083,0.183 0.187,0.183 0.29,0.183 0.373,0.101 0.373,0 0.373,-0.102 0.29,-0.184 0.187,-0.184 0.083,-0.184 0,-0.102 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.8965,51.6462)",
    id: "g1252"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1254",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.191 0.156,0.345 0.35,0.345 0.544,0.345 0.701,0.191 0.701,0 0.701,-0.19 0.544,-0.345 0.35,-0.345 0.156,-0.345 0,-0.19 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.4947,51.7668)",
    id: "g1256"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1258",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 V -0.228 H -0.542 V 0 h 0.177 v 0.518 h -0.234 v 0.228 h 0.234 v 0.227 h 0.231 V 0.746 H 0.098 V 0.518 h -0.232 l 0,-0.518 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.4947,51.7668)",
    id: "g1260"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1262",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.111,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -0.228 H -0.542 V 0 h 0.177 v 0.518 h -0.234 v 0.228 h 0.234 v 0.227 h 0.231 V 0.746 H 0.098 V 0.518 h -0.232 l 0,-0.518 z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1264"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath1270)",
    id: "g1266"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.7349,51.7668)",
    id: "g1272"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1274",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 V -0.228 H -0.96 V 0 h 0.355 v 0.518 h -0.234 v 0.228 h 0.234 v 0.227 h 0.23 V 0.746 h 0.233 V 0.518 H -0.375 V 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.7349,51.7668)",
    id: "g1276"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1278",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.111,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -0.228 H -0.96 V 0 h 0.355 v 0.518 h -0.234 v 0.228 h 0.234 v 0.227 h 0.23 V 0.746 h 0.233 V 0.518 H -0.375 V 0 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1280"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath1286)",
    id: "g1282"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.3472,51.9777)",
    id: "g1288"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1290",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0.145,-0.042 0.25,-0.175 0.25,-0.332 0,-0.19 -0.157,-0.344 -0.351,-0.344 -0.193,0 -0.35,0.154 -0.35,0.344 0,0.16 0.111,0.295 0.26,0.334"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.3614,48.8679)",
    id: "g1292"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1294",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -0.004,-0.005 -0.144,0.19 -0.249,0.288 -0.074,0.068 -0.256,0.129 -0.256,0.129 0,0.034 0.107,0.113 0.222,0.113 0.068,0 0.132,-0.03 0.169,-0.079 l 0.015,0.076 c 0,0 0.093,-0.019 0.136,-0.13 C 0.079,0.288 0.051,0.118 0.051,0.118 0.051,0.118 0.035,0.038 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.3614,48.8679)",
    id: "g1296"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1298",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -0.004,-0.005 -0.144,0.19 -0.249,0.288 -0.074,0.068 -0.256,0.129 -0.256,0.129 0,0.034 0.107,0.113 0.222,0.113 0.068,0 0.132,-0.03 0.169,-0.079 l 0.015,0.076 c 0,0 0.093,-0.019 0.136,-0.13 C 0.079,0.288 0.051,0.118 0.051,0.118 0.051,0.118 0.035,0.038 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.3682,48.9626)",
    id: "g1300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1302",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0.044,0.048 0.135,0.038 0.203,-0.022 0.271,-0.083 0.291,-0.171 0.248,-0.219 0.203,-0.267 0.112,-0.257 0.044,-0.196 -0.024,-0.136 -0.044,-0.048 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.3682,48.9626)",
    id: "g1304"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1306",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0.044,0.048 0.135,0.038 0.203,-0.022 0.271,-0.083 0.291,-0.171 0.248,-0.219 0.203,-0.267 0.112,-0.257 0.044,-0.196 -0.024,-0.136 -0.044,-0.048 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.0606,48.8679)",
    id: "g1308"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1310",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C 0.005,-0.005 0.143,0.19 0.249,0.288 0.323,0.356 0.504,0.417 0.504,0.417 0.504,0.451 0.398,0.53 0.284,0.53 0.215,0.53 0.152,0.5 0.113,0.451 L 0.099,0.527 c 0,0 -0.094,-0.019 -0.136,-0.13 C -0.08,0.288 -0.052,0.118 -0.052,0.118 -0.052,0.118 -0.035,0.038 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.0606,48.8679)",
    id: "g1312"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1314",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0.005,-0.005 0.143,0.19 0.249,0.288 0.323,0.356 0.504,0.417 0.504,0.417 0.504,0.451 0.398,0.53 0.284,0.53 0.215,0.53 0.152,0.5 0.113,0.451 L 0.099,0.527 c 0,0 -0.094,-0.019 -0.136,-0.13 C -0.08,0.288 -0.052,0.118 -0.052,0.118 -0.052,0.118 -0.035,0.038 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.0645,48.9626)",
    id: "g1316"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1318",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -0.044,0.048 -0.135,0.038 -0.203,-0.022 -0.068,-0.061 -0.088,-0.149 -0.044,-0.197 0.044,-0.048 0.135,-0.038 0.203,0.023 C 0.024,-0.136 0.043,-0.048 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.0645,48.9626)",
    id: "g1320"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1322",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -0.044,0.048 -0.135,0.038 -0.203,-0.022 -0.068,-0.061 -0.088,-0.149 -0.044,-0.197 0.044,-0.048 0.135,-0.038 0.203,0.023 C 0.024,-0.136 0.043,-0.048 0,0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path1324",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 60.026,46.684 h 8.452 v -2.305 h -8.452 z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.5909,42.8449)",
    id: "g1326"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1328",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -0.053,0.022 -0.092,0.026 -0.156,0.026 h -6.33 c -0.062,0 -0.121,-0.011 -0.174,-0.032 0.217,0.077 0.373,0.279 0.373,0.52 0,0.242 -0.17,0.453 -0.389,0.529 0.052,-0.018 0.124,-0.031 0.186,-0.031 h 6.334 c 0.064,0 0.124,0.002 0.177,0.021 L -0.014,1.026 C -0.24,0.954 -0.369,0.744 -0.369,0.514 -0.369,0.293 -0.226,0.073 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.5909,42.8449)",
    id: "g1330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1332",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -0.053,0.022 -0.092,0.026 -0.156,0.026 h -6.33 c -0.062,0 -0.121,-0.011 -0.174,-0.032 0.217,0.077 0.373,0.279 0.373,0.52 0,0.242 -0.17,0.453 -0.389,0.529 0.052,-0.018 0.124,-0.031 0.186,-0.031 h 6.334 c 0.064,0 0.124,0.002 0.177,0.021 L -0.014,1.026 C -0.24,0.954 -0.369,0.744 -0.369,0.514 -0.369,0.293 -0.226,0.073 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.1045,42.8713)",
    id: "g1334"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1336",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 h 6.33 c 0.213,0 0.387,-0.138 0.387,-0.309 0,-0.17 -0.174,-0.309 -0.387,-0.309 H 0 c -0.214,0 -0.388,0.139 -0.388,0.309 C -0.388,-0.138 -0.214,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.1045,42.8713)",
    id: "g1338"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1340",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 h 6.33 c 0.213,0 0.387,-0.138 0.387,-0.309 0,-0.17 -0.174,-0.309 -0.387,-0.309 H 0 c -0.214,0 -0.388,0.139 -0.388,0.309 C -0.388,-0.138 -0.214,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.1006,44.3796)",
    id: "g1342"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1344",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 h 6.334 c 0.213,0 0.387,-0.117 0.387,-0.261 0,-0.145 -0.174,-0.262 -0.387,-0.262 H 0 c -0.214,0 -0.388,0.117 -0.388,0.262 C -0.388,-0.117 -0.214,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.1006,44.3796)",
    id: "g1346"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1348",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 h 6.334 c 0.213,0 0.387,-0.117 0.387,-0.261 0,-0.145 -0.174,-0.262 -0.387,-0.262 H 0 c -0.214,0 -0.388,0.117 -0.388,0.262 C -0.388,-0.117 -0.214,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.3511,5.5861)",
    id: "g1350"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1352",
    style: {
      fill: "#0044ae",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0.586,0 1.106,0.128 1.489,0.341 0.381,0.203 0.898,0.327 1.467,0.327 0.571,0 1.1,-0.125 1.481,-0.329 C 4.82,0.131 5.348,0 5.926,0 6.51,0 7.032,0.143 7.417,0.355 7.794,0.55 8.3,0.668 8.856,0.668 9.429,0.668 9.938,0.553 10.319,0.348 10.702,0.137 11.235,0 11.817,0 v -0.951 c -0.582,0 -1.115,0.137 -1.498,0.348 -0.381,0.205 -0.89,0.32 -1.463,0.32 -0.556,0 -1.062,-0.118 -1.439,-0.313 -0.385,-0.211 -0.907,-0.355 -1.491,-0.355 -0.578,0 -1.106,0.132 -1.489,0.339 -0.381,0.205 -0.91,0.329 -1.481,0.329 -0.569,0 -1.086,-0.124 -1.467,-0.326 C 1.106,-0.822 0.592,-0.951 0.007,-0.951 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.3511,5.5861)",
    id: "g1354"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1356",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0.586,0 1.106,0.128 1.489,0.341 0.381,0.203 0.898,0.327 1.467,0.327 0.571,0 1.1,-0.125 1.481,-0.329 C 4.82,0.131 5.348,0 5.926,0 6.51,0 7.032,0.143 7.417,0.355 7.794,0.55 8.3,0.668 8.856,0.668 9.429,0.668 9.938,0.553 10.319,0.348 10.702,0.137 11.235,0 11.817,0 v -0.951 c -0.582,0 -1.115,0.137 -1.498,0.348 -0.381,0.205 -0.89,0.32 -1.463,0.32 -0.556,0 -1.062,-0.118 -1.439,-0.313 -0.385,-0.211 -0.907,-0.355 -1.491,-0.355 -0.578,0 -1.106,0.132 -1.489,0.339 -0.381,0.205 -0.91,0.329 -1.481,0.329 -0.569,0 -1.086,-0.124 -1.467,-0.326 C 1.106,-0.822 0.592,-0.951 0.007,-0.951 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.3511,4.6354)",
    id: "g1358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1360",
    style: {
      fill: "#bcbab9",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0.586,0 1.106,0.128 1.489,0.341 0.381,0.203 0.898,0.327 1.467,0.327 0.571,0 1.1,-0.125 1.481,-0.329 C 4.82,0.131 5.348,0 5.926,0 6.51,0 7.032,0.144 7.417,0.355 7.794,0.549 8.3,0.668 8.856,0.668 9.429,0.668 9.938,0.552 10.319,0.348 10.702,0.136 11.235,0 11.817,0 v -0.951 c -0.582,0 -1.115,0.137 -1.498,0.347 -0.381,0.206 -0.89,0.321 -1.463,0.321 -0.556,0 -1.062,-0.118 -1.439,-0.313 -0.385,-0.212 -0.907,-0.355 -1.491,-0.355 -0.578,0 -1.106,0.132 -1.489,0.339 -0.381,0.204 -0.91,0.329 -1.481,0.329 -0.569,0 -1.086,-0.124 -1.467,-0.326 C 1.106,-0.823 0.592,-0.951 0.007,-0.951 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.3511,4.6354)",
    id: "g1362"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1364",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0.586,0 1.106,0.128 1.489,0.341 0.381,0.203 0.898,0.327 1.467,0.327 0.571,0 1.1,-0.125 1.481,-0.329 C 4.82,0.131 5.348,0 5.926,0 6.51,0 7.032,0.144 7.417,0.355 7.794,0.549 8.3,0.668 8.856,0.668 9.429,0.668 9.938,0.552 10.319,0.348 10.702,0.136 11.235,0 11.817,0 v -0.951 c -0.582,0 -1.115,0.137 -1.498,0.347 -0.381,0.206 -0.89,0.321 -1.463,0.321 -0.556,0 -1.062,-0.118 -1.439,-0.313 -0.385,-0.212 -0.907,-0.355 -1.491,-0.355 -0.578,0 -1.106,0.132 -1.489,0.339 -0.381,0.204 -0.91,0.329 -1.481,0.329 -0.569,0 -1.086,-0.124 -1.467,-0.326 C 1.106,-0.823 0.592,-0.951 0.007,-0.951 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.3511,3.6843)",
    id: "g1366"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1368",
    style: {
      fill: "#0044ae",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0.586,0 1.106,0.128 1.489,0.342 0.381,0.202 0.898,0.326 1.467,0.326 0.571,0 1.1,-0.125 1.481,-0.329 C 4.82,0.132 5.348,0 5.926,0 6.51,0 7.032,0.144 7.417,0.355 7.794,0.55 8.3,0.668 8.856,0.668 9.429,0.668 9.938,0.553 10.319,0.348 10.702,0.137 11.235,0 11.817,0 v -0.951 c -0.582,0 -1.115,0.137 -1.498,0.348 -0.381,0.206 -0.89,0.321 -1.463,0.321 -0.556,0 -1.062,-0.119 -1.439,-0.313 -0.385,-0.212 -0.907,-0.356 -1.491,-0.356 -0.578,0 -1.106,0.131 -1.489,0.34 -0.381,0.204 -0.91,0.329 -1.481,0.329 -0.569,0 -1.086,-0.125 -1.467,-0.327 C 1.106,-0.822 0.592,-0.951 0.007,-0.951 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.3511,3.6843)",
    id: "g1370"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1372",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0.586,0 1.106,0.128 1.489,0.342 0.381,0.202 0.898,0.326 1.467,0.326 0.571,0 1.1,-0.125 1.481,-0.329 C 4.82,0.132 5.348,0 5.926,0 6.51,0 7.032,0.144 7.417,0.355 7.794,0.55 8.3,0.668 8.856,0.668 9.429,0.668 9.938,0.553 10.319,0.348 10.702,0.137 11.235,0 11.817,0 v -0.951 c -0.582,0 -1.115,0.137 -1.498,0.348 -0.381,0.206 -0.89,0.321 -1.463,0.321 -0.556,0 -1.062,-0.119 -1.439,-0.313 -0.385,-0.212 -0.907,-0.356 -1.491,-0.356 -0.578,0 -1.106,0.131 -1.489,0.34 -0.381,0.204 -0.91,0.329 -1.481,0.329 -0.569,0 -1.086,-0.125 -1.467,-0.327 C 1.106,-0.822 0.592,-0.951 0.007,-0.951 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.3584,1.7834)",
    id: "g1374"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1376",
    style: {
      fill: "#bcbab9",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0.585,0 1.099,0.128 1.481,0.341 1.863,0.544 2.38,0.668 2.948,0.668 3.52,0.668 4.048,0.543 4.43,0.338 4.812,0.131 5.341,0 5.918,0 6.502,0 7.024,0.143 7.409,0.355 7.787,0.549 8.292,0.668 8.849,0.668 9.421,0.668 9.93,0.552 10.312,0.347 10.695,0.136 11.228,0 11.81,0 v 0.946 c -0.582,0 -1.115,0.141 -1.498,0.352 C 9.93,1.503 9.421,1.619 8.849,1.619 8.292,1.619 7.787,1.5 7.409,1.306 7.024,1.094 6.502,0.95 5.918,0.95 5.341,0.95 4.812,1.081 4.43,1.29 4.048,1.494 3.52,1.619 2.948,1.619 2.38,1.619 1.863,1.494 1.481,1.292 1.099,1.079 0.579,0.95 -0.007,0.95 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.3584,1.7834)",
    id: "g1378"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1380",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0.585,0 1.099,0.128 1.481,0.341 1.863,0.544 2.38,0.668 2.948,0.668 3.52,0.668 4.048,0.543 4.43,0.338 4.812,0.131 5.341,0 5.918,0 6.502,0 7.024,0.143 7.409,0.355 7.787,0.549 8.292,0.668 8.849,0.668 9.421,0.668 9.93,0.552 10.312,0.347 10.695,0.136 11.228,0 11.81,0 v 0.946 c -0.582,0 -1.115,0.141 -1.498,0.352 C 9.93,1.503 9.421,1.619 8.849,1.619 8.292,1.619 7.787,1.5 7.409,1.306 7.024,1.094 6.502,0.95 5.918,0.95 5.341,0.95 4.812,1.081 4.43,1.29 4.048,1.494 3.52,1.619 2.948,1.619 2.38,1.619 1.863,1.494 1.481,1.292 1.099,1.079 0.579,0.95 -0.007,0.95 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.3584,0.8322)",
    id: "g1382"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1384",
    style: {
      fill: "#0044ae",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0.585,0 1.099,0.128 1.481,0.342 1.863,0.544 2.38,0.668 2.948,0.668 3.52,0.668 4.048,0.543 4.43,0.339 4.812,0.131 5.341,0 5.918,0 6.502,0 7.024,0.143 7.409,0.355 7.787,0.549 8.292,0.668 8.849,0.668 9.421,0.668 9.93,0.553 10.312,0.347 10.695,0.136 11.228,0 11.81,0 v 0.942 c -0.582,0 -1.115,0.145 -1.498,0.356 C 9.93,1.503 9.421,1.619 8.849,1.619 8.292,1.619 7.787,1.5 7.409,1.306 7.024,1.094 6.502,0.951 5.918,0.951 5.341,0.951 4.812,1.082 4.43,1.29 4.048,1.494 3.52,1.619 2.948,1.619 2.38,1.619 1.863,1.495 1.481,1.292 1.099,1.08 0.58,0.951 -0.005,0.951 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.3584,0.8322)",
    id: "g1386"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1388",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0.585,0 1.099,0.128 1.481,0.342 1.863,0.544 2.38,0.668 2.948,0.668 3.52,0.668 4.048,0.543 4.43,0.339 4.812,0.131 5.341,0 5.918,0 6.502,0 7.024,0.143 7.409,0.355 7.787,0.549 8.292,0.668 8.849,0.668 9.421,0.668 9.93,0.553 10.312,0.347 10.695,0.136 11.228,0 11.81,0 v 0.942 c -0.582,0 -1.115,0.145 -1.498,0.356 C 9.93,1.503 9.421,1.619 8.849,1.619 8.292,1.619 7.787,1.5 7.409,1.306 7.024,1.094 6.502,0.951 5.918,0.951 5.341,0.951 4.812,1.082 4.43,1.29 4.048,1.494 3.52,1.619 2.948,1.619 2.38,1.619 1.863,1.495 1.481,1.292 1.099,1.08 0.58,0.951 -0.005,0.951 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.5899,9.4904)",
    id: "g1390"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1392",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -0.02,-0.079 -0.047,-0.158 -0.047,-0.244 0,-0.576 0.479,-1.038 1.064,-1.038 h -8.698 c 0.585,0 1.065,0.462 1.065,1.038 0,0.085 -0.016,0.166 -0.034,0.244 0.048,-0.017 0.108,-0.02 0.165,-0.02 h 6.33 c 0.051,0 0.11,0.006 0.155,0.02"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.5899,9.4904)",
    id: "g1394"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1396",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -0.02,-0.079 -0.047,-0.158 -0.047,-0.244 0,-0.576 0.479,-1.038 1.064,-1.038 h -8.698 c 0.585,0 1.065,0.462 1.065,1.038 0,0.085 -0.016,0.166 -0.034,0.244 0.048,-0.017 0.108,-0.02 0.165,-0.02 h 6.33 c 0.051,0 0.11,0.006 0.155,0.02 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.1045,10.0881)",
    id: "g1398"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1400",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 h 6.33 c 0.213,0 0.387,-0.138 0.387,-0.309 0,-0.17 -0.174,-0.309 -0.387,-0.309 H 0 c -0.214,0 -0.388,0.139 -0.388,0.309 C -0.388,-0.138 -0.214,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.1045,10.0881)",
    id: "g1402"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1404",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 h 6.33 c 0.213,0 0.387,-0.138 0.387,-0.309 0,-0.17 -0.174,-0.309 -0.387,-0.309 H 0 c -0.214,0 -0.388,0.139 -0.388,0.309 C -0.388,-0.138 -0.214,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path1406",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 59.919,8.209 h 8.677 V 5.91 h -8.677 z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.2735,18.238)",
    id: "g1408"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1410",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0.859,-0.517 1.441,-1.045 1.347,-1.308 1.301,-1.551 1.027,-1.732 0.638,-1.999 0.024,-2.444 -0.349,-3.237 -0.057,-3.604 c -0.507,0.427 -0.828,1.062 -0.828,1.771 0,0.74 0.339,1.406 0.885,1.833"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.2735,18.238)",
    id: "g1412"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1414",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0.859,-0.517 1.441,-1.045 1.347,-1.308 1.301,-1.551 1.027,-1.732 0.638,-1.999 0.024,-2.444 -0.349,-3.237 -0.057,-3.604 c -0.507,0.427 -0.828,1.062 -0.828,1.771 0,0.74 0.339,1.406 0.885,1.833 z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path1416",
    style: {
      fill: "#bcbab9",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 67.353,41.887 H 61.188 V 10.463 h 6.165 z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1418"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath1424)",
    id: "g1420"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.6602,42.6638)",
    id: "g1426"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1428",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -33.109"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.3521,42.6638)",
    id: "g1430"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1432",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -33.109"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1434"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath1440)",
    id: "g1436"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1442",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 67.353,41.887 H 61.188 V 10.463 h 6.165 z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.8911,30.1325)",
    id: "g1444"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1446",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 1.346,0.579 3.633,1.008 6.256,1.098 7.161,1.089 8.168,1.002 9.209,0.821 c 3.688,-0.64 6.495,-2.172 6.273,-3.42 -0.005,-0.024 -0.012,-0.08 -0.019,-0.105 0,0 1.383,3.243 1.405,3.365 C 17.116,2.047 13.999,3.746 9.906,4.458 8.622,4.681 7.369,4.766 6.281,4.754 3.664,4.754 1.388,4.406 0.018,3.877 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.8911,30.1325)",
    id: "g1448"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1450",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 1.346,0.579 3.633,1.008 6.256,1.098 7.161,1.089 8.168,1.002 9.209,0.821 c 3.688,-0.64 6.495,-2.172 6.273,-3.42 -0.005,-0.024 -0.012,-0.08 -0.019,-0.105 0,0 1.383,3.243 1.405,3.365 C 17.116,2.047 13.999,3.746 9.906,4.458 8.622,4.681 7.369,4.766 6.281,4.754 3.664,4.754 1.388,4.406 0.018,3.877 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.3628,26.1877)",
    id: "g1452"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1454",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 1.709,0.127 2.877,0.603 3.01,1.346 3.117,1.939 2.537,2.596 1.506,3.191 1.044,3.139 0.526,3.074 -0.01,3.073 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.3628,26.1877)",
    id: "g1456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1458",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 1.709,0.127 2.877,0.603 3.01,1.346 3.117,1.939 2.537,2.596 1.506,3.191 1.044,3.139 0.526,3.074 -0.01,3.073 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.1768,28.5891)",
    id: "g1460"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1462",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C -1.067,-0.167 -1.869,-0.442 -2.27,-0.783 L -2.305,-0.851 C -2.497,-1.257 -1.558,-2.122 0.01,-3.087 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.1768,28.5891)",
    id: "g1464"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1466",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C -1.067,-0.167 -1.869,-0.442 -2.27,-0.783 L -2.305,-0.851 C -2.497,-1.257 -1.558,-2.122 0.01,-3.087 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.1909,20.1257)",
    id: "g1468"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1470",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0.163,0.509 -1.503,1.523 -3.859,2.423 -1.078,0.401 -1.966,0.82 -3.068,1.326 -3.273,1.503 -5.69,3.233 -5.392,3.863 l 0.032,0.065 c -0.173,-0.147 -0.444,-3.251 -0.444,-3.251 -0.299,-0.579 1.914,-2.28 4.927,-3.783 0.964,-0.481 3.001,-1.263 3.963,-1.613 1.717,-0.622 3.426,-1.792 3.271,-2.225 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.1909,20.1257)",
    id: "g1472"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1474",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0.163,0.509 -1.503,1.523 -3.859,2.423 -1.078,0.401 -1.966,0.82 -3.068,1.326 -3.273,1.503 -5.69,3.233 -5.392,3.863 l 0.032,0.065 c -0.173,-0.147 -0.444,-3.251 -0.444,-3.251 -0.299,-0.579 1.914,-2.28 4.927,-3.783 0.964,-0.481 3.001,-1.263 3.963,-1.613 1.717,-0.622 3.426,-1.792 3.271,-2.225 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.7124,31.4802)",
    id: "g1476"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1478",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0.233,0.921 0.535,1.812 0.831,2.711 0.765,2.693 0.695,2.679 0.628,2.668 0.562,2.658 0.49,2.651 0.423,2.648 0.282,2.001 0.091,1.351 -0.113,0.702 -0.477,1.27 -0.875,1.821 -1.189,2.396 -1.317,2.369 -1.448,2.338 -1.576,2.318 -1.705,2.297 -1.839,2.288 -1.969,2.275 c 0.551,-0.769 1.083,-1.536 1.592,-2.333 0.061,0.016 0.121,0.037 0.188,0.048 C -0.127,0 -0.063,-0.002 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.0557,34.1735)",
    id: "g1480"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1482",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -0.112,-0.005 -0.225,-0.015 -0.336,-0.013 -0.113,0.003 -0.225,0.015 -0.336,0.025 l -0.045,-2.531 1.7,-0.029 c -0.008,0.051 -0.021,0.108 -0.02,0.159 0.001,0.053 0.015,0.108 0.025,0.16 C 0.683,-2.25 0.351,-2.27 -0.04,-2.263 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.7261,33.757)",
    id: "g1484"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1486",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0.273,-0.023 0.534,-0.072 0.795,-0.121 0.791,-0.068 0.782,-0.016 0.787,0.04 0.792,0.092 0.81,0.143 0.823,0.194 L -1.478,0.393 C -1.473,0.34 -1.464,0.287 -1.469,0.235 -1.474,0.18 -1.492,0.129 -1.505,0.078 c 0.234,0.005 0.518,0.007 0.835,-0.02 l -0.202,-2.277 c 0.113,-0.002 0.226,-0.001 0.337,-0.01 0.112,-0.01 0.223,-0.031 0.334,-0.048 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.8599,33.4025)",
    id: "g1488"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1490",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0.267,-0.061 0.601,-0.106 0.601,-0.423 0,-0.08 -0.009,-0.135 -0.021,-0.186 -0.087,-0.373 -0.357,-0.502 -0.807,-0.362 z m -1.191,-2.14 c 0.111,-0.017 0.222,-0.031 0.332,-0.056 0.109,-0.025 0.215,-0.061 0.323,-0.093 l 0.273,1.163 0.03,-0.007 c 0.064,-0.159 0.147,-0.354 0.19,-0.467 L 0.299,-2.479 C 0.432,-2.501 0.565,-2.521 0.697,-2.55 0.832,-2.581 0.96,-2.622 1.09,-2.659 l -0.118,0.263 c -0.183,0.397 -0.376,0.792 -0.535,1.194 0.423,-0.02 0.751,0.142 0.834,0.496 0.058,0.247 -0.035,0.44 -0.259,0.605 C 0.848,0.021 0.526,0.086 0.321,0.133 l -0.93,0.212 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.3677,31.1574)",
    id: "g1492"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1494",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 0.804,0.542 0.71,-0.405 Z M 0.685,-0.652 C 0.664,-0.927 0.617,-1.192 0.567,-1.481 0.683,-1.539 0.798,-1.591 0.91,-1.655 1.023,-1.72 1.126,-1.792 1.235,-1.861 L 1.461,0.992 C 1.408,1.014 1.359,1.038 1.308,1.066 1.258,1.095 1.213,1.125 1.167,1.16 l -2.418,-1.598 c 0.064,-0.033 0.13,-0.062 0.192,-0.097 0.062,-0.035 0.117,-0.075 0.177,-0.113 0.204,0.18 0.418,0.324 0.662,0.511 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.4566,56.9772)",
    id: "g1496"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1498",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.018,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.447 0.368,0.81 0.823,0.81 1.277,0.81 1.645,0.447 1.645,0 1.645,-0.448 1.277,-0.811 0.823,-0.811 0.368,-0.811 0,-0.448 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.731,63.9694)",
    id: "g1500"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1502",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 2.52,0 4.761,-0.386 6.222,-0.991 0.836,-0.391 1.958,-0.681 3.186,-0.851 0.935,-0.13 1.825,-0.157 2.598,-0.097 1.035,0.021 2.531,-0.293 4.026,-0.98 1.239,-0.569 2.272,-1.266 2.96,-1.939 l -0.596,-0.551 -0.171,-1.563 -1.629,-1.944 -0.815,-0.718 -1.93,-1.606 -0.986,-0.085 -0.301,-0.887 -12.483,1.521 -12.521,-1.521 -0.301,0.887 -0.986,0.085 -1.93,1.606 -0.815,0.718 -1.629,1.944 -0.172,1.563 -0.595,0.551 c 0.688,0.673 1.722,1.37 2.96,1.939 1.496,0.687 2.991,1.001 4.026,0.98 0.774,-0.06 1.662,-0.033 2.598,0.097 1.228,0.17 2.35,0.46 3.185,0.851 C -4.636,-0.386 -2.52,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.731,63.9694)",
    id: "g1504"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1506",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 2.52,0 4.761,-0.386 6.222,-0.991 0.836,-0.391 1.958,-0.681 3.186,-0.851 0.935,-0.13 1.825,-0.157 2.598,-0.097 1.035,0.021 2.531,-0.293 4.026,-0.98 1.239,-0.569 2.272,-1.266 2.96,-1.939 l -0.596,-0.551 -0.171,-1.563 -1.629,-1.944 -0.815,-0.718 -1.93,-1.606 -0.986,-0.085 -0.301,-0.887 -12.483,1.521 -12.521,-1.521 -0.301,0.887 -0.986,0.085 -1.93,1.606 -0.815,0.718 -1.629,1.944 -0.172,1.563 -0.595,0.551 c 0.688,0.673 1.722,1.37 2.96,1.939 1.496,0.687 2.991,1.001 4.026,0.98 0.774,-0.06 1.662,-0.033 2.598,0.097 1.228,0.17 2.35,0.46 3.185,0.851 C -4.636,-0.386 -2.52,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.8897,50.8034)",
    id: "g1508"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1510",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -4.707,-0.01 -8.932,-0.624 -11.905,-1.576 0.247,0.121 0.224,0.438 -0.083,1.262 -0.37,0.995 -0.95,0.953 -0.95,0.953 3.287,1.011 7.865,1.642 12.958,1.65 5.094,-0.008 9.708,-0.639 12.995,-1.65 0,0 -0.579,0.042 -0.95,-0.953 C 11.758,-1.138 11.736,-1.455 11.982,-1.576 9.009,-0.624 4.707,-0.01 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.8897,50.8034)",
    id: "g1512"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1514",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -4.707,-0.01 -8.932,-0.624 -11.905,-1.576 0.247,0.121 0.224,0.438 -0.083,1.262 -0.37,0.995 -0.95,0.953 -0.95,0.953 3.287,1.011 7.865,1.642 12.958,1.65 5.094,-0.008 9.708,-0.639 12.995,-1.65 0,0 -0.579,0.042 -0.95,-0.953 C 11.758,-1.138 11.736,-1.455 11.982,-1.576 9.009,-0.624 4.707,-0.01 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.9097,53.0895)",
    id: "g1516"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1518",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -5.093,-0.008 -9.671,-0.639 -12.958,-1.65 -0.219,-0.07 -0.45,0.02 -0.521,0.236 -0.072,0.216 0.047,0.464 0.266,0.535 C -9.911,0.175 -5.218,0.837 0,0.845 5.219,0.837 9.932,0.175 13.234,-0.879 13.452,-0.95 13.571,-1.198 13.5,-1.414 13.429,-1.63 13.197,-1.72 12.978,-1.65 9.69,-0.639 5.094,-0.008 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.9097,53.0895)",
    id: "g1520"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1522",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -5.093,-0.008 -9.671,-0.639 -12.958,-1.65 -0.219,-0.07 -0.45,0.02 -0.521,0.236 -0.072,0.216 0.047,0.464 0.266,0.535 C -9.911,0.175 -5.218,0.837 0,0.845 5.219,0.837 9.932,0.175 13.234,-0.879 13.452,-0.95 13.571,-1.198 13.5,-1.414 13.429,-1.63 13.197,-1.72 12.978,-1.65 9.69,-0.639 5.094,-0.008 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.9209,46.8224)",
    id: "g1524"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1526",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -4.649,0.007 -8.816,0.581 -11.79,1.511 -0.217,0.07 -0.332,0.278 -0.318,0.492 C -12.112,2.209 -12,2.4 -11.79,2.468 -8.816,3.398 -4.649,3.972 0,3.979 4.651,3.972 8.813,3.398 11.787,2.468 11.997,2.4 12.11,2.209 12.107,2.003 12.118,1.789 12.004,1.581 11.787,1.511 8.813,0.581 4.651,0.007 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.9209,46.8224)",
    id: "g1528"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1530",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -4.649,0.007 -8.816,0.581 -11.79,1.511 -0.217,0.07 -0.332,0.278 -0.318,0.492 C -12.112,2.209 -12,2.4 -11.79,2.468 -8.816,3.398 -4.649,3.972 0,3.979 4.651,3.972 8.813,3.398 11.787,2.468 11.997,2.4 12.11,2.209 12.107,2.003 12.118,1.789 12.004,1.581 11.787,1.511 8.813,0.581 4.651,0.007 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.9102,47.4557)",
    id: "g1532"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1534",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C -4.197,0.007 -7.991,0.511 -10.879,1.288 -7.991,2.066 -4.197,2.542 0,2.548 4.197,2.542 8.011,2.066 10.898,1.288 8.011,0.511 4.197,0.007 0,0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1536"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath1542)",
    id: "g1538"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.9766,50.5578)",
    id: "g1544"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1546",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.039,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -5.228"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.3174,50.5578)",
    id: "g1548"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1550",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.081,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -5.228"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.6929,50.5578)",
    id: "g1552"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1554",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -5.228"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.0762,50.5578)",
    id: "g1556"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1558",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.121,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -5.228"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.5259,50.5578)",
    id: "g1560"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1562",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -5.228"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.9761,50.5578)",
    id: "g1564"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1566",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.17,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -5.228"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.4624,50.5578)",
    id: "g1568"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1570",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.17,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -5.228"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.9854,50.5944)",
    id: "g1572"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1574",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.19400001,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -5.229"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.5083,50.5944)",
    id: "g1576"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1578",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.19400001,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -5.229"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.0747,50.5944)",
    id: "g1580"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1582",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.219,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -5.229"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.6348,50.5944)",
    id: "g1584"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1586",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.219,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -5.229"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.1949,50.5944)",
    id: "g1588"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1590",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.219,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -5.229"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.7549,50.5944)",
    id: "g1592"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1594",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.243,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -5.229"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.3145,50.5944)",
    id: "g1596"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1598",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.26699999,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -5.229"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.8745,50.5944)",
    id: "g1600"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1602",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.292,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -5.229"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.4034,50.5944)",
    id: "g1604"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1606",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.31600001,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -5.229"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.9273,50.5944)",
    id: "g1608"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1610",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.31600001,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -5.229"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.4497,50.5944)",
    id: "g1612"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1614",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.34,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -5.229"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.0093,50.6306)",
    id: "g1616"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1618",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.36399999,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -5.228"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.5332,50.6306)",
    id: "g1620"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1622",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.389,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -5.228"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.0562,50.6306)",
    id: "g1624"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1626",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.41299999,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -5.228"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.5796,50.6306)",
    id: "g1628"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1630",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.486,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -5.228"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.6685,50.5578)",
    id: "g1632"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1634",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.03,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -5.228"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.4971,50.5578)",
    id: "g1636"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1638",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.03,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -5.228"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.6158,50.5578)",
    id: "g1640"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1642",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.03,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -5.228"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1644"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath1650)",
    id: "g1646"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.9102,47.4557)",
    id: "g1652"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1654",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C -4.197,0.007 -7.991,0.511 -10.879,1.288 -7.991,2.066 -4.197,2.542 0,2.548 4.197,2.542 8.011,2.066 10.898,1.288 8.011,0.511 4.197,0.007 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.2759,51.8849)",
    id: "g1656"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1658",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.416,0.41 0.646,0.41 0.832,0.227 0.832,0 0.832,-0.226 0.646,-0.41 0.416,-0.41 0.187,-0.41 0,-0.226 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.2759,51.8849)",
    id: "g1660"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1662",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.416,0.41 0.646,0.41 0.832,0.227 0.832,0 0.832,-0.226 0.646,-0.41 0.416,-0.41 0.187,-0.41 0,-0.226 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.9195,51.5641)",
    id: "g1664"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1666",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 h -1.246 c -0.23,0 -0.421,0.183 -0.421,0.409 0,0.227 0.186,0.41 0.416,0.41 H 0 1.268 c 0.229,0 0.416,-0.183 0.416,-0.41 C 1.684,0.183 1.492,0 1.263,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.9195,51.5641)",
    id: "g1668"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1670",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 h -1.246 c -0.23,0 -0.421,0.183 -0.421,0.409 0,0.227 0.186,0.41 0.416,0.41 H 0 1.268 c 0.229,0 0.416,-0.183 0.416,-0.41 C 1.684,0.183 1.492,0 1.263,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.6582,51.2067)",
    id: "g1672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1674",
    style: {
      fill: "#006f46",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 -0.896,-0.108 c -0.228,-0.028 -0.441,0.131 -0.469,0.356 -0.028,0.224 0.134,0.428 0.362,0.456 l 0.901,0.109 0.918,0.111 C 1.044,0.952 1.251,0.792 1.279,0.567 1.307,0.343 1.14,0.138 0.913,0.11 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.6582,51.2067)",
    id: "g1676"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1678",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 -0.896,-0.108 c -0.228,-0.028 -0.441,0.131 -0.469,0.356 -0.028,0.224 0.134,0.428 0.362,0.456 l 0.901,0.109 0.918,0.111 C 1.044,0.952 1.251,0.792 1.279,0.567 1.307,0.343 1.14,0.138 0.913,0.11 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.0147,51.1242)",
    id: "g1680"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1682",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.417,0.41 0.646,0.41 0.832,0.227 0.832,0 0.832,-0.226 0.646,-0.409 0.417,-0.409 0.187,-0.409 0,-0.226 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.0147,51.1242)",
    id: "g1684"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1686",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.417,0.41 0.646,0.41 0.832,0.227 0.832,0 0.832,-0.226 0.646,-0.409 0.417,-0.409 0.187,-0.409 0,-0.226 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.2432,50.381)",
    id: "g1688"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1690",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 0.462,0.627 1.74,0.46 0.718,-0.315 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.2432,50.381)",
    id: "g1692"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1694",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 0.462,0.627 1.74,0.46 0.718,-0.315 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.1812,51.2067)",
    id: "g1696"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1698",
    style: {
      fill: "#006f46",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 0.896,-0.108 C 1.125,-0.136 1.337,0.023 1.365,0.248 1.393,0.472 1.231,0.676 1.003,0.704 L 0.102,0.813 -0.816,0.924 C -1.044,0.952 -1.251,0.792 -1.28,0.567 -1.308,0.343 -1.14,0.138 -0.912,0.11 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.1812,51.2067)",
    id: "g1700"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1702",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 0.896,-0.108 C 1.125,-0.136 1.337,0.023 1.365,0.248 1.393,0.472 1.231,0.676 1.003,0.704 L 0.102,0.813 -0.816,0.924 C -1.044,0.952 -1.251,0.792 -1.28,0.567 -1.308,0.343 -1.14,0.138 -0.912,0.11 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.732,51.8849)",
    id: "g1704"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1706",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.227 0.186,0.41 0.416,0.41 0.645,0.41 0.831,0.227 0.831,0 0.831,-0.226 0.645,-0.41 0.416,-0.41 0.186,-0.41 0,-0.226 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.732,51.8849)",
    id: "g1708"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1710",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.227 0.186,0.41 0.416,0.41 0.645,0.41 0.831,0.227 0.831,0 0.831,-0.226 0.645,-0.41 0.416,-0.41 0.186,-0.41 0,-0.226 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.9927,51.1242)",
    id: "g1712"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1714",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.416,0.41 0.646,0.41 0.832,0.227 0.832,0 0.832,-0.226 0.646,-0.409 0.416,-0.409 0.187,-0.409 0,-0.226 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.9927,51.1242)",
    id: "g1716"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1718",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.416,0.41 0.646,0.41 0.832,0.227 0.832,0 0.832,-0.226 0.646,-0.409 0.416,-0.409 0.187,-0.409 0,-0.226 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.5962,50.381)",
    id: "g1720"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1722",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 -0.462,0.627 -1.74,0.46 -0.719,-0.315 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.5962,50.381)",
    id: "g1724"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1726",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 -0.462,0.627 -1.74,0.46 -0.719,-0.315 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.5293,48.6047)",
    id: "g1728"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1730",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 2.941,0.859 6.938,1.392 11.381,1.399 15.824,1.392 19.84,0.859 22.781,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.5103,60.5383)",
    id: "g1732"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1734",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 0.526,-0.438 0.789,1.341 c -0.855,0.544 -1.442,1.493 -1.442,2.571 0,0.122 0.006,0.241 0.02,0.359 0.082,1.711 2.087,3.125 4.629,3.125 1.322,0 2.513,-0.376 3.353,-0.979 0.022,0.266 0.044,0.493 0.081,0.734 -0.925,0.56 -2.123,0.899 -3.434,0.899 -2.923,0 -5.212,-1.73 -5.324,-3.779 -0.011,-0.118 -0.016,-0.238 -0.016,-0.359 0,-1.092 0.48,-2.075 1.237,-2.759 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.5103,60.5383)",
    id: "g1736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1738",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 0.526,-0.438 0.789,1.341 c -0.855,0.544 -1.442,1.493 -1.442,2.571 0,0.122 0.006,0.241 0.02,0.359 0.082,1.711 2.087,3.125 4.629,3.125 1.322,0 2.513,-0.376 3.353,-0.979 0.022,0.266 0.044,0.493 0.081,0.734 -0.925,0.56 -2.123,0.899 -3.434,0.899 -2.923,0 -5.212,-1.73 -5.324,-3.779 -0.011,-0.118 -0.016,-0.238 -0.016,-0.359 0,-1.092 0.48,-2.075 1.237,-2.759 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.545,60.5236)",
    id: "g1740"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1742",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -0.999,0.774 -1.618,1.828 -1.618,2.989 0,1.335 0.839,2.528 2.115,3.318 C -0.289,5.649 -0.768,4.798 -0.836,3.848 -0.848,3.729 -0.853,3.609 -0.853,3.488 c 0,-1.092 0.48,-2.074 1.237,-2.758 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.545,60.5236)",
    id: "g1744"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1746",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -0.999,0.774 -1.618,1.828 -1.618,2.989 0,1.335 0.839,2.528 2.115,3.318 C -0.289,5.649 -0.768,4.798 -0.836,3.848 -0.848,3.729 -0.853,3.609 -0.853,3.488 c 0,-1.092 0.48,-2.074 1.237,-2.758 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.7378,59.1691)",
    id: "g1748"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1750",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -0.56,0.651 -0.901,1.494 -0.901,2.413 0,0.558 0.124,1.087 0.346,1.562 0.809,1.731 3.341,2.988 6.354,2.988 0.821,0 1.606,-0.094 2.33,-0.265 C 7.968,6.515 7.842,6.315 7.719,6.115 7.117,6.236 6.471,6.302 5.799,6.302 3.042,6.302 0.735,5.187 0.067,3.68 -0.111,3.293 -0.211,2.865 -0.211,2.413 -0.211,1.499 0.201,0.678 0.848,0.118 L -0.15,-1.58 -0.687,-1.137 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.7378,59.1691)",
    id: "g1752"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1754",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -0.56,0.651 -0.901,1.494 -0.901,2.413 0,0.558 0.124,1.087 0.346,1.562 0.809,1.731 3.341,2.988 6.354,2.988 0.821,0 1.606,-0.094 2.33,-0.265 C 7.968,6.515 7.842,6.315 7.719,6.115 7.117,6.236 6.471,6.302 5.799,6.302 3.042,6.302 0.735,5.187 0.067,3.68 -0.111,3.293 -0.211,2.865 -0.211,2.413 -0.211,1.499 0.201,0.678 0.848,0.118 L -0.15,-1.58 -0.687,-1.137 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.7603,64.8542)",
    id: "g1756"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1758",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -0.726,-0.475 -1.273,-1.059 -1.578,-1.71 -0.221,-0.476 -0.346,-1.004 -0.346,-1.562 0,-0.919 0.342,-1.762 0.902,-2.413 l -0.606,-1.023 c -0.58,0.776 -0.917,1.68 -0.917,2.644 0,1.657 1.014,3.106 2.545,4.064"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.7603,64.8542)",
    id: "g1760"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1762",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -0.726,-0.475 -1.273,-1.059 -1.578,-1.71 -0.221,-0.476 -0.346,-1.004 -0.346,-1.562 0,-0.919 0.342,-1.762 0.902,-2.413 l -0.606,-1.023 c -0.58,0.776 -0.917,1.68 -0.917,2.644 0,1.657 1.014,3.106 2.545,4.064 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.8784,68.4909)",
    id: "g1764"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1766",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0.667,0 1.242,-0.459 1.378,-1.076 0.09,-0.546 0.147,-1.167 0.158,-1.828 0.002,-0.068 -0.003,-0.135 -0.003,-0.202 0,-0.081 0.015,-0.163 0.016,-0.246 0.025,-1.385 0.215,-2.61 0.486,-3.359 l -2.036,-2.027 -2.058,2.027 c 0.272,0.749 0.462,1.974 0.487,3.359 0.001,0.083 0.015,0.165 0.016,0.246 0,0.067 -0.005,0.134 -0.003,0.202 0.011,0.661 0.068,1.282 0.157,1.828 C -1.265,-0.459 -0.667,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.8784,68.4909)",
    id: "g1768"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1770",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0.667,0 1.242,-0.459 1.378,-1.076 0.09,-0.546 0.147,-1.167 0.158,-1.828 0.002,-0.068 -0.003,-0.135 -0.003,-0.202 0,-0.081 0.015,-0.163 0.016,-0.246 0.025,-1.385 0.215,-2.61 0.486,-3.359 l -2.036,-2.027 -2.058,2.027 c 0.272,0.749 0.462,1.974 0.487,3.359 0.001,0.083 0.015,0.165 0.016,0.246 0,0.067 -0.005,0.134 -0.003,0.202 0.011,0.661 0.068,1.282 0.157,1.828 C -1.265,-0.459 -0.667,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.8784,67.8307)",
    id: "g1772"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1774",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0.346,0 0.64,-0.23 0.71,-0.55 0.795,-1.065 0.848,-1.653 0.859,-2.277 0.86,-2.341 0.855,-2.405 0.856,-2.468 c 0,-0.077 0.015,-0.154 0.016,-0.233 0.023,-1.309 0.202,-2.466 0.46,-3.174 l -1.344,-1.324 -1.342,1.324 c 0.256,0.708 0.436,1.865 0.459,3.174 0.002,0.079 0.015,0.156 0.015,0.233 0.001,0.063 -0.003,0.127 -0.003,0.191 0.011,0.624 0.065,1.212 0.149,1.727 C -0.663,-0.23 -0.347,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.8784,67.8307)",
    id: "g1776"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1778",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0.346,0 0.64,-0.23 0.71,-0.55 0.795,-1.065 0.848,-1.653 0.859,-2.277 0.86,-2.341 0.855,-2.405 0.856,-2.468 c 0,-0.077 0.015,-0.154 0.016,-0.233 0.023,-1.309 0.202,-2.466 0.46,-3.174 l -1.344,-1.324 -1.342,1.324 c 0.256,0.708 0.436,1.865 0.459,3.174 0.002,0.079 0.015,0.156 0.015,0.233 0.001,0.063 -0.003,0.127 -0.003,0.191 0.011,0.624 0.065,1.212 0.149,1.727 C -0.663,-0.23 -0.347,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.23,60.5383)",
    id: "g1780"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1782",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 -0.526,-0.438 -0.789,1.341 c 0.856,0.544 1.443,1.493 1.443,2.571 0,0.122 -0.007,0.241 -0.021,0.359 -0.082,1.711 -2.087,3.125 -4.629,3.125 -1.322,0 -2.513,-0.376 -3.352,-0.979 -0.022,0.266 -0.045,0.493 -0.081,0.734 0.924,0.56 2.122,0.899 3.433,0.899 2.924,0 5.212,-1.73 5.324,-3.779 C 0.813,3.715 0.818,3.595 0.818,3.474 0.818,2.382 0.339,1.399 -0.419,0.715 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.23,60.5383)",
    id: "g1784"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1786",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 -0.526,-0.438 -0.789,1.341 c 0.856,0.544 1.443,1.493 1.443,2.571 0,0.122 -0.007,0.241 -0.021,0.359 -0.082,1.711 -2.087,3.125 -4.629,3.125 -1.322,0 -2.513,-0.376 -3.352,-0.979 -0.022,0.266 -0.045,0.493 -0.081,0.734 0.924,0.56 2.122,0.899 3.433,0.899 2.924,0 5.212,-1.73 5.324,-3.779 C 0.813,3.715 0.818,3.595 0.818,3.474 0.818,2.382 0.339,1.399 -0.419,0.715 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.1958,60.5236)",
    id: "g1788"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1790",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 1,0.774 1.618,1.828 1.618,2.989 0,1.335 -0.839,2.528 -2.116,3.318 C 0.29,5.649 0.767,4.798 0.836,3.848 0.847,3.729 0.852,3.609 0.852,3.488 0.852,2.396 0.373,1.414 -0.385,0.73 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.1958,60.5236)",
    id: "g1792"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1794",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 1,0.774 1.618,1.828 1.618,2.989 0,1.335 -0.839,2.528 -2.116,3.318 C 0.29,5.649 0.767,4.798 0.836,3.848 0.847,3.729 0.852,3.609 0.852,3.488 0.852,2.396 0.373,1.414 -0.385,0.73 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.0034,59.1691)",
    id: "g1796"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1798",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0.559,0.651 0.9,1.494 0.9,2.413 0.9,2.971 0.776,3.5 0.555,3.975 -0.254,5.706 -2.787,6.963 -5.8,6.963 c -0.82,0 -1.606,-0.094 -2.33,-0.265 0.162,-0.183 0.287,-0.383 0.41,-0.583 0.602,0.121 1.248,0.187 1.92,0.187 2.757,0 5.065,-1.115 5.733,-2.622 C 0.11,3.293 0.21,2.865 0.21,2.413 0.21,1.499 -0.202,0.678 -0.848,0.118 l 0.997,-1.698 0.537,0.443 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.0034,59.1691)",
    id: "g1800"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1802",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0.559,0.651 0.9,1.494 0.9,2.413 0.9,2.971 0.776,3.5 0.555,3.975 -0.254,5.706 -2.787,6.963 -5.8,6.963 c -0.82,0 -1.606,-0.094 -2.33,-0.265 0.162,-0.183 0.287,-0.383 0.41,-0.583 0.602,0.121 1.248,0.187 1.92,0.187 2.757,0 5.065,-1.115 5.733,-2.622 C 0.11,3.293 0.21,2.865 0.21,2.413 0.21,1.499 -0.202,0.678 -0.848,0.118 l 0.997,-1.698 0.537,0.443 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.98,64.8542)",
    id: "g1804"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1806",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0.726,-0.475 1.274,-1.059 1.578,-1.71 0.222,-0.476 0.346,-1.004 0.346,-1.562 0,-0.919 -0.342,-1.762 -0.901,-2.413 l 0.605,-1.023 c 0.58,0.776 0.918,1.68 0.918,2.644 C 2.546,-2.407 1.531,-0.958 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.98,64.8542)",
    id: "g1808"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1810",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0.726,-0.475 1.274,-1.059 1.578,-1.71 0.222,-0.476 0.346,-1.004 0.346,-1.562 0,-0.919 -0.342,-1.762 -0.901,-2.413 l 0.605,-1.023 c 0.58,0.776 0.918,1.68 0.918,2.644 C 2.546,-2.407 1.531,-0.958 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.0054,62.2795)",
    id: "g1812"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1814",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 H -0.021"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.1553,61.5187)",
    id: "g1816"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1818",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.393 0.322,0.711 0.722,0.711 1.12,0.711 1.443,0.393 1.443,0 1.443,-0.393 1.12,-0.711 0.722,-0.711 0.322,-0.711 0,-0.393 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.1553,61.5187)",
    id: "g1820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1822",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.393 0.322,0.711 0.722,0.711 1.12,0.711 1.443,0.393 1.443,0 1.443,-0.393 1.12,-0.711 0.722,-0.711 0.322,-0.711 0,-0.393 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.1553,62.9133)",
    id: "g1824"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1826",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.393 0.322,0.711 0.722,0.711 1.12,0.711 1.443,0.393 1.443,0 1.443,-0.393 1.12,-0.711 0.722,-0.711 0.322,-0.711 0,-0.393 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.1553,62.9133)",
    id: "g1828"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1830",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.393 0.322,0.711 0.722,0.711 1.12,0.711 1.443,0.393 1.443,0 1.443,-0.393 1.12,-0.711 0.722,-0.711 0.322,-0.711 0,-0.393 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.2993,64.4128)",
    id: "g1832"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1834",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.314 0.258,0.569 0.578,0.569 0.896,0.569 1.155,0.314 1.155,0 1.155,-0.314 0.896,-0.568 0.578,-0.568 0.258,-0.568 0,-0.314 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.2993,64.4128)",
    id: "g1836"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1838",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.314 0.258,0.569 0.578,0.569 0.896,0.569 1.155,0.314 1.155,0 1.155,-0.314 0.896,-0.568 0.578,-0.568 0.258,-0.568 0,-0.314 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.4615,65.7648)",
    id: "g1840"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1842",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.226 0.186,0.41 0.416,0.41 0.645,0.41 0.831,0.226 0.831,0 0.831,-0.227 0.645,-0.41 0.416,-0.41 0.186,-0.41 0,-0.227 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.4615,65.7648)",
    id: "g1844"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1846",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.226 0.186,0.41 0.416,0.41 0.645,0.41 0.831,0.226 0.831,0 0.831,-0.227 0.645,-0.41 0.416,-0.41 0.186,-0.41 0,-0.227 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.544,66.9474)",
    id: "g1848"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1850",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.181 0.149,0.328 0.333,0.328 0.516,0.328 0.665,0.181 0.665,0 0.665,-0.181 0.516,-0.328 0.333,-0.328 0.149,-0.328 0,-0.181 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.544,66.9474)",
    id: "g1852"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1854",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.181 0.149,0.328 0.333,0.328 0.516,0.328 0.665,0.181 0.665,0 0.665,-0.181 0.516,-0.328 0.333,-0.328 0.149,-0.328 0,-0.181 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.9375,57.2404)",
    id: "g1856"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1858",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 0.469,-0.088 c -0.075,-0.2 -0.09,-0.416 -0.09,-0.641 0,-1.015 0.835,-1.838 1.865,-1.838 0.828,0 1.53,0.532 1.773,1.268 0.027,-0.021 0.178,0.663 0.255,0.655 0.066,-0.006 0.059,-0.708 0.084,-0.698 0.119,-0.925 0.933,-1.552 1.849,-1.552 1.028,0 1.86,0.821 1.86,1.834 0,0.076 -0.004,0.151 -0.013,0.225 L 8.637,-0.233 8.951,-1 C 8.825,-1.241 8.775,-1.513 8.775,-1.802 c 0,-0.968 0.797,-1.753 1.779,-1.753 0.618,0 1.162,0.31 1.481,0.781 l 0.374,0.493 -0.003,-0.605 c 0,-0.61 0.247,-1.157 0.82,-1.253 0,0 0.656,-0.044 1.524,0.668 0.87,0.712 1.35,1.299 1.35,1.299 l 0.075,-0.711 c 0,0 -0.722,-1.163 -1.508,-1.637 -0.43,-0.26 -1.083,-0.533 -1.602,-0.445 -0.548,0.094 -0.94,0.549 -1.143,1.081 -0.39,-0.241 -0.852,-0.381 -1.347,-0.381 -1.063,0 -2.019,0.605 -2.397,1.519 -0.489,-0.547 -1.17,-0.886 -1.969,-0.886 -0.85,0 -1.628,0.398 -2.116,1.009 -0.48,-0.455 -1.132,-0.734 -1.849,-0.734 -0.939,0 -1.78,0.479 -2.254,1.202 -0.475,-0.723 -1.312,-1.202 -2.251,-1.202 -0.718,0 -1.37,0.279 -1.849,0.734 -0.489,-0.611 -1.266,-1.009 -2.117,-1.009 -0.798,0 -1.481,0.339 -1.968,0.886 -0.38,-0.914 -1.334,-1.519 -2.399,-1.519 -0.494,0 -0.956,0.14 -1.346,0.381 -0.203,-0.532 -0.594,-0.987 -1.142,-1.081 -0.52,-0.088 -1.172,0.185 -1.604,0.445 -0.785,0.474 -1.507,1.637 -1.507,1.637 l 0.076,0.711 c 0,0 0.479,-0.587 1.349,-1.299 0.87,-0.712 1.526,-0.668 1.526,-0.668 0.572,0.096 0.819,0.643 0.819,1.253 l -0.003,0.605 0.373,-0.493 c 0.319,-0.471 0.864,-0.781 1.481,-0.781 0.983,0 1.779,0.785 1.779,1.753 0,0.289 -0.05,0.561 -0.175,0.802 l 0.314,0.767 0.585,-0.602 c -0.01,-0.074 -0.015,-0.149 -0.015,-0.225 0,-1.013 0.834,-1.834 1.862,-1.834 0.916,0 1.729,0.627 1.848,1.552 0.025,-0.01 0.019,0.692 0.084,0.698 0.077,0.008 0.229,-0.676 0.255,-0.655 0.243,-0.736 0.945,-1.268 1.774,-1.268 1.029,0 1.865,0.823 1.865,1.838 0,0.225 -0.015,0.441 -0.09,0.641 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.9375,57.2404)",
    id: "g1860"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1862",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 0.469,-0.088 c -0.075,-0.2 -0.09,-0.416 -0.09,-0.641 0,-1.015 0.835,-1.838 1.865,-1.838 0.828,0 1.53,0.532 1.773,1.268 0.027,-0.021 0.178,0.663 0.255,0.655 0.066,-0.006 0.059,-0.708 0.084,-0.698 0.119,-0.925 0.933,-1.552 1.849,-1.552 1.028,0 1.86,0.821 1.86,1.834 0,0.076 -0.004,0.151 -0.013,0.225 L 8.637,-0.233 8.951,-1 C 8.825,-1.241 8.775,-1.513 8.775,-1.802 c 0,-0.968 0.797,-1.753 1.779,-1.753 0.618,0 1.162,0.31 1.481,0.781 l 0.374,0.493 -0.003,-0.605 c 0,-0.61 0.247,-1.157 0.82,-1.253 0,0 0.656,-0.044 1.524,0.668 0.87,0.712 1.35,1.299 1.35,1.299 l 0.075,-0.711 c 0,0 -0.722,-1.163 -1.508,-1.637 -0.43,-0.26 -1.083,-0.533 -1.602,-0.445 -0.548,0.094 -0.94,0.549 -1.143,1.081 -0.39,-0.241 -0.852,-0.381 -1.347,-0.381 -1.063,0 -2.019,0.605 -2.397,1.519 -0.489,-0.547 -1.17,-0.886 -1.969,-0.886 -0.85,0 -1.628,0.398 -2.116,1.009 -0.48,-0.455 -1.132,-0.734 -1.849,-0.734 -0.939,0 -1.78,0.479 -2.254,1.202 -0.475,-0.723 -1.312,-1.202 -2.251,-1.202 -0.718,0 -1.37,0.279 -1.849,0.734 -0.489,-0.611 -1.266,-1.009 -2.117,-1.009 -0.798,0 -1.481,0.339 -1.968,0.886 -0.38,-0.914 -1.334,-1.519 -2.399,-1.519 -0.494,0 -0.956,0.14 -1.346,0.381 -0.203,-0.532 -0.594,-0.987 -1.142,-1.081 -0.52,-0.088 -1.172,0.185 -1.604,0.445 -0.785,0.474 -1.507,1.637 -1.507,1.637 l 0.076,0.711 c 0,0 0.479,-0.587 1.349,-1.299 0.87,-0.712 1.526,-0.668 1.526,-0.668 0.572,0.096 0.819,0.643 0.819,1.253 l -0.003,0.605 0.373,-0.493 c 0.319,-0.471 0.864,-0.781 1.481,-0.781 0.983,0 1.779,0.785 1.779,1.753 0,0.289 -0.05,0.561 -0.175,0.802 l 0.314,0.767 0.585,-0.602 c -0.01,-0.074 -0.015,-0.149 -0.015,-0.225 0,-1.013 0.834,-1.834 1.862,-1.834 0.916,0 1.729,0.627 1.848,1.552 0.025,-0.01 0.019,0.692 0.084,0.698 0.077,0.008 0.229,-0.676 0.255,-0.655 0.243,-0.736 0.945,-1.268 1.774,-1.268 1.029,0 1.865,0.823 1.865,1.838 0,0.225 -0.015,0.441 -0.09,0.641 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.7412,54.82)",
    id: "g1864"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1866",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0.108,0.328 0.011,0.653 -0.217,0.726 -0.444,0.799 -0.717,0.592 -0.825,0.264 -0.933,-0.064 -0.836,-0.389 -0.609,-0.461 -0.381,-0.534 -0.108,-0.328 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.7412,54.82)",
    id: "g1868"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1870",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0.108,0.328 0.011,0.653 -0.217,0.726 -0.444,0.799 -0.717,0.592 -0.825,0.264 -0.933,-0.064 -0.836,-0.389 -0.609,-0.461 -0.381,-0.534 -0.108,-0.328 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.6343,56.4528)",
    id: "g1872"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1874",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0.042,0.343 -0.115,0.643 -0.353,0.672 -0.59,0.701 -0.818,0.446 -0.86,0.104 -0.903,-0.238 -0.744,-0.539 -0.507,-0.567 -0.27,-0.596 -0.042,-0.342 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.6343,56.4528)",
    id: "g1876"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1878",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0.042,0.343 -0.115,0.643 -0.353,0.672 -0.59,0.701 -0.818,0.446 -0.86,0.104 -0.903,-0.238 -0.744,-0.539 -0.507,-0.567 -0.27,-0.596 -0.042,-0.342 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.2232,56.4528)",
    id: "g1880"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1882",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C -0.043,0.343 0.115,0.643 0.353,0.672 0.59,0.701 0.817,0.446 0.86,0.104 0.902,-0.238 0.745,-0.539 0.507,-0.567 0.269,-0.596 0.042,-0.342 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.2232,56.4528)",
    id: "g1884"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1886",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C -0.043,0.343 0.115,0.643 0.353,0.672 0.59,0.701 0.817,0.446 0.86,0.104 0.902,-0.238 0.745,-0.539 0.507,-0.567 0.269,-0.596 0.042,-0.342 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.1172,54.82)",
    id: "g1888"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1890",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C -0.109,0.328 -0.011,0.653 0.216,0.726 0.443,0.799 0.716,0.592 0.824,0.264 0.932,-0.064 0.835,-0.389 0.607,-0.461 0.379,-0.534 0.108,-0.328 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.1172,54.82)",
    id: "g1892"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1894",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C -0.109,0.328 -0.011,0.653 0.216,0.726 0.443,0.799 0.716,0.592 0.824,0.264 0.932,-0.064 0.835,-0.389 0.607,-0.461 0.379,-0.534 0.108,-0.328 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.6382,60.4474)",
    id: "g1896"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1898",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0.402,-0.265 0.753,-0.705 0.875,-1.197 0,0 0.047,0.102 0.27,0.234 0.223,0.131 0.412,0.127 0.412,0.127 0,0 -0.063,-0.384 -0.096,-0.52 C 1.428,-1.492 1.426,-1.902 1.341,-2.271 1.256,-2.64 1.101,-2.937 1.101,-2.937 0.942,-2.802 0.726,-2.735 0.504,-2.774 0.281,-2.813 0.102,-2.948 -0.001,-3.128 c 0,0 -0.248,0.226 -0.456,0.544 -0.208,0.318 -0.353,0.703 -0.431,0.82 -0.077,0.117 -0.271,0.456 -0.271,0.456 0,0 0.177,0.068 0.432,0.019 0.255,-0.049 0.334,-0.128 0.334,-0.128 C -0.448,-0.913 -0.286,-0.384 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.6382,60.4474)",
    id: "g1900"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1902",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0.402,-0.265 0.753,-0.705 0.875,-1.197 0,0 0.047,0.102 0.27,0.234 0.223,0.131 0.412,0.127 0.412,0.127 0,0 -0.063,-0.384 -0.096,-0.52 C 1.428,-1.492 1.426,-1.902 1.341,-2.271 1.256,-2.64 1.101,-2.937 1.101,-2.937 0.942,-2.802 0.726,-2.735 0.504,-2.774 0.281,-2.813 0.102,-2.948 -0.001,-3.128 c 0,0 -0.248,0.226 -0.456,0.544 -0.208,0.318 -0.353,0.703 -0.431,0.82 -0.077,0.117 -0.271,0.456 -0.271,0.456 0,0 0.177,0.068 0.432,0.019 0.255,-0.049 0.334,-0.128 0.334,-0.128 C -0.448,-0.913 -0.286,-0.384 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.8081,56.4191)",
    id: "g1904"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1906",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -0.127,0.104 -0.224,0.251 -0.255,0.425 -0.031,0.173 0.003,0.343 0.087,0.485 0,0 -0.335,0.176 -0.694,0.276 -0.273,0.075 -0.754,0.077 -0.9,0.08 -0.144,0.004 -0.433,0.01 -0.433,0.01 0,0 0.022,-0.068 0.106,-0.218 0.1,-0.182 0.186,-0.295 0.186,-0.295 -0.479,-0.116 -0.889,-0.446 -1.148,-0.826 0.374,-0.27 0.873,-0.436 1.365,-0.383 0,0 -0.043,-0.136 -0.074,-0.34 -0.025,-0.17 -0.024,-0.241 -0.024,-0.241 0,0 0.27,0.103 0.405,0.155 0.136,0.052 0.587,0.216 0.817,0.379 C -0.258,-0.278 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.8081,56.4191)",
    id: "g1908"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1910",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -0.127,0.104 -0.224,0.251 -0.255,0.425 -0.031,0.173 0.003,0.343 0.087,0.485 0,0 -0.335,0.176 -0.694,0.276 -0.273,0.075 -0.754,0.077 -0.9,0.08 -0.144,0.004 -0.433,0.01 -0.433,0.01 0,0 0.022,-0.068 0.106,-0.218 0.1,-0.182 0.186,-0.295 0.186,-0.295 -0.479,-0.116 -0.889,-0.446 -1.148,-0.826 0.374,-0.27 0.873,-0.436 1.365,-0.383 0,0 -0.043,-0.136 -0.074,-0.34 -0.025,-0.17 -0.024,-0.241 -0.024,-0.241 0,0 0.27,0.103 0.405,0.155 0.136,0.052 0.587,0.216 0.817,0.379 C -0.258,-0.278 0,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.8863,56.6066)",
    id: "g1912"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1914",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0.083,0.141 0.125,0.312 0.093,0.485 -0.031,0.174 -0.123,0.321 -0.251,0.426 0,0 0.254,0.279 0.557,0.493 0.23,0.164 0.683,0.327 0.817,0.38 0.136,0.051 0.406,0.155 0.406,0.155 0,0 0,-0.071 -0.025,-0.241 C 1.566,1.494 1.523,1.358 1.523,1.358 2.014,1.411 2.515,1.239 2.889,0.969 2.631,0.589 2.219,0.265 1.739,0.149 c 0,0 0.088,-0.113 0.188,-0.295 0.082,-0.151 0.106,-0.218 0.106,-0.218 0,0 -0.29,0.006 -0.434,0.01 -0.145,0.003 -0.627,0.004 -0.9,0.08 C 0.34,-0.174 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.8863,56.6066)",
    id: "g1916"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1918",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0.083,0.141 0.125,0.312 0.093,0.485 -0.031,0.174 -0.123,0.321 -0.251,0.426 0,0 0.254,0.279 0.557,0.493 0.23,0.164 0.683,0.327 0.817,0.38 0.136,0.051 0.406,0.155 0.406,0.155 0,0 0,-0.071 -0.025,-0.241 C 1.566,1.494 1.523,1.358 1.523,1.358 2.014,1.411 2.515,1.239 2.889,0.969 2.631,0.589 2.219,0.265 1.739,0.149 c 0,0 0.088,-0.113 0.188,-0.295 0.082,-0.151 0.106,-0.218 0.106,-0.218 0,0 -0.29,0.006 -0.434,0.01 -0.145,0.003 -0.627,0.004 -0.9,0.08 C 0.34,-0.174 0,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.4566,56.9772)",
    id: "g1920"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1922",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.447 0.368,0.81 0.823,0.81 1.277,0.81 1.645,0.447 1.645,0 1.645,-0.448 1.277,-0.811 0.823,-0.811 0.368,-0.811 0,-0.448 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.4566,56.9772)",
    id: "g1924"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1926",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.447 0.368,0.81 0.823,0.81 1.277,0.81 1.645,0.447 1.645,0 1.645,-0.448 1.277,-0.811 0.823,-0.811 0.368,-0.811 0,-0.448 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.9073,61.7438)",
    id: "g1928"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1930",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0.395,-0.374 0.699,-0.932 0.737,-1.504 0,0 0.074,0.104 0.346,0.208 0.275,0.104 0.487,0.062 0.487,0.062 0,0 -0.149,-0.415 -0.212,-0.561 C 1.295,-1.94 1.21,-2.397 1.042,-2.792 c -0.169,-0.395 -0.4,-0.695 -0.4,-0.695 -0.151,0.18 -0.378,0.297 -0.633,0.297 -0.256,0 -0.483,-0.117 -0.634,-0.297 0,0 -0.231,0.3 -0.4,0.695 -0.169,0.395 -0.253,0.852 -0.316,0.997 -0.064,0.146 -0.211,0.561 -0.211,0.561 0,0 0.211,0.042 0.485,-0.062 0.274,-0.104 0.346,-0.208 0.346,-0.208 C -0.682,-0.932 -0.396,-0.374 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.9073,61.7438)",
    id: "g1932"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1934",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0.395,-0.374 0.699,-0.932 0.737,-1.504 0,0 0.074,0.104 0.346,0.208 0.275,0.104 0.487,0.062 0.487,0.062 0,0 -0.149,-0.415 -0.212,-0.561 C 1.295,-1.94 1.21,-2.397 1.042,-2.792 c -0.169,-0.395 -0.4,-0.695 -0.4,-0.695 -0.151,0.18 -0.378,0.297 -0.633,0.297 -0.256,0 -0.483,-0.117 -0.634,-0.297 0,0 -0.231,0.3 -0.4,0.695 -0.169,0.395 -0.253,0.852 -0.316,0.997 -0.064,0.146 -0.211,0.561 -0.211,0.561 0,0 0.211,0.042 0.485,-0.062 0.274,-0.104 0.346,-0.208 0.346,-0.208 C -0.682,-0.932 -0.396,-0.374 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.2925,57.2199)",
    id: "g1936"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1938",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -0.121,0.141 -0.199,0.324 -0.199,0.523 0,0.2 0.073,0.383 0.194,0.523 0,0 -0.338,0.262 -0.719,0.443 -0.289,0.137 -0.825,0.232 -0.986,0.264 -0.162,0.032 -0.482,0.095 -0.482,0.095 0,0 0.012,-0.08 0.074,-0.265 0.076,-0.221 0.15,-0.364 0.15,-0.364 -0.558,-0.036 -1.081,-0.324 -1.445,-0.698 0.364,-0.374 0.887,-0.655 1.445,-0.691 0,0 -0.074,-0.143 -0.15,-0.366 -0.062,-0.184 -0.074,-0.263 -0.074,-0.263 0,0 0.32,0.063 0.482,0.095 0.161,0.032 0.697,0.126 0.986,0.264 C -0.343,-0.26 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.2925,57.2199)",
    id: "g1940"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1942",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -0.121,0.141 -0.199,0.324 -0.199,0.523 0,0.2 0.073,0.383 0.194,0.523 0,0 -0.338,0.262 -0.719,0.443 -0.289,0.137 -0.825,0.232 -0.986,0.264 -0.162,0.032 -0.482,0.095 -0.482,0.095 0,0 0.012,-0.08 0.074,-0.265 0.076,-0.221 0.15,-0.364 0.15,-0.364 -0.558,-0.036 -1.081,-0.324 -1.445,-0.698 0.364,-0.374 0.887,-0.655 1.445,-0.691 0,0 -0.074,-0.143 -0.15,-0.366 -0.062,-0.184 -0.074,-0.263 -0.074,-0.263 0,0 0.32,0.063 0.482,0.095 0.161,0.032 0.697,0.126 0.986,0.264 C -0.343,-0.26 0,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.5327,57.2199)",
    id: "g1944"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1946",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0.121,0.141 0.2,0.324 0.2,0.523 0,0.2 -0.073,0.383 -0.195,0.523 0,0 0.339,0.262 0.72,0.443 0.29,0.137 0.824,0.232 0.985,0.264 0.162,0.032 0.483,0.095 0.483,0.095 0,0 -0.012,-0.08 -0.075,-0.265 C 2.043,1.362 1.968,1.219 1.968,1.219 2.526,1.183 3.05,0.895 3.413,0.521 3.05,0.147 2.526,-0.134 1.968,-0.17 c 0,0 0.075,-0.143 0.15,-0.366 0.063,-0.184 0.075,-0.263 0.075,-0.263 0,0 -0.321,0.063 -0.483,0.095 C 1.549,-0.672 1.015,-0.578 0.725,-0.44 0.344,-0.26 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.5327,57.2199)",
    id: "g1948"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1950",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0.121,0.141 0.2,0.324 0.2,0.523 0,0.2 -0.073,0.383 -0.195,0.523 0,0 0.339,0.262 0.72,0.443 0.29,0.137 0.824,0.232 0.985,0.264 0.162,0.032 0.483,0.095 0.483,0.095 0,0 -0.012,-0.08 -0.075,-0.265 C 2.043,1.362 1.968,1.219 1.968,1.219 2.526,1.183 3.05,0.895 3.413,0.521 3.05,0.147 2.526,-0.134 1.968,-0.17 c 0,0 0.075,-0.143 0.15,-0.366 0.063,-0.184 0.075,-0.263 0.075,-0.263 0,0 -0.321,0.063 -0.483,0.095 C 1.549,-0.672 1.015,-0.578 0.725,-0.44 0.344,-0.26 0,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.2193,60.4474)",
    id: "g1952"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1954",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -0.401,-0.265 -0.753,-0.705 -0.876,-1.197 0,0 -0.046,0.102 -0.269,0.234 -0.222,0.131 -0.412,0.127 -0.412,0.127 0,0 0.063,-0.384 0.096,-0.52 0.032,-0.136 0.035,-0.546 0.12,-0.915 0.086,-0.369 0.239,-0.666 0.239,-0.666 0.16,0.135 0.376,0.202 0.598,0.163 0.222,-0.039 0.402,-0.174 0.505,-0.354 0,0 0.248,0.226 0.457,0.544 0.207,0.318 0.352,0.703 0.43,0.82 0.077,0.117 0.271,0.456 0.271,0.456 0,0 -0.178,0.068 -0.432,0.019 C 0.472,-1.338 0.392,-1.417 0.392,-1.417 0.448,-0.913 0.286,-0.384 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.2193,60.4474)",
    id: "g1956"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1958",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -0.401,-0.265 -0.753,-0.705 -0.876,-1.197 0,0 -0.046,0.102 -0.269,0.234 -0.222,0.131 -0.412,0.127 -0.412,0.127 0,0 0.063,-0.384 0.096,-0.52 0.032,-0.136 0.035,-0.546 0.12,-0.915 0.086,-0.369 0.239,-0.666 0.239,-0.666 0.16,0.135 0.376,0.202 0.598,0.163 0.222,-0.039 0.402,-0.174 0.505,-0.354 0,0 0.248,0.226 0.457,0.544 0.207,0.318 0.352,0.703 0.43,0.82 0.077,0.117 0.271,0.456 0.271,0.456 0,0 -0.178,0.068 -0.432,0.019 C 0.472,-1.338 0.392,-1.417 0.392,-1.417 0.448,-0.913 0.286,-0.384 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.0493,56.4191)",
    id: "g1960"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1962",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C 0.127,0.104 0.225,0.251 0.255,0.425 0.286,0.598 0.251,0.768 0.167,0.91 c 0,0 0.336,0.176 0.695,0.276 0.273,0.075 0.754,0.077 0.899,0.08 0.146,0.004 0.435,0.01 0.435,0.01 0,0 -0.023,-0.068 -0.106,-0.218 C 1.99,0.876 1.902,0.763 1.902,0.763 2.382,0.647 2.792,0.317 3.05,-0.063 2.676,-0.333 2.177,-0.499 1.686,-0.446 c 0,0 0.043,-0.136 0.073,-0.34 0.027,-0.17 0.025,-0.241 0.025,-0.241 0,0 -0.27,0.103 -0.406,0.155 C 1.244,-0.82 0.792,-0.656 0.562,-0.493 0.259,-0.278 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.0493,56.4191)",
    id: "g1964"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1966",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0.127,0.104 0.225,0.251 0.255,0.425 0.286,0.598 0.251,0.768 0.167,0.91 c 0,0 0.336,0.176 0.695,0.276 0.273,0.075 0.754,0.077 0.899,0.08 0.146,0.004 0.435,0.01 0.435,0.01 0,0 -0.023,-0.068 -0.106,-0.218 C 1.99,0.876 1.902,0.763 1.902,0.763 2.382,0.647 2.792,0.317 3.05,-0.063 2.676,-0.333 2.177,-0.499 1.686,-0.446 c 0,0 0.043,-0.136 0.073,-0.34 0.027,-0.17 0.025,-0.241 0.025,-0.241 0,0 -0.27,0.103 -0.406,0.155 C 1.244,-0.82 0.792,-0.656 0.562,-0.493 0.259,-0.278 0,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.9702,56.6066)",
    id: "g1968"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1970",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -0.083,0.141 -0.123,0.312 -0.091,0.485 0.03,0.174 0.122,0.321 0.25,0.426 0,0 -0.254,0.279 -0.556,0.493 -0.231,0.164 -0.683,0.327 -0.818,0.38 -0.135,0.051 -0.405,0.155 -0.405,0.155 0,0 -10e-4,-0.071 0.024,-0.241 0.031,-0.204 0.075,-0.34 0.075,-0.34 -0.492,0.053 -0.992,-0.119 -1.367,-0.389 0.259,-0.38 0.67,-0.704 1.15,-0.82 0,0 -0.088,-0.113 -0.188,-0.295 -0.083,-0.151 -0.106,-0.218 -0.106,-0.218 0,0 0.29,0.006 0.434,0.01 0.145,0.003 0.626,0.004 0.899,0.08 C -0.338,-0.174 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.9702,56.6066)",
    id: "g1972"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1974",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -0.083,0.141 -0.123,0.312 -0.091,0.485 0.03,0.174 0.122,0.321 0.25,0.426 0,0 -0.254,0.279 -0.556,0.493 -0.231,0.164 -0.683,0.327 -0.818,0.38 -0.135,0.051 -0.405,0.155 -0.405,0.155 0,0 -10e-4,-0.071 0.024,-0.241 0.031,-0.204 0.075,-0.34 0.075,-0.34 -0.492,0.053 -0.992,-0.119 -1.367,-0.389 0.259,-0.38 0.67,-0.704 1.15,-0.82 0,0 -0.088,-0.113 -0.188,-0.295 -0.083,-0.151 -0.106,-0.218 -0.106,-0.218 0,0 0.29,0.006 0.434,0.01 0.145,0.003 0.626,0.004 0.899,0.08 C -0.338,-0.174 0,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.7559,56.9772)",
    id: "g1976"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1978",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.447 0.368,0.81 0.822,0.81 1.276,0.81 1.645,0.447 1.645,0 1.645,-0.448 1.276,-0.811 0.822,-0.811 0.368,-0.811 0,-0.448 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.7559,56.9772)",
    id: "g1980"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1982",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.447 0.368,0.81 0.822,0.81 1.276,0.81 1.645,0.447 1.645,0 1.645,-0.448 1.276,-0.811 0.822,-0.811 0.368,-0.811 0,-0.448 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.9488,55.1765)",
    id: "g1984"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1986",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -0.194,0.212 -0.594,0.168 -0.895,-0.098 -0.3,-0.267 -0.386,-0.654 -0.193,-0.866 0.194,-0.212 0.594,-0.168 0.895,0.098 C 0.107,-0.6 0.193,-0.212 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.9488,55.1765)",
    id: "g1988"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1990",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -0.194,0.212 -0.594,0.168 -0.895,-0.098 -0.3,-0.267 -0.386,-0.654 -0.193,-0.866 0.194,-0.212 0.594,-0.168 0.895,0.098 C 0.107,-0.6 0.193,-0.212 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.7818,54.6608)",
    id: "g1992"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1994",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0.041,0.146 0.133,0.294 0.272,0.417 0.301,0.267 0.701,0.311 0.895,0.099 0.026,-0.029 0.052,-0.066 0.067,-0.1 0,0 0.418,0.822 0.912,1.097 0.493,0.274 1.328,0.204 1.328,0.204 0,0.631 -0.497,1.142 -1.137,1.142 C 1.96,2.859 1.606,2.696 1.395,2.421 L 1.31,2.844 c 0,0 -0.516,-0.106 -0.751,-0.719 -0.236,-0.612 0.021,-1.5 0.021,-1.5 0,0 -0.128,0.381 -0.321,0.634 -0.193,0.254 -0.687,0.528 -0.944,0.655 -0.257,0.127 -0.52,0.313 -0.52,0.313 0,0 -0.011,-0.07 -0.021,-0.239 -0.01,-0.203 0.005,-0.327 0.005,-0.327 -0.471,0.063 -1.021,-0.016 -1.452,-0.19 0.185,-0.376 0.534,-0.728 0.992,-0.909 0,0 -0.165,-0.142 -0.316,-0.299 -0.124,-0.131 -0.165,-0.192 -0.165,-0.192 0,0 0.323,-0.048 0.484,-0.071 0.162,-0.024 0.697,-0.112 1.018,-0.089 C -0.425,-0.072 -0.161,-0.032 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.7818,54.6608)",
    id: "g1996"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1998",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0.041,0.146 0.133,0.294 0.272,0.417 0.301,0.267 0.701,0.311 0.895,0.099 0.026,-0.029 0.052,-0.066 0.067,-0.1 0,0 0.418,0.822 0.912,1.097 0.493,0.274 1.328,0.204 1.328,0.204 0,0.631 -0.497,1.142 -1.137,1.142 C 1.96,2.859 1.606,2.696 1.395,2.421 L 1.31,2.844 c 0,0 -0.516,-0.106 -0.751,-0.719 -0.236,-0.612 0.021,-1.5 0.021,-1.5 0,0 -0.128,0.381 -0.321,0.634 -0.193,0.254 -0.687,0.528 -0.944,0.655 -0.257,0.127 -0.52,0.313 -0.52,0.313 0,0 -0.011,-0.07 -0.021,-0.239 -0.01,-0.203 0.005,-0.327 0.005,-0.327 -0.471,0.063 -1.021,-0.016 -1.452,-0.19 0.185,-0.376 0.534,-0.728 0.992,-0.909 0,0 -0.165,-0.142 -0.316,-0.299 -0.124,-0.131 -0.165,-0.192 -0.165,-0.192 0,0 0.323,-0.048 0.484,-0.071 0.162,-0.024 0.697,-0.112 1.018,-0.089 C -0.425,-0.072 -0.161,-0.032 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.9092,55.1765)",
    id: "g2000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2002",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0.193,0.212 0.594,0.168 0.894,-0.098 1.194,-0.365 1.281,-0.752 1.086,-0.964 0.894,-1.176 0.493,-1.132 0.192,-0.866 -0.108,-0.6 -0.194,-0.212 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.9092,55.1765)",
    id: "g2004"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2006",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0.193,0.212 0.594,0.168 0.894,-0.098 1.194,-0.365 1.281,-0.752 1.086,-0.964 0.894,-1.176 0.493,-1.132 0.192,-0.866 -0.108,-0.6 -0.194,-0.212 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.0757,54.6608)",
    id: "g2008"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2010",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -0.041,0.146 -0.134,0.294 -0.273,0.417 -0.299,0.267 -0.7,0.311 -0.894,0.099 -0.025,-0.029 -0.052,-0.066 -0.068,-0.1 0,0 -0.417,0.822 -0.911,1.097 -0.493,0.274 -1.327,0.204 -1.327,0.204 0,0.631 0.496,1.142 1.137,1.142 0.376,0 0.73,-0.163 0.94,-0.438 l 0.086,0.423 c 0,0 0.515,-0.106 0.75,-0.719 0.237,-0.612 -0.021,-1.5 -0.021,-1.5 0,0 0.129,0.381 0.323,0.634 0.193,0.254 0.685,0.528 0.943,0.655 0.257,0.127 0.52,0.313 0.52,0.313 0,0 0.012,-0.07 0.021,-0.239 C 1.236,1.785 1.221,1.661 1.221,1.661 1.692,1.724 2.243,1.645 2.672,1.471 2.489,1.095 2.14,0.743 1.681,0.562 c 0,0 0.165,-0.142 0.315,-0.299 C 2.122,0.132 2.163,0.071 2.163,0.071 2.163,0.071 1.839,0.023 1.677,0 1.516,-0.024 0.981,-0.112 0.661,-0.089 0.425,-0.072 0.161,-0.032 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.0757,54.6608)",
    id: "g2012"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2014",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -0.041,0.146 -0.134,0.294 -0.273,0.417 -0.299,0.267 -0.7,0.311 -0.894,0.099 -0.025,-0.029 -0.052,-0.066 -0.068,-0.1 0,0 -0.417,0.822 -0.911,1.097 -0.493,0.274 -1.327,0.204 -1.327,0.204 0,0.631 0.496,1.142 1.137,1.142 0.376,0 0.73,-0.163 0.94,-0.438 l 0.086,0.423 c 0,0 0.515,-0.106 0.75,-0.719 0.237,-0.612 -0.021,-1.5 -0.021,-1.5 0,0 0.129,0.381 0.323,0.634 0.193,0.254 0.685,0.528 0.943,0.655 0.257,0.127 0.52,0.313 0.52,0.313 0,0 0.012,-0.07 0.021,-0.239 C 1.236,1.785 1.221,1.661 1.221,1.661 1.692,1.724 2.243,1.645 2.672,1.471 2.489,1.095 2.14,0.743 1.681,0.562 c 0,0 0.165,-0.142 0.315,-0.299 C 2.122,0.132 2.163,0.071 2.163,0.071 2.163,0.071 1.839,0.023 1.677,0 1.516,-0.024 0.981,-0.112 0.661,-0.089 0.425,-0.072 0.161,-0.032 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.0933,57.7433)",
    id: "g2016"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2018",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.448 0.368,0.81 0.823,0.81 1.276,0.81 1.644,0.448 1.644,0 1.644,-0.447 1.276,-0.811 0.823,-0.811 0.368,-0.811 0,-0.447 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.0933,57.7433)",
    id: "g2020"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2022",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.448 0.368,0.81 0.823,0.81 1.276,0.81 1.644,0.448 1.644,0 1.644,-0.447 1.276,-0.811 0.823,-0.811 0.368,-0.811 0,-0.447 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.2046,70.0568)",
    id: "g2024"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2026",
    style: {
      fill: "#0044ae",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0,0.914 0.751,1.655 1.679,1.655 0.927,0 1.68,-0.741 1.68,-1.655 0,-0.914 -0.753,-1.655 -1.68,-1.655 C 0.751,-1.655 0,-0.914 0,0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2028"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath2034)",
    id: "g2030"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.8384,70.2922)",
    id: "g2036"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2038",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 V -0.9 H -3.795 V 0 h 1.401 v 2.61 h -0.922 v 0.901 h 0.922 v 0.895 h 0.915 V 3.511 h 0.917 V 2.61 H -1.479 V 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.8384,70.2922)",
    id: "g2040"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2042",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -0.9 H -3.795 V 0 h 1.401 v 2.61 h -0.922 v 0.901 h 0.922 v 0.895 h 0.915 V 3.511 h 0.917 V 2.61 H -1.479 V 0 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2044"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath2050)",
    id: "g2046"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.2578,70.2922)",
    id: "g2052"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2054",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 V -0.9 H -2.736 V 0 h 0.923 v 2.61 h -0.923 v 0.901 h 0.923 v 0.895 h 0.915 V 3.511 H 0.019 V 2.61 H -0.898 V 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.2578,70.2922)",
    id: "g2056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2058",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -0.9 H -2.736 V 0 h 0.923 v 2.61 h -0.923 v 0.901 h 0.923 v 0.895 h 0.915 V 3.511 H 0.019 V 2.61 H -0.898 V 0 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2060"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath2066)",
    id: "g2062"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.8384,70.2922)",
    id: "g2068"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2070",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 V -0.9 H -3.795 V 0 h 1.401 v 2.61 h -0.922 v 0.901 h 0.922 v 0.895 h 0.915 V 3.511 h 0.917 V 2.61 H -1.479 V 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.8384,70.2922)",
    id: "g2072"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2074",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -0.9 H -3.795 V 0 h 1.401 v 2.61 h -0.922 v 0.901 h 0.922 v 0.895 h 0.915 V 3.511 h 0.917 V 2.61 H -1.479 V 0 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2076"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath2082)",
    id: "g2078"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.3633,71.6452)",
    id: "g2084"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2086",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0.696,-0.202 1.2,-0.836 1.2,-1.588 0,-0.914 -0.752,-1.656 -1.68,-1.656 -0.928,0 -1.679,0.742 -1.679,1.656 0,0.764 0.527,1.408 1.242,1.598"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.0503,0.1979)",
    id: "g2088"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2090",
    style: {
      fill: "#bcbab9",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -4.962,0 -9.878,1.266 -14.012,3.371 -3.047,1.57 -5.069,4.737 -5.069,8.36 V 24.875 H -0.054 19.005 V 11.731 c 0,-3.623 -2.021,-6.79 -5.068,-8.36 C 9.803,1.266 4.962,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.0503,0.1979)",
    id: "g2092"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2094",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.19400001,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -4.962,0 -9.878,1.266 -14.012,3.371 -3.047,1.57 -5.069,4.737 -5.069,8.36 V 24.875 H -0.054 19.005 V 11.731 c 0,-3.623 -2.021,-6.79 -5.068,-8.36 C 9.803,1.266 4.962,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path2096",
    style: {
      fill: "#bcbab9",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#211915",
      strokeWidth: 0.19400001,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 35.968,47.078 H 55.052 V 25.091 H 35.968 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2098",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#211915",
      strokeWidth: 0.19400001,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 16.945,47.078 h 19.03 V 25.091 h -19.03 z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.9839,11.944)",
    id: "g2100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2102",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0,-5.192 -4.229,-9.402 -9.499,-9.402 -5.269,0 -9.542,4.21 -9.542,9.402 V 13.161 H 0 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2104"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath2110)",
    id: "g2106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2112",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#211915",
      strokeWidth: 0.19400001,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 21.103,25.57 h 2.23 V 1.23 h -2.23 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2114",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#211915",
      strokeWidth: 0.19400001,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 16.858,25.57 h 2.229 V 1.23 h -2.229 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2116",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#211915",
      strokeWidth: 0.19400001,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 25.349,25.57 h 2.23 V 1.23 h -2.23 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2118",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#211915",
      strokeWidth: 0.19400001,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 29.594,25.57 h 2.23 V 1.23 h -2.23 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2120",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#211915",
      strokeWidth: 0.19400001,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 33.84,25.57 h 2.23 V 1.23 h -2.23 z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g2122"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath2128)",
    id: "g2124"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.9839,11.944)",
    id: "g2130"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2132",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.19400001,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,-5.192 -4.229,-9.402 -9.499,-9.402 -5.269,0 -9.542,4.21 -9.542,9.402 V 13.161 H 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.0718,25.1052)",
    id: "g2134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2136",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 v -13.161 c 0,-5.193 -4.277,-9.402 -9.547,-9.402 -5.269,0 -9.541,4.209 -9.541,9.402 V 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.0718,25.1052)",
    id: "g2138"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2140",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.19400001,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 v -13.161 c 0,-5.193 -4.277,-9.402 -9.547,-9.402 -5.269,0 -9.541,4.209 -9.541,9.402 V 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.7632,20.5153)",
    id: "g2142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2144",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 0.666,-0.193 V -1.955 L 0,-2.145 Z m -0.639,0 -0.666,-0.193 v -1.762 l 0.666,-0.19 z M 1.693,2.056 1.89,2.712 H 3.676 L 3.87,2.056 Z m 0,-0.638 L 1.89,0.761 H 3.676 L 3.87,1.418 Z m -2.475,0.319 c 0,0.242 0.2,0.437 0.445,0.437 0.244,0 0.443,-0.195 0.443,-0.437 0,-0.241 -0.199,-0.437 -0.443,-0.437 -0.245,0 -0.445,0.196 -0.445,0.437 m 6.368,0 c 0,0.242 0.199,0.437 0.445,0.437 0.244,0 0.443,-0.195 0.443,-0.437 C 6.474,1.496 6.275,1.3 6.031,1.3 5.785,1.3 5.586,1.496 5.586,1.737 m -6.218,-13.407 -0.667,0.193 v 1.761 l 0.667,0.19 z m 0.647,0 0.666,0.193 v 1.761 l -0.666,0.19 z m -0.753,-3.186 c 0,0.242 0.198,0.437 0.444,0.437 0.244,0 0.443,-0.195 0.443,-0.437 0,-0.241 -0.199,-0.437 -0.443,-0.437 -0.246,0 -0.444,0.196 -0.444,0.437 M 3.855,-5.882 3.659,-6.539 H 1.871 l -0.193,0.657 z m 0,0.637 -0.196,0.658 H 1.871 L 1.678,-5.245 Z M 5.584,-5.55 c 0,0.242 0.198,0.438 0.443,0.438 0.245,0 0.444,-0.196 0.444,-0.438 0,-0.241 -0.199,-0.436 -0.444,-0.436 -0.245,0 -0.443,0.195 -0.443,0.436 m -7.92,7.606 -0.196,0.656 H -4.319 L -4.512,2.056 Z m 0,-0.638 -0.196,-0.657 h -1.787 l -0.193,0.657 z m -4.781,0.319 c 0,0.242 0.199,0.437 0.444,0.437 0.245,0 0.444,-0.195 0.444,-0.437 0,-0.241 -0.199,-0.437 -0.444,-0.437 -0.245,0 -0.444,0.196 -0.444,0.437 m 2.62,-7.619 0.196,-0.657 h 1.787 l 0.194,0.657 z m 0,0.637 0.196,0.658 h 1.787 L -2.32,-5.245 Z M 3.538,-1.533 3.922,-2.104 2.773,-3.452 2.139,-3.176 Z M 3.042,-1.124 2.405,-0.849 1.257,-2.198 1.643,-2.766 Z m -7.287,-0.465 -0.378,-0.573 1.16,-1.339 0.632,0.282 z m 0.492,0.414 0.635,0.28 1.16,-1.339 -0.381,-0.571 z m 7.2,-8.262 0.38,0.574 -1.161,1.339 -0.632,-0.282 z M 2.955,-9.851 2.321,-10.13 1.16,-8.792 1.542,-8.22 Z m 3.385,9.023 0.667,-0.194 v -1.76 L 6.34,-2.973 Z m -0.646,0 -0.668,-0.194 v -1.76 l 0.668,-0.191 z m -12.057,0 0.667,-0.194 v -1.76 l -0.667,-0.191 z m -0.647,0 -0.666,-0.194 v -1.76 L -7.01,-2.973 Z M 3.82,-13.723 c -0.567,-0.444 -1.215,-0.8 -1.91,-1.046 l 0.496,-0.484 c 0.557,0.214 1.082,0.497 1.563,0.834 z M 3.5,-13.145 C 2.94,-13.6 2.29,-13.967 1.589,-14.201 l -0.149,0.667 c 0.578,0.189 1.113,0.468 1.582,0.827 z M 0.003,0.771 -0.002,-0.545 h -0.644 l 0.001,1.306 C -0.963,0.859 -1.216,1.106 -1.32,1.419 h -1.569 v 0.635 h 1.569 c 0.135,0.409 0.522,0.705 0.983,0.705 0.46,0 0.849,-0.296 0.984,-0.705 h 1.6 V 1.419 H 0.643 C 0.542,1.115 0.31,0.875 0.003,0.771 M 6.347,0.763 6.342,-1.375 H 5.698 L 5.699,0.771 C 5.648,0.787 5.601,0.807 5.555,0.832 L 3.176,-1.955 2.683,-1.547 5.108,1.292 C 5.087,1.333 5.067,1.376 5.052,1.419 h -1.76 v 0.635 h 1.755 c 0.135,0.409 0.522,0.705 0.984,0.705 0.573,0 1.036,-0.457 1.036,-1.022 0,-0.457 -0.3,-0.844 -0.72,-0.974 M 5.689,-7.525 5.025,-7.687 c 0,0 -0.035,-1.128 -0.02,-0.876 0.018,0.297 -0.074,-0.882 -0.074,-0.882 l 0.67,-0.229 c 0.068,0.358 0.089,0.726 0.089,1.103 z m 0.553,-2.179 0.667,0.156 0.093,1.758 -0.66,0.227 -0.002,-1.008 c 0,-0.39 -0.032,-0.761 -0.098,-1.133 M 5.424,-11.55 c -0.159,0.184 -0.439,0.205 -0.625,0.049 -0.187,-0.157 -0.208,-0.433 -0.049,-0.617 0.158,-0.183 0.439,-0.205 0.625,-0.048 0.186,0.157 0.208,0.433 0.049,0.616 m 0.918,3.443 -0.002,1.583 c 0.42,0.131 0.725,0.518 0.725,0.974 0,0.457 -0.31,0.849 -0.728,0.98 l 0.005,2.168 H 5.698 L 5.695,-4.581 C 5.379,-4.685 5.134,-4.928 5.036,-5.243 L 3.302,-5.246 V -5.88 H 5.048 C 5.152,-6.179 5.389,-6.415 5.69,-6.517 l 0.002,-1.594 z m -3.323,-5.401 0.317,-0.569 c 0.541,0.351 1.024,0.784 1.441,1.27 0.329,-0.102 0.702,-0.041 0.984,0.196 0.435,0.366 0.487,1.012 0.114,1.441 l -0.054,0.059 c 0.262,0.616 0.44,1.281 0.501,1.977 L 5.674,-9.139 c -0.052,-0.594 -0.195,-1.157 -0.416,-1.687 -0.182,0.028 -0.376,0.004 -0.551,-0.064 l -1.623,1.869 -0.489,-0.412 1.612,-1.863 c -0.216,-0.345 -0.208,-0.789 0.041,-1.13 -0.359,-0.413 -0.769,-0.779 -1.229,-1.082 M -7.147,-5.55 c 0,0.242 0.198,0.438 0.443,0.438 0.245,0 0.444,-0.196 0.444,-0.438 0,-0.241 -0.199,-0.436 -0.444,-0.436 -0.245,0 -0.443,0.195 -0.443,0.436 m 3.023,-3.887 -0.379,0.574 1.161,1.339 0.632,-0.282 z m 0.492,-0.414 0.634,-0.279 1.161,1.338 -0.381,0.572 z m -0.865,-3.872 c 0.567,-0.444 1.215,-0.8 1.911,-1.046 l -0.497,-0.484 c -0.557,0.214 -1.082,0.497 -1.563,0.834 z m 0.321,0.578 c 0.559,-0.455 1.209,-0.822 1.91,-1.056 l 0.149,0.667 c -0.577,0.189 -1.112,0.468 -1.582,0.827 z m -2.191,5.62 0.665,-0.162 c 0,0 0.035,-1.128 0.021,-0.876 -0.019,0.297 0.073,-0.882 0.073,-0.882 l -0.669,-0.229 c -0.069,0.358 -0.09,0.726 -0.09,1.103 z m -0.551,-2.179 -0.668,0.156 -0.093,1.758 0.66,0.227 0.002,-1.008 c 0,-0.39 0.032,-0.761 0.099,-1.133 m 0.817,-1.846 c 0.159,0.184 0.439,0.205 0.625,0.049 0.187,-0.157 0.208,-0.433 0.049,-0.617 -0.158,-0.183 -0.438,-0.205 -0.624,-0.048 -0.187,0.157 -0.209,0.433 -0.05,0.616 m -0.918,3.443 0.002,1.583 c -0.42,0.131 -0.724,0.518 -0.724,0.974 0,0.457 0.309,0.849 0.727,0.98 l -0.004,2.168 h 0.643 l 0.003,-2.179 c 0.315,-0.104 0.561,-0.347 0.659,-0.662 l 1.735,-0.003 V -5.88 h -1.747 c -0.103,-0.299 -0.34,-0.535 -0.642,-0.637 l -0.002,-1.594 z m 3.323,-5.401 -0.316,-0.569 c -0.543,0.351 -1.025,0.784 -1.442,1.27 -0.329,-0.102 -0.701,-0.041 -0.983,0.196 -0.436,0.366 -0.487,1.012 -0.115,1.441 l 0.055,0.059 c -0.263,0.616 -0.44,1.281 -0.501,1.977 l 0.647,-0.005 c 0.053,-0.594 0.195,-1.157 0.415,-1.687 0.184,0.028 0.377,0.004 0.554,-0.064 l 1.621,1.869 0.489,-0.412 -1.611,-1.863 c 0.216,-0.345 0.207,-0.789 -0.041,-1.13 0.358,-0.413 0.769,-0.779 1.228,-1.082 m -2.575,14.284 2.392,-2.783 0.489,0.412 -2.404,2.773 c 0.048,0.074 0.081,0.155 0.11,0.241 h 1.749 v 0.635 h -1.749 c -0.134,0.41 -0.527,0.705 -0.988,0.705 -0.574,0 -1.037,-0.457 -1.037,-1.022 0,-0.446 0.292,-0.827 0.697,-0.966 l -0.005,-2.146 h 0.644 l 0.001,2.134 c 0.026,0.008 0.077,0.007 0.101,0.017 m 5.074,-6.837 c -0.033,0.057 -0.057,0.118 -0.079,0.181 h -1.622 v 0.634 h 1.612 c 0.017,0.055 0.044,0.109 0.071,0.16 l -1.99,2.301 0.489,0.412 1.965,-2.262 c 0.033,0.017 0.069,0.031 0.105,0.044 v 3.015 h 0.644 v -2.997 c 0.028,-0.008 0.073,-0.017 0.1,-0.028 l 1.918,2.269 0.492,-0.407 -1.925,-2.258 c 0.05,-0.076 0.085,-0.159 0.111,-0.249 H 2.255 V -5.88 L 0.686,-5.884 C 0.661,-5.955 0.624,-6.021 0.584,-6.084 L 2.407,-8.24 1.918,-8.651 0.105,-6.492 C 0.071,-6.505 0.054,-6.521 0.017,-6.53 L 0.013,-10.095 H -0.63 v 3.58 c -0.028,0.01 -0.05,0.024 -0.078,0.036 l -1.887,-2.172 -0.488,0.411 z m 1.86,-8.374 c 0.509,0.082 0.979,0.228 1.442,0.432 l 0.319,-0.565 c -0.534,-0.238 -1.109,-0.41 -1.706,-0.503 -0.1,-0.461 -0.515,-0.807 -1.012,-0.807 -0.496,0 -0.91,0.342 -1.013,0.799 -0.632,0.09 -1.232,0.26 -1.794,0.511 l 0.32,0.565 c 0.489,-0.214 1.008,-0.357 1.548,-0.436 0.115,0.257 0.324,0.458 0.598,0.549 l 0.005,2.765 h 0.643 l 0.006,-2.755 c 0.285,-0.087 0.524,-0.29 0.644,-0.555"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.7632,20.5153)",
    id: "g2146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2148",
    style: {
      fill: "none",
      stroke: "#a07e00",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 0.666,-0.193 V -1.955 L 0,-2.145 Z m -0.639,0 -0.666,-0.193 v -1.762 l 0.666,-0.19 z M 1.693,2.056 1.89,2.712 H 3.676 L 3.87,2.056 Z m 0,-0.638 L 1.89,0.761 H 3.676 L 3.87,1.418 Z m -2.475,0.319 c 0,0.242 0.2,0.437 0.445,0.437 0.244,0 0.443,-0.195 0.443,-0.437 0,-0.241 -0.199,-0.437 -0.443,-0.437 -0.245,0 -0.445,0.196 -0.445,0.437 z m 6.368,0 c 0,0.242 0.199,0.437 0.445,0.437 0.244,0 0.443,-0.195 0.443,-0.437 C 6.474,1.496 6.275,1.3 6.031,1.3 5.785,1.3 5.586,1.496 5.586,1.737 Z m -6.218,-13.407 -0.667,0.193 v 1.761 l 0.667,0.19 z m 0.647,0 0.666,0.193 v 1.761 l -0.666,0.19 z m -0.753,-3.186 c 0,0.242 0.198,0.437 0.444,0.437 0.244,0 0.443,-0.195 0.443,-0.437 0,-0.241 -0.199,-0.437 -0.443,-0.437 -0.246,0 -0.444,0.196 -0.444,0.437 z M 3.855,-5.882 3.659,-6.539 H 1.871 l -0.193,0.657 z m 0,0.637 -0.196,0.658 H 1.871 L 1.678,-5.245 Z M 5.584,-5.55 c 0,0.242 0.198,0.438 0.443,0.438 0.245,0 0.444,-0.196 0.444,-0.438 0,-0.241 -0.199,-0.436 -0.444,-0.436 -0.245,0 -0.443,0.195 -0.443,0.436 z m -7.92,7.606 -0.196,0.656 H -4.319 L -4.512,2.056 Z m 0,-0.638 -0.196,-0.657 h -1.787 l -0.193,0.657 z m -4.781,0.319 c 0,0.242 0.199,0.437 0.444,0.437 0.245,0 0.444,-0.195 0.444,-0.437 0,-0.241 -0.199,-0.437 -0.444,-0.437 -0.245,0 -0.444,0.196 -0.444,0.437 z m 2.62,-7.619 0.196,-0.657 h 1.787 l 0.194,0.657 z m 0,0.637 0.196,0.658 h 1.787 L -2.32,-5.245 Z M 3.538,-1.533 3.922,-2.104 2.773,-3.452 2.139,-3.176 Z M 3.042,-1.124 2.405,-0.849 1.257,-2.198 1.643,-2.766 Z m -7.287,-0.465 -0.378,-0.573 1.16,-1.339 0.632,0.282 z m 0.492,0.414 0.635,0.28 1.16,-1.339 -0.381,-0.571 z m 7.2,-8.262 0.38,0.574 -1.161,1.339 -0.632,-0.282 z M 2.955,-9.851 2.321,-10.13 1.16,-8.792 1.542,-8.22 Z m 3.385,9.023 0.667,-0.194 v -1.76 L 6.34,-2.973 Z m -0.646,0 -0.668,-0.194 v -1.76 l 0.668,-0.191 z m -12.057,0 0.667,-0.194 v -1.76 l -0.667,-0.191 z m -0.647,0 -0.666,-0.194 v -1.76 L -7.01,-2.973 Z M 3.82,-13.723 c -0.567,-0.444 -1.215,-0.8 -1.91,-1.046 l 0.496,-0.484 c 0.557,0.214 1.082,0.497 1.563,0.834 z M 3.5,-13.145 C 2.94,-13.6 2.29,-13.967 1.589,-14.201 l -0.149,0.667 c 0.578,0.189 1.113,0.468 1.582,0.827 z M 0.003,0.771 -0.002,-0.545 h -0.644 l 0.001,1.306 C -0.963,0.859 -1.216,1.106 -1.32,1.419 h -1.569 v 0.635 h 1.569 c 0.135,0.409 0.522,0.705 0.983,0.705 0.46,0 0.849,-0.296 0.984,-0.705 h 1.6 V 1.419 H 0.643 C 0.542,1.115 0.31,0.875 0.003,0.771 Z M 6.347,0.763 6.342,-1.375 H 5.698 L 5.699,0.771 C 5.648,0.787 5.601,0.807 5.555,0.832 L 3.176,-1.955 2.683,-1.547 5.108,1.292 C 5.087,1.333 5.067,1.376 5.052,1.419 h -1.76 v 0.635 h 1.755 c 0.135,0.409 0.522,0.705 0.984,0.705 0.573,0 1.036,-0.457 1.036,-1.022 0,-0.457 -0.3,-0.844 -0.72,-0.974 z M 5.689,-7.525 5.025,-7.687 c 0,0 -0.035,-1.128 -0.02,-0.876 0.018,0.297 -0.074,-0.882 -0.074,-0.882 l 0.67,-0.229 c 0.068,0.358 0.089,0.726 0.089,1.103 z m 0.553,-2.179 0.667,0.156 0.093,1.758 -0.66,0.227 -0.002,-1.008 c 0,-0.39 -0.032,-0.761 -0.098,-1.133 z M 5.424,-11.55 c -0.159,0.184 -0.439,0.205 -0.625,0.049 -0.187,-0.157 -0.208,-0.433 -0.049,-0.617 0.158,-0.183 0.439,-0.205 0.625,-0.048 0.186,0.157 0.208,0.433 0.049,0.616 z m 0.918,3.443 -0.002,1.583 c 0.42,0.131 0.725,0.518 0.725,0.974 0,0.457 -0.31,0.849 -0.728,0.98 l 0.005,2.168 H 5.698 L 5.695,-4.581 C 5.379,-4.685 5.134,-4.928 5.036,-5.243 L 3.302,-5.246 V -5.88 H 5.048 C 5.152,-6.179 5.389,-6.415 5.69,-6.517 l 0.002,-1.594 z m -3.323,-5.401 0.317,-0.569 c 0.541,0.351 1.024,0.784 1.441,1.27 0.329,-0.102 0.702,-0.041 0.984,0.196 0.435,0.366 0.487,1.012 0.114,1.441 l -0.054,0.059 c 0.262,0.616 0.44,1.281 0.501,1.977 L 5.674,-9.139 c -0.052,-0.594 -0.195,-1.157 -0.416,-1.687 -0.182,0.028 -0.376,0.004 -0.551,-0.064 l -1.623,1.869 -0.489,-0.412 1.612,-1.863 c -0.216,-0.345 -0.208,-0.789 0.041,-1.13 -0.359,-0.413 -0.769,-0.779 -1.229,-1.082 z M -7.147,-5.55 c 0,0.242 0.198,0.438 0.443,0.438 0.245,0 0.444,-0.196 0.444,-0.438 0,-0.241 -0.199,-0.436 -0.444,-0.436 -0.245,0 -0.443,0.195 -0.443,0.436 z m 3.023,-3.887 -0.379,0.574 1.161,1.339 0.632,-0.282 z m 0.492,-0.414 0.634,-0.279 1.161,1.338 -0.381,0.572 z m -0.865,-3.872 c 0.567,-0.444 1.215,-0.8 1.911,-1.046 l -0.497,-0.484 c -0.557,0.214 -1.082,0.497 -1.563,0.834 z m 0.321,0.578 c 0.559,-0.455 1.209,-0.822 1.91,-1.056 l 0.149,0.667 c -0.577,0.189 -1.112,0.468 -1.582,0.827 z m -2.191,5.62 0.665,-0.162 c 0,0 0.035,-1.128 0.021,-0.876 -0.019,0.297 0.073,-0.882 0.073,-0.882 l -0.669,-0.229 c -0.069,0.358 -0.09,0.726 -0.09,1.103 z m -0.551,-2.179 -0.668,0.156 -0.093,1.758 0.66,0.227 0.002,-1.008 c 0,-0.39 0.032,-0.761 0.099,-1.133 z m 0.817,-1.846 c 0.159,0.184 0.439,0.205 0.625,0.049 0.187,-0.157 0.208,-0.433 0.049,-0.617 -0.158,-0.183 -0.438,-0.205 -0.624,-0.048 -0.187,0.157 -0.209,0.433 -0.05,0.616 z m -0.918,3.443 0.002,1.583 c -0.42,0.131 -0.724,0.518 -0.724,0.974 0,0.457 0.309,0.849 0.727,0.98 l -0.004,2.168 h 0.643 l 0.003,-2.179 c 0.315,-0.104 0.561,-0.347 0.659,-0.662 l 1.735,-0.003 V -5.88 h -1.747 c -0.103,-0.299 -0.34,-0.535 -0.642,-0.637 l -0.002,-1.594 z m 3.323,-5.401 -0.316,-0.569 c -0.543,0.351 -1.025,0.784 -1.442,1.27 -0.329,-0.102 -0.701,-0.041 -0.983,0.196 -0.436,0.366 -0.487,1.012 -0.115,1.441 l 0.055,0.059 c -0.263,0.616 -0.44,1.281 -0.501,1.977 l 0.647,-0.005 c 0.053,-0.594 0.195,-1.157 0.415,-1.687 0.184,0.028 0.377,0.004 0.554,-0.064 l 1.621,1.869 0.489,-0.412 -1.611,-1.863 c 0.216,-0.345 0.207,-0.789 -0.041,-1.13 0.358,-0.413 0.769,-0.779 1.228,-1.082 z m -2.575,14.284 2.392,-2.783 0.489,0.412 -2.404,2.773 c 0.048,0.074 0.081,0.155 0.11,0.241 h 1.749 v 0.635 h -1.749 c -0.134,0.41 -0.527,0.705 -0.988,0.705 -0.574,0 -1.037,-0.457 -1.037,-1.022 0,-0.446 0.292,-0.827 0.697,-0.966 l -0.005,-2.146 h 0.644 l 0.001,2.134 c 0.026,0.008 0.077,0.007 0.101,0.017 z m 5.074,-6.837 c -0.033,0.057 -0.057,0.118 -0.079,0.181 h -1.622 v 0.634 h 1.612 c 0.017,0.055 0.044,0.109 0.071,0.16 l -1.99,2.301 0.489,0.412 1.965,-2.262 c 0.033,0.017 0.069,0.031 0.105,0.044 v 3.015 h 0.644 v -2.997 c 0.028,-0.008 0.073,-0.017 0.1,-0.028 l 1.918,2.269 0.492,-0.407 -1.925,-2.258 c 0.05,-0.076 0.085,-0.159 0.111,-0.249 H 2.255 V -5.88 L 0.686,-5.884 C 0.661,-5.955 0.624,-6.021 0.584,-6.084 L 2.407,-8.24 1.918,-8.651 0.105,-6.492 C 0.071,-6.505 0.054,-6.521 0.017,-6.53 L 0.013,-10.095 H -0.63 v 3.58 c -0.028,0.01 -0.05,0.024 -0.078,0.036 l -1.887,-2.172 -0.488,0.411 z m 1.86,-8.374 c 0.509,0.082 0.979,0.228 1.442,0.432 l 0.319,-0.565 c -0.534,-0.238 -1.109,-0.41 -1.706,-0.503 -0.1,-0.461 -0.515,-0.807 -1.012,-0.807 -0.496,0 -0.91,0.342 -1.013,0.799 -0.632,0.09 -1.232,0.26 -1.794,0.511 l 0.32,0.565 c 0.489,-0.214 1.008,-0.357 1.548,-0.436 0.115,0.257 0.324,0.458 0.598,0.549 l 0.005,2.765 h 0.643 l 0.006,-2.755 c 0.285,-0.087 0.524,-0.29 0.644,-0.555 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.4317,14.9557)",
    id: "g2150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2152",
    style: {
      fill: "#006f46",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.564 0.465,1.022 1.037,1.022 1.61,1.022 2.075,0.564 2.075,0 2.075,-0.564 1.61,-1.021 1.037,-1.021 0.465,-1.021 0,-0.564 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.6963,41.6603)",
    id: "g2154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2156",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 0.022,0.243 0.054,0.38 c 0,0 -0.611,-0.052 -0.932,0.043 -0.322,0.095 -0.612,0.232 -0.912,0.496 -0.3,0.264 -0.418,0.43 -0.632,0.465 -0.515,0.084 -0.911,-0.158 -0.911,-0.158 0,0 0.385,-0.148 0.674,-0.518 0.29,-0.37 0.605,-0.558 0.741,-0.602 C -1.693,0.032 -0.911,0.084 -0.696,0.074 -0.482,0.064 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.6963,41.6603)",
    id: "g2158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2160",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 0.022,0.243 0.054,0.38 c 0,0 -0.611,-0.052 -0.932,0.043 -0.322,0.095 -0.612,0.232 -0.912,0.496 -0.3,0.264 -0.418,0.43 -0.632,0.465 -0.515,0.084 -0.911,-0.158 -0.911,-0.158 0,0 0.385,-0.148 0.674,-0.518 0.29,-0.37 0.605,-0.558 0.741,-0.602 C -1.693,0.032 -0.911,0.084 -0.696,0.074 -0.482,0.064 0,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.5528,42.5539)",
    id: "g2162"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2164",
    style: {
      fill: "#d95aaf",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 0.002,-0.285 0.03,-0.555 0.026,-0.261 -0.082,-0.49 -0.041,-0.635 0.04,-0.145 0.06,-0.26 0.114,-0.365 0.053,-0.106 0.081,-0.37 0.081,-0.37 0,0 -0.148,0.106 -0.282,0.211 -0.134,0.106 -0.229,0.172 -0.229,0.172 0,0 0.028,-0.284 0.041,-0.405 0.014,-0.122 0.082,-0.352 0.192,-0.488 0.111,-0.135 0.33,-0.351 0.399,-0.527 0.068,-0.176 0.054,-0.567 0.054,-0.567 0,0 -0.179,0.297 -0.329,0.351 -0.151,0.053 -0.481,0.243 -0.481,0.243 0,0 0.302,-0.31 0.302,-0.608 0,-0.297 -0.123,-0.635 -0.123,-0.635 0,0 -0.137,0.27 -0.315,0.446 -0.179,0.176 -0.426,0.351 -0.426,0.351 0,0 0.193,-0.459 0.193,-0.77 0,-0.311 -0.055,-0.974 -0.055,-0.974 0,0 -0.151,0.257 -0.303,0.378 -0.15,0.122 -0.329,0.23 -0.384,0.311 -0.054,0.082 0.179,-0.256 0.206,-0.46 0.028,-0.202 0.119,-0.926 0.728,-1.852 0.356,-0.541 0.906,-1.487 2.086,-1.177 1.18,0.311 0.741,1.961 0.494,2.732 -0.247,0.771 -0.371,1.622 -0.357,1.92 0.013,0.297 0.219,1.177 0.192,1.339 -0.028,0.162 -0.09,0.79 0.054,1.298 0.152,0.527 0.276,0.73 0.358,0.947 0.081,0.216 0.15,0.338 0.176,0.527 0.028,0.189 0.028,0.541 0.028,0.541 0,0 0.22,-0.419 0.275,-0.568 0.055,-0.149 0.055,-0.595 0.055,-0.595 0,0 0.041,0.446 0.371,0.662 0.329,0.217 0.713,0.447 0.81,0.569 0.096,0.121 0.123,0.202 0.123,0.202 0,0 -0.027,-0.757 -0.233,-1.055 C 3.668,0.399 3.131,-0.23 3.131,-0.23 c 0,0 0.275,0.108 0.467,0.121 0.192,0.014 0.329,0 0.329,0 0,0 -0.233,-0.19 -0.535,-0.649 C 3.09,-1.217 3.213,-1.258 2.994,-1.636 2.774,-2.015 2.596,-2.029 2.322,-2.259 1.91,-2.604 2.13,-3.977 2.184,-4.178 2.24,-4.38 2.953,-6.058 2.966,-6.463 2.98,-6.869 3.048,-7.776 2.363,-8.357 1.919,-8.732 1.196,-8.737 1.032,-8.844 0.867,-8.952 0.538,-9.29 0.538,-9.993 c 0,-0.704 0.247,-0.812 0.439,-0.987 0.192,-0.177 0.439,-0.082 0.494,-0.217 0.055,-0.136 0.083,-0.217 0.165,-0.298 0.082,-0.081 0.137,-0.174 0.11,-0.323 -0.028,-0.149 -0.344,-0.487 -0.454,-0.731 -0.109,-0.243 -0.329,-0.879 -0.329,-0.974 0,-0.094 -0.027,-0.392 0.069,-0.541 0,0 0.343,-0.418 0.11,-0.499 -0.151,-0.053 -0.299,0.1 -0.371,0.081 -0.207,-0.054 -0.31,-0.188 -0.371,-0.176 -0.136,0.027 -0.136,0.095 -0.151,0.298 -0.013,0.201 -0.007,0.283 -0.069,0.283 -0.082,0 -0.122,-0.069 -0.137,-0.176 -0.013,-0.107 -0.013,-0.351 -0.11,-0.351 -0.096,0 -0.232,0.176 -0.316,0.216 -0.081,0.041 -0.314,0.081 -0.328,0.189 -0.014,0.108 0.137,0.338 0.287,0.379 0.152,0.04 0.288,0.121 0.193,0.203 -0.096,0.081 -0.191,0.081 -0.288,0 -0.096,-0.082 -0.301,-0.014 -0.288,0.108 0.014,0.122 0.041,0.271 0.028,0.338 -0.014,0.067 -0.179,0.203 0.041,0.324 0.219,0.122 0.314,-0.108 0.534,-0.067 0.221,0.04 0.33,0.122 0.412,0.257 0.083,0.135 0.069,0.419 -0.082,0.595 -0.151,0.176 -0.303,0.203 -0.357,0.312 -0.055,0.107 -0.137,0.364 -0.137,0.364 0,0 0.041,-0.473 0.013,-0.54 -0.028,-0.068 -0.013,-0.352 -0.013,-0.352 0,0 -0.151,0.176 -0.274,0.311 -0.124,0.135 -0.247,0.54 -0.247,0.54 0,0 -0.014,-0.378 -0.014,-0.526 0,-0.149 0.165,-0.285 0.11,-0.339 -0.054,-0.054 -0.316,0.284 -0.385,0.339 -0.069,0.054 -0.288,0.228 -0.384,0.418 -0.096,0.189 -0.164,0.459 -0.192,0.555 -0.028,0.094 -0.073,0.515 -0.028,0.622 0.069,0.162 0.179,0.446 0.179,0.446 h -0.535 c -0.288,0 -0.494,0.095 -0.604,-0.109 -0.111,-0.202 -0.055,-0.609 0.082,-1.136 0.138,-0.526 0.219,-0.783 0.178,-0.878 -0.04,-0.094 -0.219,-0.311 -0.288,-0.351 -0.068,-0.041 -0.261,-0.028 -0.343,0.013 -0.082,0.041 -0.219,0.108 -0.48,0.108 -0.26,0 -0.425,-0.013 -0.521,0.014 -0.096,0.027 -0.329,0.149 -0.439,0.122 -0.11,-0.028 -0.3,-0.129 -0.247,-0.285 0.082,-0.243 -0.083,-0.297 -0.193,-0.284 -0.11,0.014 -0.205,0.054 -0.343,0.095 -0.137,0.04 -0.343,0 -0.315,0.162 0.026,0.163 0.082,0.176 0.151,0.298 0.068,0.122 0.095,0.2 0.018,0.208 -0.097,0.011 -0.193,0.022 -0.268,-0.042 -0.076,-0.063 -0.193,-0.2 -0.29,-0.148 -0.097,0.053 -0.172,0.169 -0.172,0.423 0,0.253 -0.257,0.475 -0.021,0.465 0.235,-0.011 0.536,-0.19 0.589,-0.053 0.054,0.138 0.022,0.201 -0.106,0.306 -0.13,0.106 -0.29,0.17 -0.118,0.307 0.171,0.137 0.214,0.137 0.278,0.211 0.065,0.074 0.158,0.313 0.279,0.254 0.236,-0.117 0.01,-0.286 0.246,-0.56 0.236,-0.275 0.386,-0.37 0.784,-0.328 0.396,0.042 0.504,0.095 0.504,0.211 0,0.117 -0.033,0.328 -0.044,0.412 -0.011,0.085 0.053,0.391 0.053,0.391 0,0 -0.181,-0.116 -0.235,-0.232 -0.054,-0.116 -0.161,-0.317 -0.161,-0.317 0,0 -0.045,0.239 -0.032,0.433 0.008,0.113 0.047,0.31 0.042,0.348 -0.01,0.106 -0.085,0.37 -0.085,0.37 0,0 -0.064,-0.285 -0.108,-0.37 -0.042,-0.084 -0.064,-0.422 -0.064,-0.422 0,0 -0.252,0.228 -0.181,0.613 0.053,0.295 -0.044,0.686 0.042,0.813 0.085,0.127 0.29,0.645 0.782,0.666 0.495,0.021 0.88,-0.021 1.052,-0.011 0.171,0.011 0.782,0.127 0.782,0.127 0,0 -1.125,0.602 -1.383,0.781 -0.258,0.181 -0.654,0.645 -0.783,0.856 -0.128,0.212 -0.247,0.623 -0.247,0.623 0,0 -0.203,-0.01 -0.385,-0.116 -0.183,-0.105 -0.364,-0.264 -0.472,-0.39 -0.107,-0.127 -0.278,-0.412 -0.278,-0.412 0,0 0.032,0.37 0.032,0.486 0,0.116 -0.022,0.338 -0.022,0.338 0,0 -0.128,-0.508 -0.386,-0.697 -0.257,-0.191 -0.557,-0.455 -0.557,-0.455 0,0 0.031,0.285 0.031,0.349 0,0.063 0.066,0.391 0.066,0.391 0,0 -0.183,-0.285 -0.462,-0.338 -0.279,-0.053 -0.686,-0.043 -0.718,-0.222 -0.033,-0.18 0.075,-0.423 0.011,-0.55 -0.065,-0.126 -0.204,-0.211 -0.204,-0.211 0,0 -0.161,0.137 -0.3,0.148 -0.14,0.011 -0.268,-0.063 -0.268,-0.063 0,0 -0.118,0.158 -0.075,0.263 0.042,0.106 0.257,0.265 0.203,0.328 -0.053,0.063 -0.225,-0.02 -0.332,-0.074 -0.107,-0.052 -0.332,-0.106 -0.311,0.074 0.022,0.18 0.075,0.285 0.022,0.412 -0.054,0.127 -0.022,0.212 0.064,0.243 0.086,0.032 0.429,-0.01 0.46,0.075 0.033,0.083 -0.085,0.189 -0.311,0.242 -0.224,0.053 -0.332,0.19 -0.213,0.306 0.117,0.117 0.15,0.148 0.204,0.254 0.053,0.105 0.074,0.296 0.278,0.201 0.204,-0.096 0.16,-0.328 0.375,-0.401 0.215,-0.075 0.719,0.031 0.826,0.094 0.107,0.064 0.45,0.328 0.568,0.391 0.117,0.063 0.611,0.444 0.611,0.444 0,0 -0.289,0.211 -0.397,0.317 -0.107,0.106 -0.299,0.359 -0.396,0.412 -0.097,0.053 -0.568,0.242 -0.73,0.253 -0.16,0.011 -0.653,0.191 -0.653,0.191 0,0 0.225,0.073 0.3,0.137 0.075,0.063 0.247,0.222 0.332,0.211 0.086,-0.011 0.108,-0.011 0.108,-0.011 0,0 -0.462,0.022 -0.558,0.053 -0.096,0.032 -0.375,0.212 -0.483,0.212 -0.107,0 -0.321,-0.043 -0.321,-0.043 0,0 0.29,0.191 0.525,0.233 0.237,0.042 0.418,0.031 0.418,0.031 0,0 -0.365,0.106 -0.45,0.233 -0.086,0.127 -0.172,0.317 -0.236,0.402 -0.064,0.084 -0.108,0.221 -0.225,0.232 -0.118,0.01 -0.322,-0.148 -0.439,-0.138 -0.118,0.011 -0.204,0.085 -0.215,0.265 -0.01,0.179 0,0.116 -0.043,0.211 -0.043,0.095 -0.214,0.317 -0.053,0.37 0.161,0.053 0.504,-0.032 0.535,0.031 0.033,0.064 -0.181,0.254 -0.321,0.327 -0.14,0.075 -0.364,0.202 -0.246,0.307 0.118,0.106 0.235,0.149 0.299,0.243 0.065,0.095 0.14,0.36 0.28,0.275 0.139,-0.085 0.332,-0.496 0.439,-0.465 0.107,0.032 0.118,0.327 0.096,0.454 -0.021,0.127 0,0.349 0.108,0.328 0.106,-0.021 0.193,-0.169 0.364,-0.18 0.172,-0.01 0.429,0.042 0.407,-0.085 -0.021,-0.127 -0.117,-0.285 -0.235,-0.421 -0.119,-0.138 -0.172,-0.413 -0.097,-0.592 0.075,-0.18 0.268,-0.466 0.44,-0.582 0.171,-0.116 0.493,-0.2 0.696,-0.338 0.204,-0.137 0.676,-0.528 0.836,-0.57 0.161,-0.042 0.323,-0.127 0.323,-0.127 0,0 0.181,0.085 0.428,0.085 0.246,0 0.815,-0.043 1.03,0.053 0.214,0.095 0.493,0.253 0.407,0.454 -0.086,0.201 -0.558,0.38 -0.515,0.538 0.044,0.159 0.215,0.169 0.504,0.18 0.289,0.011 0.687,-0.053 0.762,0.37 0.074,0.423 0.096,0.665 -0.311,0.76 -0.408,0.096 -0.708,0.106 -0.783,0.413 -0.075,0.306 -0.15,0.379 -0.064,0.464 0.085,0.085 0.235,0.127 0.535,0.148 0.301,0.021 0.644,0.021 0.74,0.096 0.097,0.073 0.119,0.274 0.236,0.358 0.118,0.085 0.58,0.161 0.58,0.161 0,0 0.549,-0.28 1.061,-0.677 C -0.412,0.526 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.5528,42.5539)",
    id: "g2166"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2168",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 0.002,-0.285 0.03,-0.555 0.026,-0.261 -0.082,-0.49 -0.041,-0.635 0.04,-0.145 0.06,-0.26 0.114,-0.365 0.053,-0.106 0.081,-0.37 0.081,-0.37 0,0 -0.148,0.106 -0.282,0.211 -0.134,0.106 -0.229,0.172 -0.229,0.172 0,0 0.028,-0.284 0.041,-0.405 0.014,-0.122 0.082,-0.352 0.192,-0.488 0.111,-0.135 0.33,-0.351 0.399,-0.527 0.068,-0.176 0.054,-0.567 0.054,-0.567 0,0 -0.179,0.297 -0.329,0.351 -0.151,0.053 -0.481,0.243 -0.481,0.243 0,0 0.302,-0.31 0.302,-0.608 0,-0.297 -0.123,-0.635 -0.123,-0.635 0,0 -0.137,0.27 -0.315,0.446 -0.179,0.176 -0.426,0.351 -0.426,0.351 0,0 0.193,-0.459 0.193,-0.77 0,-0.311 -0.055,-0.974 -0.055,-0.974 0,0 -0.151,0.257 -0.303,0.378 -0.15,0.122 -0.329,0.23 -0.384,0.311 -0.054,0.082 0.179,-0.256 0.206,-0.46 0.028,-0.202 0.119,-0.926 0.728,-1.852 0.356,-0.541 0.906,-1.487 2.086,-1.177 1.18,0.311 0.741,1.961 0.494,2.732 -0.247,0.771 -0.371,1.622 -0.357,1.92 0.013,0.297 0.219,1.177 0.192,1.339 -0.028,0.162 -0.09,0.79 0.054,1.298 0.152,0.527 0.276,0.73 0.358,0.947 0.081,0.216 0.15,0.338 0.176,0.527 0.028,0.189 0.028,0.541 0.028,0.541 0,0 0.22,-0.419 0.275,-0.568 0.055,-0.149 0.055,-0.595 0.055,-0.595 0,0 0.041,0.446 0.371,0.662 0.329,0.217 0.713,0.447 0.81,0.569 0.096,0.121 0.123,0.202 0.123,0.202 0,0 -0.027,-0.757 -0.233,-1.055 C 3.668,0.399 3.131,-0.23 3.131,-0.23 c 0,0 0.275,0.108 0.467,0.121 0.192,0.014 0.329,0 0.329,0 0,0 -0.233,-0.19 -0.535,-0.649 C 3.09,-1.217 3.213,-1.258 2.994,-1.636 2.774,-2.015 2.596,-2.029 2.322,-2.259 1.91,-2.604 2.13,-3.977 2.184,-4.178 2.24,-4.38 2.953,-6.058 2.966,-6.463 2.98,-6.869 3.048,-7.776 2.363,-8.357 1.919,-8.732 1.196,-8.737 1.032,-8.844 0.867,-8.952 0.538,-9.29 0.538,-9.993 c 0,-0.704 0.247,-0.812 0.439,-0.987 0.192,-0.177 0.439,-0.082 0.494,-0.217 0.055,-0.136 0.083,-0.217 0.165,-0.298 0.082,-0.081 0.137,-0.174 0.11,-0.323 -0.028,-0.149 -0.344,-0.487 -0.454,-0.731 -0.109,-0.243 -0.329,-0.879 -0.329,-0.974 0,-0.094 -0.027,-0.392 0.069,-0.541 0,0 0.343,-0.418 0.11,-0.499 -0.151,-0.053 -0.299,0.1 -0.371,0.081 -0.207,-0.054 -0.31,-0.188 -0.371,-0.176 -0.136,0.027 -0.136,0.095 -0.151,0.298 -0.013,0.201 -0.007,0.283 -0.069,0.283 -0.082,0 -0.122,-0.069 -0.137,-0.176 -0.013,-0.107 -0.013,-0.351 -0.11,-0.351 -0.096,0 -0.232,0.176 -0.316,0.216 -0.081,0.041 -0.314,0.081 -0.328,0.189 -0.014,0.108 0.137,0.338 0.287,0.379 0.152,0.04 0.288,0.121 0.193,0.203 -0.096,0.081 -0.191,0.081 -0.288,0 -0.096,-0.082 -0.301,-0.014 -0.288,0.108 0.014,0.122 0.041,0.271 0.028,0.338 -0.014,0.067 -0.179,0.203 0.041,0.324 0.219,0.122 0.314,-0.108 0.534,-0.067 0.221,0.04 0.33,0.122 0.412,0.257 0.083,0.135 0.069,0.419 -0.082,0.595 -0.151,0.176 -0.303,0.203 -0.357,0.312 -0.055,0.107 -0.137,0.364 -0.137,0.364 0,0 0.041,-0.473 0.013,-0.54 -0.028,-0.068 -0.013,-0.352 -0.013,-0.352 0,0 -0.151,0.176 -0.274,0.311 -0.124,0.135 -0.247,0.54 -0.247,0.54 0,0 -0.014,-0.378 -0.014,-0.526 0,-0.149 0.165,-0.285 0.11,-0.339 -0.054,-0.054 -0.316,0.284 -0.385,0.339 -0.069,0.054 -0.288,0.228 -0.384,0.418 -0.096,0.189 -0.164,0.459 -0.192,0.555 -0.028,0.094 -0.073,0.515 -0.028,0.622 0.069,0.162 0.179,0.446 0.179,0.446 h -0.535 c -0.288,0 -0.494,0.095 -0.604,-0.109 -0.111,-0.202 -0.055,-0.609 0.082,-1.136 0.138,-0.526 0.219,-0.783 0.178,-0.878 -0.04,-0.094 -0.219,-0.311 -0.288,-0.351 -0.068,-0.041 -0.261,-0.028 -0.343,0.013 -0.082,0.041 -0.219,0.108 -0.48,0.108 -0.26,0 -0.425,-0.013 -0.521,0.014 -0.096,0.027 -0.329,0.149 -0.439,0.122 -0.11,-0.028 -0.3,-0.129 -0.247,-0.285 0.082,-0.243 -0.083,-0.297 -0.193,-0.284 -0.11,0.014 -0.205,0.054 -0.343,0.095 -0.137,0.04 -0.343,0 -0.315,0.162 0.026,0.163 0.082,0.176 0.151,0.298 0.068,0.122 0.095,0.2 0.018,0.208 -0.097,0.011 -0.193,0.022 -0.268,-0.042 -0.076,-0.063 -0.193,-0.2 -0.29,-0.148 -0.097,0.053 -0.172,0.169 -0.172,0.423 0,0.253 -0.257,0.475 -0.021,0.465 0.235,-0.011 0.536,-0.19 0.589,-0.053 0.054,0.138 0.022,0.201 -0.106,0.306 -0.13,0.106 -0.29,0.17 -0.118,0.307 0.171,0.137 0.214,0.137 0.278,0.211 0.065,0.074 0.158,0.313 0.279,0.254 0.236,-0.117 0.01,-0.286 0.246,-0.56 0.236,-0.275 0.386,-0.37 0.784,-0.328 0.396,0.042 0.504,0.095 0.504,0.211 0,0.117 -0.033,0.328 -0.044,0.412 -0.011,0.085 0.053,0.391 0.053,0.391 0,0 -0.181,-0.116 -0.235,-0.232 -0.054,-0.116 -0.161,-0.317 -0.161,-0.317 0,0 -0.045,0.239 -0.032,0.433 0.008,0.113 0.047,0.31 0.042,0.348 -0.01,0.106 -0.085,0.37 -0.085,0.37 0,0 -0.064,-0.285 -0.108,-0.37 -0.042,-0.084 -0.064,-0.422 -0.064,-0.422 0,0 -0.252,0.228 -0.181,0.613 0.053,0.295 -0.044,0.686 0.042,0.813 0.085,0.127 0.29,0.645 0.782,0.666 0.495,0.021 0.88,-0.021 1.052,-0.011 0.171,0.011 0.782,0.127 0.782,0.127 0,0 -1.125,0.602 -1.383,0.781 -0.258,0.181 -0.654,0.645 -0.783,0.856 -0.128,0.212 -0.247,0.623 -0.247,0.623 0,0 -0.203,-0.01 -0.385,-0.116 -0.183,-0.105 -0.364,-0.264 -0.472,-0.39 -0.107,-0.127 -0.278,-0.412 -0.278,-0.412 0,0 0.032,0.37 0.032,0.486 0,0.116 -0.022,0.338 -0.022,0.338 0,0 -0.128,-0.508 -0.386,-0.697 -0.257,-0.191 -0.557,-0.455 -0.557,-0.455 0,0 0.031,0.285 0.031,0.349 0,0.063 0.066,0.391 0.066,0.391 0,0 -0.183,-0.285 -0.462,-0.338 -0.279,-0.053 -0.686,-0.043 -0.718,-0.222 -0.033,-0.18 0.075,-0.423 0.011,-0.55 -0.065,-0.126 -0.204,-0.211 -0.204,-0.211 0,0 -0.161,0.137 -0.3,0.148 -0.14,0.011 -0.268,-0.063 -0.268,-0.063 0,0 -0.118,0.158 -0.075,0.263 0.042,0.106 0.257,0.265 0.203,0.328 -0.053,0.063 -0.225,-0.02 -0.332,-0.074 -0.107,-0.052 -0.332,-0.106 -0.311,0.074 0.022,0.18 0.075,0.285 0.022,0.412 -0.054,0.127 -0.022,0.212 0.064,0.243 0.086,0.032 0.429,-0.01 0.46,0.075 0.033,0.083 -0.085,0.189 -0.311,0.242 -0.224,0.053 -0.332,0.19 -0.213,0.306 0.117,0.117 0.15,0.148 0.204,0.254 0.053,0.105 0.074,0.296 0.278,0.201 0.204,-0.096 0.16,-0.328 0.375,-0.401 0.215,-0.075 0.719,0.031 0.826,0.094 0.107,0.064 0.45,0.328 0.568,0.391 0.117,0.063 0.611,0.444 0.611,0.444 0,0 -0.289,0.211 -0.397,0.317 -0.107,0.106 -0.299,0.359 -0.396,0.412 -0.097,0.053 -0.568,0.242 -0.73,0.253 -0.16,0.011 -0.653,0.191 -0.653,0.191 0,0 0.225,0.073 0.3,0.137 0.075,0.063 0.247,0.222 0.332,0.211 0.086,-0.011 0.108,-0.011 0.108,-0.011 0,0 -0.462,0.022 -0.558,0.053 -0.096,0.032 -0.375,0.212 -0.483,0.212 -0.107,0 -0.321,-0.043 -0.321,-0.043 0,0 0.29,0.191 0.525,0.233 0.237,0.042 0.418,0.031 0.418,0.031 0,0 -0.365,0.106 -0.45,0.233 -0.086,0.127 -0.172,0.317 -0.236,0.402 -0.064,0.084 -0.108,0.221 -0.225,0.232 -0.118,0.01 -0.322,-0.148 -0.439,-0.138 -0.118,0.011 -0.204,0.085 -0.215,0.265 -0.01,0.179 0,0.116 -0.043,0.211 -0.043,0.095 -0.214,0.317 -0.053,0.37 0.161,0.053 0.504,-0.032 0.535,0.031 0.033,0.064 -0.181,0.254 -0.321,0.327 -0.14,0.075 -0.364,0.202 -0.246,0.307 0.118,0.106 0.235,0.149 0.299,0.243 0.065,0.095 0.14,0.36 0.28,0.275 0.139,-0.085 0.332,-0.496 0.439,-0.465 0.107,0.032 0.118,0.327 0.096,0.454 -0.021,0.127 0,0.349 0.108,0.328 0.106,-0.021 0.193,-0.169 0.364,-0.18 0.172,-0.01 0.429,0.042 0.407,-0.085 -0.021,-0.127 -0.117,-0.285 -0.235,-0.421 -0.119,-0.138 -0.172,-0.413 -0.097,-0.592 0.075,-0.18 0.268,-0.466 0.44,-0.582 0.171,-0.116 0.493,-0.2 0.696,-0.338 0.204,-0.137 0.676,-0.528 0.836,-0.57 0.161,-0.042 0.323,-0.127 0.323,-0.127 0,0 0.181,0.085 0.428,0.085 0.246,0 0.815,-0.043 1.03,0.053 0.214,0.095 0.493,0.253 0.407,0.454 -0.086,0.201 -0.558,0.38 -0.515,0.538 0.044,0.159 0.215,0.169 0.504,0.18 0.289,0.011 0.687,-0.053 0.762,0.37 0.074,0.423 0.096,0.665 -0.311,0.76 -0.408,0.096 -0.708,0.106 -0.783,0.413 -0.075,0.306 -0.15,0.379 -0.064,0.464 0.085,0.085 0.235,0.127 0.535,0.148 0.301,0.021 0.644,0.021 0.74,0.096 0.097,0.073 0.119,0.274 0.236,0.358 0.118,0.085 0.58,0.161 0.58,0.161 0,0 0.549,-0.28 1.061,-0.677 C -0.412,0.526 0,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.6035,42.8527)",
    id: "g2170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2172",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -0.064,0.19 -0.075,0.243 -0.011,0.052 -0.043,0.116 -0.043,0.116 0,0 0.332,0 0.321,-0.106 C 0.193,0.148 0.097,0.148 0.075,0.106 0.053,0.063 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.6035,42.8527)",
    id: "g2174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2176",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -0.064,0.19 -0.075,0.243 -0.011,0.052 -0.043,0.116 -0.043,0.116 0,0 0.332,0 0.321,-0.106 C 0.193,0.148 0.097,0.148 0.075,0.106 0.053,0.063 0,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.125,43.402)",
    id: "g2178"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2180",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 -0.021,0.169 c 0,0 0.29,-0.002 0.428,-0.106 0.216,-0.158 0.355,-0.401 0.344,-0.412 -0.038,-0.037 -0.204,0.106 -0.322,0.148 0,0 -0.085,-0.021 -0.171,-0.021 -0.086,0 -0.129,0.043 -0.139,0.084 -0.011,0.043 0.01,0.117 0.01,0.117 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.125,43.402)",
    id: "g2182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2184",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.018,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 -0.021,0.169 c 0,0 0.29,-0.002 0.428,-0.106 0.216,-0.158 0.355,-0.401 0.344,-0.412 -0.038,-0.037 -0.204,0.106 -0.322,0.148 0,0 -0.085,-0.021 -0.171,-0.021 -0.086,0 -0.129,0.043 -0.139,0.084 -0.011,0.043 0.01,0.117 0.01,0.117 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.2159,41.0143)",
    id: "g2186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2188",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 -0.128,0.19 -0.16,0.253 -0.193,0.317 -0.246,0.444 -0.246,0.444"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.3687,42.9157)",
    id: "g2190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2192",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 0.182,-0.137 0.321,-0.158 0.139,-0.021 0.29,-0.021 0.311,-0.021 0.021,0 0.067,0.211 0.043,0.359 -0.074,0.475 -0.493,0.581 -0.493,0.581 0,0 0.125,-0.289 0.064,-0.423 C 0.161,0.148 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.3687,42.9157)",
    id: "g2194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2196",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 0.182,-0.137 0.321,-0.158 0.139,-0.021 0.29,-0.021 0.311,-0.021 0.021,0 0.067,0.211 0.043,0.359 -0.074,0.475 -0.493,0.581 -0.493,0.581 0,0 0.125,-0.289 0.064,-0.423 C 0.161,0.148 0,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.5005,42.5041)",
    id: "g2198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2200",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -0.161,0.306 -0.504,0.264 -0.343,-0.042 -0.568,-0.317 -0.568,-0.317 0,0 0.378,0.011 0.472,-0.053 0.139,-0.095 0.181,-0.338 0.181,-0.338 0,0 0.205,0.127 0.269,0.212 C -0.086,-0.147 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.5005,42.5041)",
    id: "g2202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2204",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -0.161,0.306 -0.504,0.264 -0.343,-0.042 -0.568,-0.317 -0.568,-0.317 0,0 0.378,0.011 0.472,-0.053 0.139,-0.095 0.181,-0.338 0.181,-0.338 0,0 0.205,0.127 0.269,0.212 C -0.086,-0.147 0,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.0816,41.2678)",
    id: "g2206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2208",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -0.29,-0.042 -0.45,-0.232 -0.161,-0.19 -0.139,-0.549 -0.139,-0.549 0,0 0.193,0.211 0.364,0.211 0.171,0 0.439,-0.063 0.439,-0.063 0,0 -0.085,0.221 -0.085,0.316 C 0.129,-0.222 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.0816,41.2678)",
    id: "g2210"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2212",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -0.29,-0.042 -0.45,-0.232 -0.161,-0.19 -0.139,-0.549 -0.139,-0.549 0,0 0.193,0.211 0.364,0.211 0.171,0 0.439,-0.063 0.439,-0.063 0,0 -0.085,0.221 -0.085,0.316 C 0.129,-0.222 0,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.6133,41.3102)",
    id: "g2214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2216",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 0.129,0.211 0.258,0.021 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.6133,41.3102)",
    id: "g2218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2220",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 0.129,0.211 0.258,0.021 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.9248,41.321)",
    id: "g2222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2224",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 0.15,0.211 0.311,0.021 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.9248,41.321)",
    id: "g2226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2228",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 0.15,0.211 0.311,0.021 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.7852,42.6203)",
    id: "g2230"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2232",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 0.311,-0.116 0.033,-0.264 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.7852,42.6203)",
    id: "g2234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2236",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 0.311,-0.116 0.033,-0.264 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.1607,42.5148)",
    id: "g2238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2240",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 0.279,-0.074 0.053,-0.254 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.1607,42.5148)",
    id: "g2242"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2244",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 0.279,-0.074 0.053,-0.254 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.0703,40.0319)",
    id: "g2246"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2248",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -0.306,-0.093 -0.418,-0.264 -0.14,-0.211 -0.129,-0.423 -0.129,-0.423 0,0 0.257,0.222 0.589,0.127 0.333,-0.095 0.366,-0.127 0.504,-0.116 0.14,0.01 0.483,0.137 0.483,0.137 0,0 -0.279,-0.337 -0.247,-0.57 0.033,-0.232 0.074,-0.337 0.065,-0.454 -0.022,-0.286 -0.225,-0.634 -0.225,-0.634 0,0 0.118,0.074 0.396,0.137 0.279,0.063 0.515,0.201 0.665,0.317 0.15,0.117 0.342,0.402 0.342,0.402 0,0 -0.063,-0.391 0,-0.56 0.065,-0.169 0.087,-0.656 0.087,-0.656 0,0 0.18,0.163 0.321,0.243 0.075,0.043 0.268,0.148 0.343,0.275 0.054,0.09 0.119,0.423 0.119,0.423 0,0 0.042,-0.36 0.15,-0.529 0.106,-0.169 0.268,-0.686 0.268,-0.686 0,0 0.106,0.338 0.224,0.476 0.118,0.137 0.258,0.316 0.269,0.421 0.01,0.106 -0.033,0.339 -0.033,0.339 l 0.15,-0.339"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.6631,37.8557)",
    id: "g2250"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2252",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 0.182,0.328 0.354,0.434 0.525,0.539 0.761,0.729 0.825,0.75 0.89,0.771 1.168,0.93 1.168,0.93"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.2061,36.7463)",
    id: "g2254"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2256",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 0.413,0.22 0.537,0.296 0.793,0.455 0.977,0.74 0.977,0.74"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.0576,37.2746)",
    id: "g2258"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2260",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0 -0.161,0.18 -0.439,0.127 -0.718,0.074 -0.9,-0.253 -0.9,-0.253 c 0,0 0.235,0.063 0.374,0.032 0.14,-0.032 0.236,-0.18 0.236,-0.18 0,0 0.129,0.116 0.171,0.18 C -0.075,-0.158 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.0576,37.2746)",
    id: "g2262"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2264",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 -0.161,0.18 -0.439,0.127 -0.718,0.074 -0.9,-0.253 -0.9,-0.253 c 0,0 0.235,0.063 0.374,0.032 0.14,-0.032 0.236,-0.18 0.236,-0.18 0,0 0.129,0.116 0.171,0.18 C -0.075,-0.158 0,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.7364,36.1022)",
    id: "g2266"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2268",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -0.236,0.042 -0.44,-0.127 -0.203,-0.169 -0.215,-0.497 -0.215,-0.497 0,0 0.194,0.169 0.344,0.148 0.15,-0.021 0.332,-0.105 0.332,-0.105 0,0 0.031,0.202 0.043,0.253 C 0.096,-0.18 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.7364,36.1022)",
    id: "g2270"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2272",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -0.236,0.042 -0.44,-0.127 -0.203,-0.169 -0.215,-0.497 -0.215,-0.497 0,0 0.194,0.169 0.344,0.148 0.15,-0.021 0.332,-0.105 0.332,-0.105 0,0 0.031,0.202 0.043,0.253 C 0.096,-0.18 0,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.2827,35.0246)",
    id: "g2274"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2276",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -0.015,-0.314 0.129,-0.507 0.15,-0.201 0.429,-0.233 0.429,-0.233 0,0 -0.094,0.211 -0.108,0.318 -0.021,0.158 0.129,0.295 0.129,0.295 0,0 -0.139,0.148 -0.279,0.148 C 0.16,0.021 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.2827,35.0246)",
    id: "g2278"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2280",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -0.015,-0.314 0.129,-0.507 0.15,-0.201 0.429,-0.233 0.429,-0.233 0,0 -0.094,0.211 -0.108,0.318 -0.021,0.158 0.129,0.295 0.129,0.295 0,0 -0.139,0.148 -0.279,0.148 C 0.16,0.021 0,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.6075,34.4963)",
    id: "g2282"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2284",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 0.772,-0.497 0.751,-0.908 0.73,-1.32 0.323,-1.859 0.323,-1.859"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.0703,32.2463)",
    id: "g2286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2288",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -0.193,0.254 -0.461,0.243 -0.268,-0.011 -0.547,-0.275 -0.547,-0.275 0,0 0.333,0.032 0.419,-0.084 0.085,-0.116 0.171,-0.264 0.171,-0.264 0,0 0.15,0.084 0.213,0.137 C -0.14,-0.19 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.0703,32.2463)",
    id: "g2290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2292",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -0.193,0.254 -0.461,0.243 -0.268,-0.011 -0.547,-0.275 -0.547,-0.275 0,0 0.333,0.032 0.419,-0.084 0.085,-0.116 0.171,-0.264 0.171,-0.264 0,0 0.15,0.084 0.213,0.137 C -0.14,-0.19 0,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.2442,31.1374)",
    id: "g2294"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2296",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -0.353,0.053 -0.525,-0.138 -0.172,-0.19 -0.161,-0.539 -0.161,-0.539 0,0 0.215,0.243 0.408,0.222 0.193,-0.021 0.407,-0.127 0.407,-0.127 0,0 -0.032,0.212 -0.054,0.307 C 0.054,-0.18 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.2442,31.1374)",
    id: "g2298"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2300",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -0.353,0.053 -0.525,-0.138 -0.172,-0.19 -0.161,-0.539 -0.161,-0.539 0,0 0.215,0.243 0.408,0.222 0.193,-0.021 0.407,-0.127 0.407,-0.127 0,0 -0.032,0.212 -0.054,0.307 C 0.054,-0.18 0,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.0059,29.9641)",
    id: "g2302"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2304",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -0.172,-0.253 -0.043,-0.454 0.129,-0.201 0.397,-0.296 0.397,-0.296 0,0 -0.096,0.148 -0.054,0.317 0.034,0.135 0.257,0.317 0.257,0.317 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.0059,29.9641)",
    id: "g2306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2308",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -0.172,-0.253 -0.043,-0.454 0.129,-0.201 0.397,-0.296 0.397,-0.296 0,0 -0.096,0.148 -0.054,0.317 0.034,0.135 0.257,0.317 0.257,0.317 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.7119,29.489)",
    id: "g2310"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2312",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -0.311,0.074 -0.482,-0.032 -0.171,-0.106 -0.311,-0.549 -0.311,-0.549 0,0 0.278,0.243 0.482,0.211 0.204,-0.031 0.353,-0.116 0.353,-0.116 0,0 0.033,0.179 0.012,0.306 C 0.041,-0.104 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.7119,29.489)",
    id: "g2314"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2316",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -0.311,0.074 -0.482,-0.032 -0.171,-0.106 -0.311,-0.549 -0.311,-0.549 0,0 0.278,0.243 0.482,0.211 0.204,-0.031 0.353,-0.116 0.353,-0.116 0,0 0.033,0.179 0.012,0.306 C 0.041,-0.104 0,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.8623,28.3058)",
    id: "g2318"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2320",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -0.235,-0.253 -0.15,-0.465 0.086,-0.211 0.235,-0.433 0.235,-0.433 0,0 -0.008,0.315 0.087,0.401 0.139,0.127 0.396,0.148 0.396,0.148 0,0 -0.203,0.19 -0.268,0.212 C 0.236,-0.116 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.8623,28.3058)",
    id: "g2322"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2324",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -0.235,-0.253 -0.15,-0.465 0.086,-0.211 0.235,-0.433 0.235,-0.433 0,0 -0.008,0.315 0.087,0.401 0.139,0.127 0.396,0.148 0.396,0.148 0,0 -0.203,0.19 -0.268,0.212 C 0.236,-0.116 0,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.042,27.9362)",
    id: "g2326"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2328",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -0.119,-0.307 0.106,-0.507 0.226,-0.201 0.419,-0.222 0.419,-0.222 0,0 -0.171,0.317 -0.118,0.486 0.056,0.176 0.203,0.285 0.203,0.285 0,0 -0.278,0.096 -0.321,0.085 C 0.246,0.116 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.042,27.9362)",
    id: "g2330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2332",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -0.119,-0.307 0.106,-0.507 0.226,-0.201 0.419,-0.222 0.419,-0.222 0,0 -0.171,0.317 -0.118,0.486 0.056,0.176 0.203,0.285 0.203,0.285 0,0 -0.278,0.096 -0.321,0.085 C 0.246,0.116 0,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.9663,6.0309)",
    id: "g2334"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2336",
    style: {
      fill: "#f7cc7e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0.792,-0.247 1.194,-0.862 1.194,-1.582 0,-0.938 -0.873,-1.649 -2.008,-1.649 -1.135,0 -2.056,0.711 -2.056,1.649 0,0.708 0.38,1.501 1.169,1.559 0,0 -0.025,0.074 -0.092,0.194 -0.082,0.091 -0.244,0.263 -0.244,0.263 0,0 0.301,0.057 0.475,-0.012 0.175,-0.068 0.291,-0.182 0.291,-0.182 0,0 0.082,0.166 0.197,0.297 0.116,0.13 0.267,0.21 0.267,0.21 0,0 0.174,-0.153 0.233,-0.256 0.057,-0.103 0.092,-0.229 0.092,-0.229 0,0 0.163,0.137 0.302,0.195 0.139,0.057 0.318,0.103 0.318,0.103 0,0 -0.051,-0.184 -0.086,-0.275 C 0.018,0.194 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.9663,6.0309)",
    id: "g2338"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2340",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.19400001,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0.792,-0.247 1.194,-0.862 1.194,-1.582 0,-0.938 -0.873,-1.649 -2.008,-1.649 -1.135,0 -2.056,0.711 -2.056,1.649 0,0.708 0.38,1.501 1.169,1.559 0,0 -0.025,0.074 -0.092,0.194 -0.082,0.091 -0.244,0.263 -0.244,0.263 0,0 0.301,0.057 0.475,-0.012 0.175,-0.068 0.291,-0.182 0.291,-0.182 0,0 0.082,0.166 0.197,0.297 0.116,0.13 0.267,0.21 0.267,0.21 0,0 0.174,-0.153 0.233,-0.256 0.057,-0.103 0.092,-0.229 0.092,-0.229 0,0 0.163,0.137 0.302,0.195 0.139,0.057 0.318,0.103 0.318,0.103 0,0 -0.051,-0.184 -0.086,-0.275 C 0.018,0.194 0,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.9854,1.7814)",
    id: "g2342"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2344",
    style: {
      fill: "#006f46",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0 -1.51,1.058 -2.164,1.201 -3,1.384 -3.94,1.235 -4.346,1.258 -4.334,1.247 -3.858,0.892 -3.65,0.675 -3.441,0.458 -2.744,0.023 -2.35,-0.08 -1.126,-0.401 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.9854,1.7814)",
    id: "g2346"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2348",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.19400001,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 -1.51,1.058 -2.164,1.201 -3,1.384 -3.94,1.235 -4.346,1.258 -4.334,1.247 -3.858,0.892 -3.65,0.675 -3.441,0.458 -2.744,0.023 -2.35,-0.08 -1.126,-0.401 0,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.4151,1.6901)",
    id: "g2350"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2352",
    style: {
      fill: "#006f46",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0 0.968,1.044 1.978,1.189 3.174,1.361 3.956,1.086 4.42,0.96 4.432,0.96 4.038,0.766 3.829,0.617 3.62,0.469 3.081,0 2.257,-0.012 1.432,-0.023 0.522,0.08 0.372,0.057 0.221,0.034 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.4151,1.6901)",
    id: "g2354"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2356",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.19400001,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 0.968,1.044 1.978,1.189 3.174,1.361 3.956,1.086 4.42,0.96 4.432,0.96 4.038,0.766 3.829,0.617 3.62,0.469 3.081,0 2.257,-0.012 1.432,-0.023 0.522,0.08 0.372,0.057 0.221,0.034 0,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.1245,2.9841)",
    id: "g2358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2360",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c -0.379,0.366 -0.615,0.887 -0.615,1.465 0,0.578 0.237,1.099 0.617,1.465 C 0.38,2.564 0.614,2.043 0.614,1.465 0.614,0.887 0.38,0.366 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.1245,2.9841)",
    id: "g2362"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2364",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.19400001,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -0.379,0.366 -0.615,0.887 -0.615,1.465 0,0.578 0.237,1.099 0.617,1.465 C 0.38,2.564 0.614,2.043 0.614,1.465 0.614,0.887 0.38,0.366 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.7417,0.8386)",
    id: "g2366"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2368",
    style: {
      fill: "#006f46",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0 0.231,0.6 0.255,1.114 0.275,1.549 0.197,1.972 0.197,1.972 h 0.198 0.104 c 0,0 0.151,-0.457 0.151,-0.858 0,-0.4 -0.07,-0.931 -0.07,-0.931 0,0 -0.208,-0.034 -0.278,-0.069 C 0.231,0.08 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.7417,0.8386)",
    id: "g2370"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2372",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.19400001,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 0.231,0.6 0.255,1.114 0.275,1.549 0.197,1.972 0.197,1.972 h 0.198 0.104 c 0,0 0.151,-0.457 0.151,-0.858 0,-0.4 -0.07,-0.931 -0.07,-0.931 0,0 -0.208,-0.034 -0.278,-0.069 C 0.231,0.08 0,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.8272,57.6755)",
    id: "g2374"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2376",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.227 0.186,0.41 0.416,0.41 0.645,0.41 0.831,0.227 0.831,0 0.831,-0.226 0.645,-0.409 0.416,-0.409 0.186,-0.409 0,-0.226 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.8272,57.6755)",
    id: "g2378"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2380",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.227 0.186,0.41 0.416,0.41 0.645,0.41 0.831,0.227 0.831,0 0.831,-0.226 0.645,-0.409 0.416,-0.409 0.186,-0.409 0,-0.226 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.3951,58.7228)",
    id: "g2382"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2384",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.226 0.187,0.409 0.416,0.409 0.646,0.409 0.832,0.226 0.832,0 0.832,-0.227 0.646,-0.41 0.416,-0.41 0.187,-0.41 0,-0.227 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.3951,58.7228)",
    id: "g2386"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2388",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.226 0.187,0.409 0.416,0.409 0.646,0.409 0.832,0.226 0.832,0 0.832,-0.227 0.646,-0.41 0.416,-0.41 0.187,-0.41 0,-0.227 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.7744,59.9367)",
    id: "g2390"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2392",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.226 0.187,0.41 0.416,0.41 0.646,0.41 0.831,0.226 0.831,0 0.831,-0.227 0.646,-0.41 0.416,-0.41 0.187,-0.41 0,-0.227 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.7744,59.9367)",
    id: "g2394"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2396",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.226 0.187,0.41 0.416,0.41 0.646,0.41 0.831,0.226 0.831,0 0.831,-0.227 0.646,-0.41 0.416,-0.41 0.187,-0.41 0,-0.227 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.8218,61.2399)",
    id: "g2398"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2400",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.416,0.41 0.646,0.41 0.831,0.227 0.831,0 0.831,-0.226 0.646,-0.41 0.416,-0.41 0.187,-0.41 0,-0.226 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.8218,61.2399)",
    id: "g2402"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2404",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.416,0.41 0.646,0.41 0.831,0.227 0.831,0 0.831,-0.226 0.646,-0.41 0.416,-0.41 0.187,-0.41 0,-0.226 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.5142,62.5197)",
    id: "g2406"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2408",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.227 0.186,0.41 0.416,0.41 0.645,0.41 0.831,0.227 0.831,0 0.831,-0.226 0.645,-0.409 0.416,-0.409 0.186,-0.409 0,-0.226 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.5142,62.5197)",
    id: "g2410"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2412",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.227 0.186,0.41 0.416,0.41 0.645,0.41 0.831,0.227 0.831,0 0.831,-0.226 0.645,-0.409 0.416,-0.409 0.186,-0.409 0,-0.226 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.8745,63.6838)",
    id: "g2414"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2416",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.226 0.186,0.409 0.416,0.409 0.645,0.409 0.831,0.226 0.831,0 0.831,-0.227 0.645,-0.41 0.416,-0.41 0.186,-0.41 0,-0.227 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.8745,63.6838)",
    id: "g2418"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2420",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.226 0.186,0.409 0.416,0.409 0.645,0.409 0.831,0.226 0.831,0 0.831,-0.227 0.645,-0.41 0.416,-0.41 0.186,-0.41 0,-0.227 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.0205,64.6413)",
    id: "g2422"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2424",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.226 0.187,0.409 0.417,0.409 0.646,0.409 0.832,0.226 0.832,0 0.832,-0.227 0.646,-0.41 0.417,-0.41 0.187,-0.41 0,-0.227 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.0205,64.6413)",
    id: "g2426"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2428",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.226 0.187,0.409 0.417,0.409 0.646,0.409 0.832,0.226 0.832,0 0.832,-0.227 0.646,-0.41 0.417,-0.41 0.187,-0.41 0,-0.227 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.0298,65.4343)",
    id: "g2430"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2432",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.227 0.186,0.41 0.416,0.41 0.646,0.41 0.832,0.227 0.832,0 0.832,-0.226 0.646,-0.41 0.416,-0.41 0.186,-0.41 0,-0.226 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.0298,65.4343)",
    id: "g2434"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2436",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.227 0.186,0.41 0.416,0.41 0.646,0.41 0.832,0.227 0.832,0 0.832,-0.226 0.646,-0.41 0.416,-0.41 0.186,-0.41 0,-0.226 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.8448,66.0847)",
    id: "g2438"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2440",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.226 0.187,0.409 0.416,0.409 0.646,0.409 0.832,0.226 0.832,0 0.832,-0.227 0.646,-0.41 0.416,-0.41 0.187,-0.41 0,-0.227 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.8448,66.0847)",
    id: "g2442"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2444",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.226 0.187,0.409 0.416,0.409 0.646,0.409 0.832,0.226 0.832,0 0.832,-0.227 0.646,-0.41 0.416,-0.41 0.187,-0.41 0,-0.227 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.6177,66.5471)",
    id: "g2446"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2448",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.227 0.186,0.41 0.416,0.41 0.645,0.41 0.831,0.227 0.831,0 0.831,-0.226 0.645,-0.409 0.416,-0.409 0.186,-0.409 0,-0.226 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.6177,66.5471)",
    id: "g2450"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2452",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.227 0.186,0.41 0.416,0.41 0.645,0.41 0.831,0.227 0.831,0 0.831,-0.226 0.645,-0.409 0.416,-0.409 0.186,-0.409 0,-0.226 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.2432,66.8039)",
    id: "g2454"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2456",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.227 0.186,0.41 0.416,0.41 0.645,0.41 0.831,0.227 0.831,0 0.831,-0.226 0.645,-0.41 0.416,-0.41 0.186,-0.41 0,-0.226 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.2432,66.8039)",
    id: "g2458"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2460",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.227 0.186,0.41 0.416,0.41 0.645,0.41 0.831,0.227 0.831,0 0.831,-0.226 0.645,-0.41 0.416,-0.41 0.186,-0.41 0,-0.226 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.9395,66.8742)",
    id: "g2462"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2464",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.226 0.187,0.41 0.416,0.41 0.646,0.41 0.832,0.226 0.832,0 0.832,-0.227 0.646,-0.41 0.416,-0.41 0.187,-0.41 0,-0.227 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.9395,66.8742)",
    id: "g2466"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2468",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.226 0.187,0.41 0.416,0.41 0.646,0.41 0.832,0.226 0.832,0 0.832,-0.227 0.646,-0.41 0.416,-0.41 0.187,-0.41 0,-0.227 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.6602,66.8278)",
    id: "g2470"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2472",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.226 0.187,0.409 0.416,0.409 0.645,0.409 0.831,0.226 0.831,0 0.831,-0.227 0.645,-0.41 0.416,-0.41 0.187,-0.41 0,-0.227 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.6602,66.8278)",
    id: "g2474"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2476",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.226 0.187,0.409 0.416,0.409 0.645,0.409 0.831,0.226 0.831,0 0.831,-0.227 0.645,-0.41 0.416,-0.41 0.187,-0.41 0,-0.227 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.3804,66.8278)",
    id: "g2478"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2480",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.226 0.187,0.409 0.416,0.409 0.646,0.409 0.832,0.226 0.832,0 0.832,-0.227 0.646,-0.41 0.416,-0.41 0.187,-0.41 0,-0.227 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.3804,66.8278)",
    id: "g2482"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2484",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.226 0.187,0.409 0.416,0.409 0.646,0.409 0.832,0.226 0.832,0 0.832,-0.227 0.646,-0.41 0.416,-0.41 0.187,-0.41 0,-0.227 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.0201,65.6872)",
    id: "g2486"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2488",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.416,0.41 0.646,0.41 0.832,0.227 0.832,0 0.832,-0.226 0.646,-0.41 0.416,-0.41 0.187,-0.41 0,-0.226 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.0201,65.6872)",
    id: "g2490"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2492",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.416,0.41 0.646,0.41 0.832,0.227 0.832,0 0.832,-0.226 0.646,-0.41 0.416,-0.41 0.187,-0.41 0,-0.226 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.2803,64.4269)",
    id: "g2494"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2496",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.226 0.187,0.409 0.417,0.409 0.646,0.409 0.832,0.226 0.832,0 0.832,-0.227 0.646,-0.41 0.417,-0.41 0.187,-0.41 0,-0.227 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.2803,64.4269)",
    id: "g2498"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2500",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.226 0.187,0.409 0.417,0.409 0.646,0.409 0.832,0.226 0.832,0 0.832,-0.227 0.646,-0.41 0.417,-0.41 0.187,-0.41 0,-0.227 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.3277,63.1696)",
    id: "g2502"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2504",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.417,0.41 0.646,0.41 0.832,0.227 0.832,0 0.832,-0.226 0.646,-0.409 0.417,-0.409 0.187,-0.409 0,-0.226 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.3277,63.1696)",
    id: "g2506"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2508",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.417,0.41 0.646,0.41 0.832,0.227 0.832,0 0.832,-0.226 0.646,-0.409 0.417,-0.409 0.187,-0.409 0,-0.226 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.9492,62.0261)",
    id: "g2510"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2512",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.226 0.186,0.409 0.416,0.409 0.646,0.409 0.832,0.226 0.832,0 0.832,-0.227 0.646,-0.41 0.416,-0.41 0.186,-0.41 0,-0.227 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.9492,62.0261)",
    id: "g2514"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2516",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.226 0.186,0.409 0.416,0.409 0.646,0.409 0.832,0.226 0.832,0 0.832,-0.227 0.646,-0.41 0.416,-0.41 0.186,-0.41 0,-0.227 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.2422,60.9748)",
    id: "g2518"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2520",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.417,0.41 0.646,0.41 0.832,0.227 0.832,0 0.832,-0.226 0.646,-0.41 0.417,-0.41 0.187,-0.41 0,-0.226 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.2422,60.9748)",
    id: "g2522"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2524",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.417,0.41 0.646,0.41 0.832,0.227 0.832,0 0.832,-0.226 0.646,-0.41 0.417,-0.41 0.187,-0.41 0,-0.226 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.4136,67.6213)",
    id: "g2526"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2528",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.227 0.186,0.41 0.416,0.41 0.645,0.41 0.831,0.227 0.831,0 0.831,-0.226 0.645,-0.41 0.416,-0.41 0.186,-0.41 0,-0.226 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.4136,67.6213)",
    id: "g2530"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2532",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.227 0.186,0.41 0.416,0.41 0.645,0.41 0.831,0.227 0.831,0 0.831,-0.226 0.645,-0.41 0.416,-0.41 0.186,-0.41 0,-0.226 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.2759,68.2751)",
    id: "g2534"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2536",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.226 0.186,0.41 0.417,0.41 0.646,0.41 0.832,0.226 0.832,0 0.832,-0.226 0.646,-0.409 0.417,-0.409 0.186,-0.409 0,-0.226 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.2759,68.2751)",
    id: "g2538"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2540",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.226 0.186,0.41 0.417,0.41 0.646,0.41 0.832,0.226 0.832,0 0.832,-0.226 0.646,-0.409 0.417,-0.409 0.186,-0.409 0,-0.226 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.0244,68.6682)",
    id: "g2542"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2544",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.226 0.186,0.41 0.416,0.41 0.645,0.41 0.832,0.226 0.832,0 0.832,-0.227 0.645,-0.41 0.416,-0.41 0.186,-0.41 0,-0.227 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.0244,68.6682)",
    id: "g2546"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2548",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.226 0.186,0.41 0.416,0.41 0.645,0.41 0.832,0.226 0.832,0 0.832,-0.227 0.645,-0.41 0.416,-0.41 0.186,-0.41 0,-0.227 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.7212,68.9016)",
    id: "g2550"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2552",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.227 0.186,0.41 0.416,0.41 0.645,0.41 0.831,0.227 0.831,0 0.831,-0.227 0.645,-0.41 0.416,-0.41 0.186,-0.41 0,-0.227 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.7212,68.9016)",
    id: "g2554"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2556",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.227 0.186,0.41 0.416,0.41 0.645,0.41 0.831,0.227 0.831,0 0.831,-0.227 0.645,-0.41 0.416,-0.41 0.186,-0.41 0,-0.227 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.4449,68.8781)",
    id: "g2558"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2560",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.226 0.187,0.41 0.417,0.41 0.646,0.41 0.832,0.226 0.832,0 0.832,-0.226 0.646,-0.41 0.417,-0.41 0.187,-0.41 0,-0.226 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.4449,68.8781)",
    id: "g2562"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2564",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.226 0.187,0.41 0.417,0.41 0.646,0.41 0.832,0.226 0.832,0 0.832,-0.226 0.646,-0.41 0.417,-0.41 0.187,-0.41 0,-0.226 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.1182,68.6447)",
    id: "g2566"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2568",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.416,0.41 0.646,0.41 0.832,0.227 0.832,0 0.832,-0.227 0.646,-0.41 0.416,-0.41 0.187,-0.41 0,-0.227 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.1182,68.6447)",
    id: "g2570"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2572",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.416,0.41 0.646,0.41 0.832,0.227 0.832,0 0.832,-0.227 0.646,-0.41 0.416,-0.41 0.187,-0.41 0,-0.227 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.8911,68.2053)",
    id: "g2574"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2576",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.226 0.186,0.41 0.416,0.41 0.645,0.41 0.831,0.226 0.831,0 0.831,-0.227 0.645,-0.41 0.416,-0.41 0.186,-0.41 0,-0.227 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.8911,68.2053)",
    id: "g2578"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2580",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.226 0.186,0.41 0.416,0.41 0.645,0.41 0.831,0.226 0.831,0 0.831,-0.227 0.645,-0.41 0.416,-0.41 0.186,-0.41 0,-0.227 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.0821,57.6755)",
    id: "g2582"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2584",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.416,0.41 0.646,0.41 0.831,0.227 0.831,0 0.831,-0.226 0.646,-0.409 0.416,-0.409 0.187,-0.409 0,-0.226 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.0821,57.6755)",
    id: "g2586"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2588",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.416,0.41 0.646,0.41 0.831,0.227 0.831,0 0.831,-0.226 0.646,-0.409 0.416,-0.409 0.187,-0.409 0,-0.226 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.5137,58.7228)",
    id: "g2590"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2592",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.226 0.186,0.409 0.417,0.409 0.646,0.409 0.832,0.226 0.832,0 0.832,-0.227 0.646,-0.41 0.417,-0.41 0.186,-0.41 0,-0.227 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.5137,58.7228)",
    id: "g2594"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2596",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.226 0.186,0.409 0.417,0.409 0.646,0.409 0.832,0.226 0.832,0 0.832,-0.227 0.646,-0.41 0.417,-0.41 0.186,-0.41 0,-0.227 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.1348,59.9367)",
    id: "g2598"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2600",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.226 0.186,0.41 0.416,0.41 0.645,0.41 0.831,0.226 0.831,0 0.831,-0.227 0.645,-0.41 0.416,-0.41 0.186,-0.41 0,-0.227 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.1348,59.9367)",
    id: "g2602"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2604",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.226 0.186,0.41 0.416,0.41 0.645,0.41 0.831,0.226 0.831,0 0.831,-0.227 0.645,-0.41 0.416,-0.41 0.186,-0.41 0,-0.227 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.0874,61.2399)",
    id: "g2606"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2608",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.227 0.186,0.41 0.416,0.41 0.645,0.41 0.831,0.227 0.831,0 0.831,-0.226 0.645,-0.41 0.416,-0.41 0.186,-0.41 0,-0.226 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.0874,61.2399)",
    id: "g2610"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2612",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.227 0.186,0.41 0.416,0.41 0.645,0.41 0.831,0.227 0.831,0 0.831,-0.226 0.645,-0.41 0.416,-0.41 0.186,-0.41 0,-0.226 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.3951,62.5197)",
    id: "g2614"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2616",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.416,0.41 0.646,0.41 0.831,0.227 0.831,0 0.831,-0.226 0.646,-0.409 0.416,-0.409 0.187,-0.409 0,-0.226 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.3951,62.5197)",
    id: "g2618"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2620",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.416,0.41 0.646,0.41 0.831,0.227 0.831,0 0.831,-0.226 0.646,-0.409 0.416,-0.409 0.187,-0.409 0,-0.226 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.0347,63.6838)",
    id: "g2622"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2624",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.226 0.187,0.409 0.416,0.409 0.646,0.409 0.832,0.226 0.832,0 0.832,-0.227 0.646,-0.41 0.416,-0.41 0.187,-0.41 0,-0.227 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.0347,63.6838)",
    id: "g2626"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2628",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.226 0.187,0.409 0.416,0.409 0.646,0.409 0.832,0.226 0.832,0 0.832,-0.227 0.646,-0.41 0.416,-0.41 0.187,-0.41 0,-0.227 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.8882,64.6413)",
    id: "g2630"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2632",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.226 0.186,0.409 0.416,0.409 0.645,0.409 0.832,0.226 0.832,0 0.832,-0.227 0.645,-0.41 0.416,-0.41 0.186,-0.41 0,-0.227 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.8882,64.6413)",
    id: "g2634"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2636",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.226 0.186,0.409 0.416,0.409 0.645,0.409 0.832,0.226 0.832,0 0.832,-0.227 0.645,-0.41 0.416,-0.41 0.186,-0.41 0,-0.227 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.8784,65.4343)",
    id: "g2638"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2640",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.417,0.41 0.646,0.41 0.832,0.227 0.832,0 0.832,-0.226 0.646,-0.41 0.417,-0.41 0.187,-0.41 0,-0.226 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.8784,65.4343)",
    id: "g2642"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2644",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.417,0.41 0.646,0.41 0.832,0.227 0.832,0 0.832,-0.226 0.646,-0.41 0.417,-0.41 0.187,-0.41 0,-0.226 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.064,66.0847)",
    id: "g2646"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2648",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.226 0.186,0.409 0.416,0.409 0.646,0.409 0.832,0.226 0.832,0 0.832,-0.227 0.646,-0.41 0.416,-0.41 0.186,-0.41 0,-0.227 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.064,66.0847)",
    id: "g2650"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2652",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.226 0.186,0.409 0.416,0.409 0.646,0.409 0.832,0.226 0.832,0 0.832,-0.227 0.646,-0.41 0.416,-0.41 0.186,-0.41 0,-0.227 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.292,66.5471)",
    id: "g2654"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2656",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.416,0.41 0.645,0.41 0.831,0.227 0.831,0 0.831,-0.226 0.645,-0.409 0.416,-0.409 0.187,-0.409 0,-0.226 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.292,66.5471)",
    id: "g2658"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2660",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.416,0.41 0.645,0.41 0.831,0.227 0.831,0 0.831,-0.226 0.645,-0.409 0.416,-0.409 0.187,-0.409 0,-0.226 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.666,66.8039)",
    id: "g2662"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2664",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.416,0.41 0.646,0.41 0.831,0.227 0.831,0 0.831,-0.226 0.646,-0.41 0.416,-0.41 0.187,-0.41 0,-0.226 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.666,66.8039)",
    id: "g2666"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2668",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.416,0.41 0.646,0.41 0.831,0.227 0.831,0 0.831,-0.226 0.646,-0.41 0.416,-0.41 0.187,-0.41 0,-0.226 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.9702,66.8742)",
    id: "g2670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2672",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.226 0.186,0.41 0.416,0.41 0.645,0.41 0.831,0.226 0.831,0 0.831,-0.227 0.645,-0.41 0.416,-0.41 0.186,-0.41 0,-0.227 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.9702,66.8742)",
    id: "g2674"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2676",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.226 0.186,0.41 0.416,0.41 0.645,0.41 0.831,0.226 0.831,0 0.831,-0.227 0.645,-0.41 0.416,-0.41 0.186,-0.41 0,-0.227 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.2495,66.8278)",
    id: "g2678"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2680",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.226 0.186,0.409 0.416,0.409 0.645,0.409 0.831,0.226 0.831,0 0.831,-0.227 0.645,-0.41 0.416,-0.41 0.186,-0.41 0,-0.227 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.2495,66.8278)",
    id: "g2682"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2684",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.226 0.186,0.409 0.416,0.409 0.645,0.409 0.831,0.226 0.831,0 0.831,-0.227 0.645,-0.41 0.416,-0.41 0.186,-0.41 0,-0.227 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.5288,66.8278)",
    id: "g2686"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2688",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.226 0.187,0.409 0.416,0.409 0.645,0.409 0.831,0.226 0.831,0 0.831,-0.227 0.645,-0.41 0.416,-0.41 0.187,-0.41 0,-0.227 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.5288,66.8278)",
    id: "g2690"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2692",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.226 0.187,0.409 0.416,0.409 0.645,0.409 0.831,0.226 0.831,0 0.831,-0.227 0.645,-0.41 0.416,-0.41 0.187,-0.41 0,-0.227 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.8892,65.6872)",
    id: "g2694"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2696",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.227 0.186,0.41 0.416,0.41 0.645,0.41 0.831,0.227 0.831,0 0.831,-0.226 0.645,-0.41 0.416,-0.41 0.186,-0.41 0,-0.226 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.8892,65.6872)",
    id: "g2698"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2700",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.227 0.186,0.41 0.416,0.41 0.645,0.41 0.831,0.227 0.831,0 0.831,-0.226 0.645,-0.41 0.416,-0.41 0.186,-0.41 0,-0.226 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.628,64.4269)",
    id: "g2702"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2704",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.226 0.186,0.409 0.416,0.409 0.646,0.409 0.832,0.226 0.832,0 0.832,-0.227 0.646,-0.41 0.416,-0.41 0.186,-0.41 0,-0.227 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.628,64.4269)",
    id: "g2706"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2708",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.226 0.186,0.409 0.416,0.409 0.646,0.409 0.832,0.226 0.832,0 0.832,-0.227 0.646,-0.41 0.416,-0.41 0.186,-0.41 0,-0.227 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.5806,63.1696)",
    id: "g2710"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2712",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.227 0.186,0.41 0.417,0.41 0.646,0.41 0.832,0.227 0.832,0 0.832,-0.226 0.646,-0.409 0.417,-0.409 0.186,-0.409 0,-0.226 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.5806,63.1696)",
    id: "g2714"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2716",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.227 0.186,0.41 0.417,0.41 0.646,0.41 0.832,0.227 0.832,0 0.832,-0.226 0.646,-0.409 0.417,-0.409 0.186,-0.409 0,-0.226 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.9595,62.0261)",
    id: "g2718"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2720",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.226 0.187,0.409 0.417,0.409 0.646,0.409 0.832,0.226 0.832,0 0.832,-0.227 0.646,-0.41 0.417,-0.41 0.187,-0.41 0,-0.227 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.9595,62.0261)",
    id: "g2722"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2724",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.226 0.187,0.409 0.417,0.409 0.646,0.409 0.832,0.226 0.832,0 0.832,-0.227 0.646,-0.41 0.417,-0.41 0.187,-0.41 0,-0.227 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.666,60.9748)",
    id: "g2726"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2728",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.416,0.41 0.646,0.41 0.832,0.227 0.832,0 0.832,-0.226 0.646,-0.41 0.416,-0.41 0.187,-0.41 0,-0.226 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.666,60.9748)",
    id: "g2730"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2732",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.416,0.41 0.646,0.41 0.832,0.227 0.832,0 0.832,-0.226 0.646,-0.41 0.416,-0.41 0.187,-0.41 0,-0.226 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.4956,67.6213)",
    id: "g2734"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2736",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.416,0.41 0.646,0.41 0.832,0.227 0.832,0 0.832,-0.226 0.646,-0.41 0.416,-0.41 0.187,-0.41 0,-0.226 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.4956,67.6213)",
    id: "g2738"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2740",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.416,0.41 0.646,0.41 0.832,0.227 0.832,0 0.832,-0.226 0.646,-0.41 0.416,-0.41 0.187,-0.41 0,-0.226 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.6328,68.2751)",
    id: "g2742"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2744",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.226 0.187,0.41 0.416,0.41 0.646,0.41 0.832,0.226 0.832,0 0.832,-0.226 0.646,-0.409 0.416,-0.409 0.187,-0.409 0,-0.226 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.6328,68.2751)",
    id: "g2746"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2748",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.226 0.187,0.41 0.416,0.41 0.646,0.41 0.832,0.226 0.832,0 0.832,-0.226 0.646,-0.409 0.416,-0.409 0.187,-0.409 0,-0.226 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.8853,68.6682)",
    id: "g2750"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2752",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.226 0.186,0.41 0.416,0.41 0.646,0.41 0.831,0.226 0.831,0 0.831,-0.227 0.646,-0.41 0.416,-0.41 0.186,-0.41 0,-0.227 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.8853,68.6682)",
    id: "g2754"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2756",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.226 0.186,0.41 0.416,0.41 0.646,0.41 0.831,0.226 0.831,0 0.831,-0.227 0.646,-0.41 0.416,-0.41 0.186,-0.41 0,-0.227 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.188,68.9016)",
    id: "g2758"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2760",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.416,0.41 0.646,0.41 0.832,0.227 0.832,0 0.832,-0.227 0.646,-0.41 0.416,-0.41 0.187,-0.41 0,-0.227 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.188,68.9016)",
    id: "g2762"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2764",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.227 0.187,0.41 0.416,0.41 0.646,0.41 0.832,0.227 0.832,0 0.832,-0.227 0.646,-0.41 0.416,-0.41 0.187,-0.41 0,-0.227 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.4634,68.8781)",
    id: "g2766"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2768",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.226 0.186,0.41 0.417,0.41 0.646,0.41 0.832,0.226 0.832,0 0.832,-0.226 0.646,-0.41 0.417,-0.41 0.186,-0.41 0,-0.226 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.4634,68.8781)",
    id: "g2770"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2772",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.226 0.186,0.41 0.417,0.41 0.646,0.41 0.832,0.226 0.832,0 0.832,-0.226 0.646,-0.41 0.417,-0.41 0.186,-0.41 0,-0.226 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.7906,68.6447)",
    id: "g2774"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2776",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.227 0.186,0.41 0.416,0.41 0.645,0.41 0.832,0.227 0.832,0 0.832,-0.227 0.645,-0.41 0.416,-0.41 0.186,-0.41 0,-0.227 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.7906,68.6447)",
    id: "g2778"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2780",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.227 0.186,0.41 0.416,0.41 0.645,0.41 0.832,0.227 0.832,0 0.832,-0.227 0.645,-0.41 0.416,-0.41 0.186,-0.41 0,-0.227 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.0181,68.2053)",
    id: "g2782"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2784",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.226 0.187,0.41 0.416,0.41 0.646,0.41 0.832,0.226 0.832,0 0.832,-0.227 0.646,-0.41 0.416,-0.41 0.187,-0.41 0,-0.227 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.0181,68.2053)",
    id: "g2786"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2788",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.146,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.226 0.187,0.41 0.416,0.41 0.646,0.41 0.832,0.226 0.832,0 0.832,-0.227 0.646,-0.41 0.416,-0.41 0.187,-0.41 0,-0.227 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.8799,28.1472)",
    id: "g2790"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2792",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 h -10.759 v 2.813 h 1.538 v 5.76 h -0.714 v 2.57 h 1.18 v 1.812 h -0.521 v 1.297 h 0.494 v -0.378 h 0.521 v 0.378 h 0.576 v -0.378 h 0.522 v 0.378 h 0.495 v -1.297 h -0.55 v -1.812 h 1.07 v 3.867 h -0.631 v 1.487 h 0.467 v -0.378 h 0.576 v 0.378 h 0.769 v -0.378 h 0.604 v 0.378 h 0.466 V 15.01 H -4.61 v -3.867 h 1.042 v 1.812 h -0.521 v 1.297 h 0.467 v -0.378 h 0.548 v 0.378 h 0.576 v -0.378 h 0.521 v 0.378 h 0.495 V 12.955 H -2.03 v -1.812 h 1.262 v -2.57 h -0.741 v -5.76 l 1.509,0 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.8799,28.1472)",
    id: "g2794"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2796",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.19400001,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 h -10.759 v 2.813 h 1.538 v 5.76 h -0.714 v 2.57 h 1.18 v 1.812 h -0.521 v 1.297 h 0.494 v -0.378 h 0.521 v 0.378 h 0.576 v -0.378 h 0.522 v 0.378 h 0.495 v -1.297 h -0.55 v -1.812 h 1.07 v 3.867 h -0.631 v 1.487 h 0.467 v -0.378 h 0.576 v 0.378 h 0.769 v -0.378 h 0.604 v 0.378 h 0.466 V 15.01 H -4.61 v -3.867 h 1.042 v 1.812 h -0.521 v 1.297 h 0.467 v -0.378 h 0.548 v 0.378 h 0.576 v -0.378 h 0.521 v 0.378 h 0.495 V 12.955 H -2.03 v -1.812 h 1.262 v -2.57 h -0.741 v -5.76 l 1.509,0 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.7408,34.8078)",
    id: "g2798"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2800",
    style: {
      fill: "#0044ae",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.269 0.202,0.487 0.464,0.487 0.726,0.487 0.938,0.269 0.938,0 v -1.122 h -0.939 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.7408,34.8078)",
    id: "g2802"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2804",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.19400001,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.269 0.202,0.487 0.464,0.487 0.726,0.487 0.938,0.269 0.938,0 v -1.122 h -0.939 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.356,34.8078)",
    id: "g2806"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2808",
    style: {
      fill: "#0044ae",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.269 0.202,0.487 0.464,0.487 0.726,0.487 0.938,0.269 0.938,0 v -1.122 h -0.939 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.356,34.8078)",
    id: "g2810"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2812",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.19400001,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.269 0.202,0.487 0.464,0.487 0.726,0.487 0.938,0.269 0.938,0 v -1.122 h -0.939 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.4898,29.884)",
    id: "g2814"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2816",
    style: {
      fill: "#0044ae",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,0.563 0.44,1.019 1.012,1.019 1.583,1.019 2.046,0.563 2.046,0 v -1.74 h -2.048 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.4898,29.884)",
    id: "g2818"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2820",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.19400001,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0.563 0.44,1.019 1.012,1.019 1.583,1.019 2.046,0.563 2.046,0 v -1.74 h -2.048 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.8609,25.1877)",
    id: "g2822"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2824",
    style: {
      fill: "#b60027",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,3.987 2.76,7.218 6.166,7.218 9.57,7.218 12.331,3.987 12.331,0 12.331,-3.987 9.57,-7.218 6.166,-7.218 2.76,-7.218 0,-3.987 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.8609,25.1877)",
    id: "g2826"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2828",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.226,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,3.987 2.76,7.218 6.166,7.218 9.57,7.218 12.331,3.987 12.331,0 12.331,-3.987 9.57,-7.218 6.166,-7.218 2.76,-7.218 0,-3.987 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.69,25.2014)",
    id: "g2830"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2832",
    style: {
      fill: "#0044ae",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0,2.923 1.942,5.293 4.337,5.293 6.734,5.293 8.676,2.923 8.676,0 8.676,-2.924 6.734,-5.293 4.337,-5.293 1.942,-5.293 0,-2.924 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.69,25.2014)",
    id: "g2834"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2836",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.226,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,2.923 1.942,5.293 4.337,5.293 6.734,5.293 8.676,2.923 8.676,0 8.676,-2.924 6.734,-5.293 4.337,-5.293 1.942,-5.293 0,-2.924 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.979,28.8449)",
    id: "g2838"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2840",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -0.514,-0.586 -0.514,-1.132 0,-0.546 0.217,-1 0.217,-1 -0.078,0.217 -0.288,0.373 -0.536,0.373 -0.312,0 -0.567,-0.251 -0.567,-0.559 0,-0.093 0.053,-0.232 0.093,-0.308 l 0.184,-0.388 c 0.062,0.144 0.205,0.224 0.373,0.224 0.225,0 0.406,-0.179 0.406,-0.4 0,-0.035 -0.005,-0.068 -0.012,-0.1 L -0.818,-3.291 V -3.7 h 0.412 L -0.713,-4.334 -0.307,-4.168 0,-4.53 0.32,-4.168 0.727,-4.334 0.419,-3.7 h 0.412 v 0.409 L 0.37,-3.29 c -0.009,0.032 -0.014,0.065 -0.014,0.1 0,0.221 0.182,0.4 0.407,0.4 0.168,0 0.312,-0.08 0.373,-0.224 l 0.184,0.388 c 0.041,0.076 0.094,0.215 0.094,0.308 0,0.308 -0.256,0.559 -0.568,0.559 -0.247,0 -0.458,-0.156 -0.536,-0.373 0,0 0.217,0.454 0.217,1 C 0.527,-0.586 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.979,28.8449)",
    id: "g2842"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2844",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.126,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -0.514,-0.586 -0.514,-1.132 0,-0.546 0.217,-1 0.217,-1 -0.078,0.217 -0.288,0.373 -0.536,0.373 -0.312,0 -0.567,-0.251 -0.567,-0.559 0,-0.093 0.053,-0.232 0.093,-0.308 l 0.184,-0.388 c 0.062,0.144 0.205,0.224 0.373,0.224 0.225,0 0.406,-0.179 0.406,-0.4 0,-0.035 -0.005,-0.068 -0.012,-0.1 L -0.818,-3.291 V -3.7 h 0.412 L -0.713,-4.334 -0.307,-4.168 0,-4.53 0.32,-4.168 0.727,-4.334 0.419,-3.7 h 0.412 v 0.409 L 0.37,-3.29 c -0.009,0.032 -0.014,0.065 -0.014,0.1 0,0.221 0.182,0.4 0.407,0.4 0.168,0 0.312,-0.08 0.373,-0.224 l 0.184,0.388 c 0.041,0.076 0.094,0.215 0.094,0.308 0,0.308 -0.256,0.559 -0.568,0.559 -0.247,0 -0.458,-0.156 -0.536,-0.373 0,0 0.217,0.454 0.217,1 C 0.527,-0.586 0,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path2846",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#211915",
      strokeWidth: 0.126,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 34.81,25.145 h -1.649 v 0.41 h 1.649 z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.0103,28.8449)",
    id: "g2848"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2850",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -0.515,-0.586 -0.515,-1.132 0,-0.546 0.217,-1 0.217,-1 -0.077,0.217 -0.288,0.373 -0.535,0.373 -0.313,0 -0.567,-0.251 -0.567,-0.559 0,-0.093 0.052,-0.232 0.092,-0.308 l 0.184,-0.388 c 0.062,0.144 0.206,0.224 0.373,0.224 0.225,0 0.407,-0.179 0.407,-0.4 0,-0.035 -0.005,-0.068 -0.013,-0.1 L -0.819,-3.291 V -3.7 h 0.413 L -0.713,-4.334 -0.308,-4.168 0,-4.53 0.319,-4.168 0.726,-4.334 0.419,-3.7 h 0.412 v 0.409 L 0.369,-3.29 c -0.008,0.032 -0.013,0.065 -0.013,0.1 0,0.221 0.182,0.4 0.406,0.4 0.169,0 0.311,-0.08 0.373,-0.224 l 0.185,0.388 c 0.039,0.076 0.092,0.215 0.092,0.308 0,0.308 -0.254,0.559 -0.567,0.559 -0.247,0 -0.457,-0.156 -0.536,-0.373 0,0 0.218,0.454 0.218,1 C 0.527,-0.586 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.0103,28.8449)",
    id: "g2852"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2854",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.126,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -0.515,-0.586 -0.515,-1.132 0,-0.546 0.217,-1 0.217,-1 -0.077,0.217 -0.288,0.373 -0.535,0.373 -0.313,0 -0.567,-0.251 -0.567,-0.559 0,-0.093 0.052,-0.232 0.092,-0.308 l 0.184,-0.388 c 0.062,0.144 0.206,0.224 0.373,0.224 0.225,0 0.407,-0.179 0.407,-0.4 0,-0.035 -0.005,-0.068 -0.013,-0.1 L -0.819,-3.291 V -3.7 h 0.413 L -0.713,-4.334 -0.308,-4.168 0,-4.53 0.319,-4.168 0.726,-4.334 0.419,-3.7 h 0.412 v 0.409 L 0.369,-3.29 c -0.008,0.032 -0.013,0.065 -0.013,0.1 0,0.221 0.182,0.4 0.406,0.4 0.169,0 0.311,-0.08 0.373,-0.224 l 0.185,0.388 c 0.039,0.076 0.092,0.215 0.092,0.308 0,0.308 -0.254,0.559 -0.567,0.559 -0.247,0 -0.457,-0.156 -0.536,-0.373 0,0 0.218,0.454 0.218,1 C 0.527,-0.586 0,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path2856",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#211915",
      strokeWidth: 0.126,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 38.841,25.145 h -1.65 v 0.41 h 1.65 z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.9947,25.237)",
    id: "g2858"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2860",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -0.514,-0.587 -0.514,-1.132 0,-0.546 0.216,-1.001 0.216,-1.001 -0.077,0.217 -0.288,0.373 -0.535,0.373 -0.313,0 -0.567,-0.25 -0.567,-0.559 0,-0.092 0.052,-0.231 0.093,-0.307 l 0.184,-0.389 c 0.061,0.144 0.205,0.224 0.373,0.224 0.225,0 0.406,-0.179 0.406,-0.4 0,-0.034 -0.005,-0.067 -0.013,-0.1 h -0.462 v -0.41 L -0.406,-3.7 -0.713,-4.335 -0.307,-4.169 0,-4.53 0.319,-4.169 0.727,-4.335 0.419,-3.7 0.831,-3.701 v 0.41 H 0.369 c -0.008,0.033 -0.013,0.066 -0.013,0.1 0,0.221 0.182,0.4 0.406,0.4 0.169,0 0.312,-0.08 0.373,-0.224 l 0.185,0.389 c 0.04,0.076 0.093,0.215 0.093,0.307 0,0.309 -0.255,0.559 -0.567,0.559 -0.248,0 -0.458,-0.156 -0.536,-0.373 0,0 0.217,0.455 0.217,1.001 C 0.527,-0.587 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.9947,25.237)",
    id: "g2862"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2864",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.126,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -0.514,-0.587 -0.514,-1.132 0,-0.546 0.216,-1.001 0.216,-1.001 -0.077,0.217 -0.288,0.373 -0.535,0.373 -0.313,0 -0.567,-0.25 -0.567,-0.559 0,-0.092 0.052,-0.231 0.093,-0.307 l 0.184,-0.389 c 0.061,0.144 0.205,0.224 0.373,0.224 0.225,0 0.406,-0.179 0.406,-0.4 0,-0.034 -0.005,-0.067 -0.013,-0.1 h -0.462 v -0.41 L -0.406,-3.7 -0.713,-4.335 -0.307,-4.169 0,-4.53 0.319,-4.169 0.727,-4.335 0.419,-3.7 0.831,-3.701 v 0.41 H 0.369 c -0.008,0.033 -0.013,0.066 -0.013,0.1 0,0.221 0.182,0.4 0.406,0.4 0.169,0 0.312,-0.08 0.373,-0.224 l 0.185,0.389 c 0.04,0.076 0.093,0.215 0.093,0.307 0,0.309 -0.255,0.559 -0.567,0.559 -0.248,0 -0.458,-0.156 -0.536,-0.373 0,0 0.217,0.455 0.217,1.001 C 0.527,-0.587 0,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path2866",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#211915",
      strokeWidth: 0.126,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 36.826,21.536 h -1.65 v 0.41 h 1.65 z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.333,44.2453)",
    id: "g2868"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2870",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 -0.11,-0.007 c -0.004,-0.014 -0.055,-0.095 -0.1,-0.14 -0.098,-0.096 -0.243,-0.108 -0.326,-0.026 -0.043,0.041 -0.059,0.1 -0.052,0.16 -0.066,-0.033 -0.133,-0.033 -0.193,0.002 -0.1,0.059 -0.124,0.201 -0.053,0.317 0.012,0.021 0.023,0.053 0.041,0.069 L -0.803,0.502 -0.935,0.47 -0.973,0.394 C -1.056,0.298 -1.177,0.272 -1.239,0.329 -1.268,0.357 -1.29,0.43 -1.288,0.433 -1.287,0.431 -1.32,0.399 -1.354,0.39 -1.558,0.338 -1.637,0.805 -1.645,0.924 L -1.71,0.828 c 0,0 0.059,-0.28 0.029,-0.515 -0.029,-0.234 -0.109,-0.472 -0.109,-0.472 0.283,-0.077 0.706,-0.316 1.127,-0.653 0.421,-0.336 0.754,-0.699 0.89,-0.955 0,0 0.218,0.125 0.444,0.203 0.228,0.078 0.517,0.078 0.517,0.078 l 0.083,0.084 c -0.12,-0.018 -0.6,-0.038 -0.591,0.169 0.001,0.035 0.027,0.072 0.029,0.073 -0.001,-0.003 -0.079,0.003 -0.113,0.026 -0.07,0.047 -0.069,0.17 0.008,0.269 l 0.067,0.053 0.006,0.134 -0.128,-0.018 C 0.536,-0.715 0.507,-0.733 0.488,-0.75 0.388,-0.842 0.243,-0.849 0.164,-0.765 0.115,-0.714 0.102,-0.649 0.121,-0.579 0.063,-0.598 0,-0.594 -0.05,-0.561 c -0.097,0.062 -0.117,0.205 -0.041,0.318 0.036,0.055 0.105,0.119 0.119,0.127 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.333,44.2453)",
    id: "g2872"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2874",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 -0.11,-0.007 c -0.004,-0.014 -0.055,-0.095 -0.1,-0.14 -0.098,-0.096 -0.243,-0.108 -0.326,-0.026 -0.043,0.041 -0.059,0.1 -0.052,0.16 -0.066,-0.033 -0.133,-0.033 -0.193,0.002 -0.1,0.059 -0.124,0.201 -0.053,0.317 0.012,0.021 0.023,0.053 0.041,0.069 L -0.803,0.502 -0.935,0.47 -0.973,0.394 C -1.056,0.298 -1.177,0.272 -1.239,0.329 -1.268,0.357 -1.29,0.43 -1.288,0.433 -1.287,0.431 -1.32,0.399 -1.354,0.39 -1.558,0.338 -1.637,0.805 -1.645,0.924 L -1.71,0.828 c 0,0 0.059,-0.28 0.029,-0.515 -0.029,-0.234 -0.109,-0.472 -0.109,-0.472 0.283,-0.077 0.706,-0.316 1.127,-0.653 0.421,-0.336 0.754,-0.699 0.89,-0.955 0,0 0.218,0.125 0.444,0.203 0.228,0.078 0.517,0.078 0.517,0.078 l 0.083,0.084 c -0.12,-0.018 -0.6,-0.038 -0.591,0.169 0.001,0.035 0.027,0.072 0.029,0.073 -0.001,-0.003 -0.079,0.003 -0.113,0.026 -0.07,0.047 -0.069,0.17 0.008,0.269 l 0.067,0.053 0.006,0.134 -0.128,-0.018 C 0.536,-0.715 0.507,-0.733 0.488,-0.75 0.388,-0.842 0.243,-0.849 0.164,-0.765 0.115,-0.714 0.102,-0.649 0.121,-0.579 0.063,-0.598 0,-0.594 -0.05,-0.561 c -0.097,0.062 -0.117,0.205 -0.041,0.318 0.036,0.055 0.105,0.119 0.119,0.127 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.4805,43.9753)",
    id: "g2876"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2878",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0.019,0.022 0.058,0.021 0.087,-0.002 0.117,-0.026 0.127,-0.064 0.108,-0.086 0.089,-0.109 0.05,-0.108 0.021,-0.084 -0.01,-0.061 -0.019,-0.023 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.4805,43.9753)",
    id: "g2880"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2882",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.018,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0.019,0.022 0.058,0.021 0.087,-0.002 0.117,-0.026 0.127,-0.064 0.108,-0.086 0.089,-0.109 0.05,-0.108 0.021,-0.084 -0.01,-0.061 -0.019,-0.023 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.8394,43.6603)",
    id: "g2884"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2886",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 -0.123,0.098 c -0.023,0.019 -0.031,0.048 -0.016,0.065 0.014,0.018 0.044,0.017 0.067,-0.001 L 0.052,0.063 0.178,-0.038 C 0.2,-0.056 0.207,-0.084 0.193,-0.102 0.179,-0.119 0.147,-0.118 0.125,-0.1 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.8394,43.6603)",
    id: "g2888"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2890",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.018,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 -0.123,0.098 c -0.023,0.019 -0.031,0.048 -0.016,0.065 0.014,0.018 0.044,0.017 0.067,-0.001 L 0.052,0.063 0.178,-0.038 C 0.2,-0.056 0.207,-0.084 0.193,-0.102 0.179,-0.119 0.147,-0.118 0.125,-0.1 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.1778,44.1315)",
    id: "g2892"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2894",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 -0.097,0.06 c -0.025,0.015 -0.036,0.044 -0.027,0.065 0.011,0.019 0.04,0.023 0.064,0.008 L 0.039,0.073 0.138,0.012 C 0.163,-0.004 0.174,-0.032 0.164,-0.052 0.153,-0.072 0.124,-0.076 0.099,-0.061 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.1778,44.1315)",
    id: "g2896"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2898",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.018,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 -0.097,0.06 c -0.025,0.015 -0.036,0.044 -0.027,0.065 0.011,0.019 0.04,0.023 0.064,0.008 L 0.039,0.073 0.138,0.012 C 0.163,-0.004 0.174,-0.032 0.164,-0.052 0.153,-0.072 0.124,-0.076 0.099,-0.061 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.7867,44.4113)",
    id: "g2900"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2902",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0.019,0.023 0.058,0.022 0.088,-0.001 0.118,-0.025 0.127,-0.063 0.108,-0.086 0.089,-0.109 0.05,-0.108 0.021,-0.084 -0.009,-0.061 -0.019,-0.023 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.7867,44.4113)",
    id: "g2904"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2906",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.018,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0.019,0.023 0.058,0.022 0.088,-0.001 0.118,-0.025 0.127,-0.063 0.108,-0.086 0.089,-0.109 0.05,-0.108 0.021,-0.084 -0.009,-0.061 -0.019,-0.023 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.2373,43.3708)",
    id: "g2908"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2910",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0.02,0.023 0.01,0.061 -0.02,0.084 -0.049,0.108 -0.088,0.109 -0.108,0.086 -0.126,0.063 -0.117,0.026 -0.087,0.001 -0.058,-0.022 -0.018,-0.023 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.2373,43.3708)",
    id: "g2912"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2914",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.018,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0.02,0.023 0.01,0.061 -0.02,0.084 -0.049,0.108 -0.088,0.109 -0.108,0.086 -0.126,0.063 -0.117,0.026 -0.087,0.001 -0.058,-0.022 -0.018,-0.023 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.4566,43.112)",
    id: "g2916"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2918",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 0.079,-0.082 C 0.1,-0.102 0.131,-0.108 0.149,-0.093 0.166,-0.079 0.164,-0.05 0.144,-0.03 L 0.063,0.052 -0.018,0.135 C -0.038,0.156 -0.069,0.161 -0.087,0.146 -0.105,0.132 -0.102,0.104 -0.082,0.083 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.4566,43.112)",
    id: "g2920"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2922",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.018,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 0.079,-0.082 C 0.1,-0.102 0.131,-0.108 0.149,-0.093 0.166,-0.079 0.164,-0.05 0.144,-0.03 L 0.063,0.052 -0.018,0.135 C -0.038,0.156 -0.069,0.161 -0.087,0.146 -0.105,0.132 -0.102,0.104 -0.082,0.083 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.8145,42.7932)",
    id: "g2924"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2926",
    style: {
      fill: "#211915",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0.02,0.023 0.01,0.061 -0.02,0.084 -0.049,0.108 -0.088,0.109 -0.108,0.086 -0.126,0.063 -0.118,0.025 -0.087,0.002 -0.057,-0.022 -0.018,-0.023 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.8145,42.7932)",
    id: "g2928"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2930",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.018,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0.02,0.023 0.01,0.061 -0.02,0.084 -0.049,0.108 -0.088,0.109 -0.108,0.086 -0.126,0.063 -0.118,0.025 -0.087,0.002 -0.057,-0.022 -0.018,-0.023 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.7735,45.173)",
    id: "g2932"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2934",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 -0.225,-0.006 -0.045,-0.344 0.024,-0.053 0.059,0.005 0.288,0.199 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.7735,45.173)",
    id: "g2936"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2938",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 -0.225,-0.006 -0.045,-0.344 0.024,-0.053 0.059,0.005 0.288,0.199 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.1641,44.9846)",
    id: "g2940"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2942",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 -0.005,-0.215 0.343,-0.259 0.397,-0.235 0.393,-0.177 0.189,0.105 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.1641,44.9846)",
    id: "g2944"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2946",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 -0.005,-0.215 0.343,-0.259 0.397,-0.235 0.393,-0.177 0.189,0.105 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.8853,44.5573)",
    id: "g2948"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2950",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 -0.187,-0.107 -0.389,0.175 -0.394,0.233 -0.34,0.256 0.009,0.213 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.8853,44.5573)",
    id: "g2952"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2954",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 -0.187,-0.107 -0.389,0.175 -0.394,0.233 -0.34,0.256 0.009,0.213 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.4336,44.8215)",
    id: "g2956"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2958",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0.031,0.051 0.098,0.067 0.15,0.037 0.202,0.006 0.218,-0.059 0.187,-0.11 0.156,-0.161 0.089,-0.177 0.038,-0.147 -0.013,-0.117 -0.03,-0.051 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.4336,44.8215)",
    id: "g2960"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2962",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0.031,0.051 0.098,0.067 0.15,0.037 0.202,0.006 0.218,-0.059 0.187,-0.11 0.156,-0.161 0.089,-0.177 0.038,-0.147 -0.013,-0.117 -0.03,-0.051 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.6172,45.176)",
    id: "g2964"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2966",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C -0.004,-0.002 -0.047,0.18 -0.095,0.282 -0.129,0.354 -0.244,0.45 -0.244,0.45 -0.233,0.475 -0.088,0.526 0.085,0.413 0.227,0.291 0.073,0.071 0.073,0.071 0.073,0.071 0.037,0.018 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.6172,45.176)",
    id: "g2968"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2970",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C -0.004,-0.002 -0.047,0.18 -0.095,0.282 -0.129,0.354 -0.244,0.45 -0.244,0.45 -0.233,0.475 -0.088,0.526 0.085,0.413 0.227,0.291 0.073,0.071 0.073,0.071 0.073,0.071 0.037,0.018 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.0103,45.0524)",
    id: "g2972"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2974",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 -0.159,-0.144 -0.258,0.235 0.022,0.033 0.009,0.057 0.35,0.029 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.0103,45.0524)",
    id: "g2976"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2978",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 -0.159,-0.144 -0.258,0.235 0.022,0.033 0.009,0.057 0.35,0.029 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.5718,45.1984)",
    id: "g2980"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2982",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0.02,0.058 0.068,0.093 0.109,0.08 0.149,0.066 0.166,0.008 0.146,-0.049 0.126,-0.107 0.077,-0.143 0.036,-0.128 -0.004,-0.115 -0.021,-0.058 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.5718,45.1984)",
    id: "g2984"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2986",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0.02,0.058 0.068,0.093 0.109,0.08 0.149,0.066 0.166,0.008 0.146,-0.049 0.126,-0.107 0.077,-0.143 0.036,-0.128 -0.004,-0.115 -0.021,-0.058 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.6314,44.6144)",
    id: "g2988"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2990",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 -0.224,0.025 -0.093,-0.334 0.016,-0.057 0.06,-0.003 0.312,0.159 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.6314,44.6144)",
    id: "g2992"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2994",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 -0.224,0.025 -0.093,-0.334 0.016,-0.057 0.06,-0.003 0.312,0.159 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.0015,44.5119)",
    id: "g2996"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2998",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 -0.036,-0.212 0.303,-0.304 0.36,-0.288 0.363,-0.23 0.203,0.079 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.0015,44.5119)",
    id: "g3000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3002",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 -0.036,-0.212 0.303,-0.304 0.36,-0.288 0.363,-0.23 0.203,0.079 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.6558,43.9894)",
    id: "g3004"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3006",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 -0.2,-0.081 -0.161,0.308 0.003,0.058 0.057,0.016 0.34,-0.091 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.6558,43.9894)",
    id: "g3008"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3010",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 -0.2,-0.081 -0.161,0.308 0.003,0.058 0.057,0.016 0.34,-0.091 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.2461,44.3132)",
    id: "g3012"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3014",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0.038,0.046 0.106,0.053 0.153,0.016 0.2,-0.021 0.207,-0.089 0.169,-0.135 0.131,-0.181 0.063,-0.188 0.016,-0.15 -0.03,-0.113 -0.038,-0.046 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.2461,44.3132)",
    id: "g3016"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3018",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0.038,0.046 0.106,0.053 0.153,0.016 0.2,-0.021 0.207,-0.089 0.169,-0.135 0.131,-0.181 0.063,-0.188 0.016,-0.15 -0.03,-0.113 -0.038,-0.046 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.3814,43.8893)",
    id: "g3020"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3022",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 0.041,-0.218 -0.331,-0.115 -0.059,0.012 -0.007,0.058 0.138,0.319 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.3814,43.8893)",
    id: "g3024"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3026",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 0.041,-0.218 -0.331,-0.115 -0.059,0.012 -0.007,0.058 0.138,0.319 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.3218,43.2629)",
    id: "g3028"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3030",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 -0.213,-0.05 -0.116,0.327 0.012,0.057 0.059,0.008 0.323,-0.137 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.3218,43.2629)",
    id: "g3032"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3034",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 -0.213,-0.05 -0.116,0.327 0.012,0.057 0.059,0.008 0.323,-0.137 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.7476,43.8698)",
    id: "g3036"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3038",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m 0,0 -0.069,-0.202 0.323,-0.137 0.059,0.007 0.012,0.058 -0.116,0.327 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.7476,43.8698)",
    id: "g3040"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3042",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 -0.069,-0.202 0.323,-0.137 0.059,0.007 0.012,0.058 -0.116,0.327 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.1035,43.4899)",
    id: "g3044"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3046",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0.043,0.041 0.046,0.108 0.005,0.151 -0.035,0.194 -0.104,0.197 -0.148,0.157 -0.192,0.116 -0.195,0.048 -0.154,0.005 -0.113,-0.038 -0.044,-0.041 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.1035,43.4899)",
    id: "g3048"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3050",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0.043,0.041 0.046,0.108 0.005,0.151 -0.035,0.194 -0.104,0.197 -0.148,0.157 -0.192,0.116 -0.195,0.048 -0.154,0.005 -0.113,-0.038 -0.044,-0.041 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.6245,42.7761)",
    id: "g3052"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3054",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C -0.001,-0.005 0.19,-0.009 0.3,-0.034 0.378,-0.051 0.498,-0.141 0.498,-0.141 0.521,-0.126 0.541,0.024 0.393,0.168 0.242,0.279 0.057,0.085 0.057,0.085 0.057,0.085 0.011,0.039 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.6245,42.7761)",
    id: "g3056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3058",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C -0.001,-0.005 0.19,-0.009 0.3,-0.034 0.378,-0.051 0.498,-0.141 0.498,-0.141 0.521,-0.126 0.541,0.024 0.393,0.168 0.242,0.279 0.057,0.085 0.057,0.085 0.057,0.085 0.011,0.039 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.4209,43.1296)",
    id: "g3060"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3062",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 -0.11,-0.184 0.177,-0.385 0.213,-0.353 0.26,-0.335 0.216,0.009 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.4209,43.1296)",
    id: "g3064"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3066",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 -0.11,-0.184 0.177,-0.385 0.213,-0.353 0.26,-0.335 0.216,0.009 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.6573,42.7365)",
    id: "g3068"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3070",
    style: {
      fill: "#a07e00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M 0,0 C 0.052,0.031 0.079,0.086 0.056,0.122 0.034,0.158 -0.027,0.162 -0.08,0.13 -0.132,0.099 -0.158,0.044 -0.136,0.008 -0.114,-0.027 -0.053,-0.032 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.6573,42.7365)",
    id: "g3072"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3074",
    style: {
      fill: "none",
      stroke: "#211915",
      strokeWidth: 0.097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 3.86400008,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0.052,0.031 0.079,0.086 0.056,0.122 0.034,0.158 -0.027,0.162 -0.08,0.13 -0.132,0.099 -0.158,0.044 -0.136,0.008 -0.114,-0.027 -0.053,-0.032 0,0 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoDigitalLogo);
export default __webpack_public_path__ + "static/media/go-digital-logo.23d1bb8565fbe427bdca0a19914f6f0d.svg";
export { ForwardRef as ReactComponent };